var external_file_city_relations = [
  {
      "CityCode": "ALV",
      "ProvinceId": null,
      "CountryCode": "AD"
  },
  {
      "CityCode": "AAN",
      "ProvinceId": null,
      "CountryCode": "AE"
  },
  {
      "CityCode": "AUH",
      "ProvinceId": null,
      "CountryCode": "AE"
  },
  {
      "CityCode": "RKT",
      "ProvinceId": null,
      "CountryCode": "AE"
  },
  {
      "CityCode": "SHJ",
      "ProvinceId": null,
      "CountryCode": "AE"
  },
  {
      "CityCode": "DXB",
      "ProvinceId": null,
      "CountryCode": "AE"
  },
  {
      "CityCode": "FJR",
      "ProvinceId": null,
      "CountryCode": "AE"
  },
  {
      "CityCode": "ANU",
      "ProvinceId": null,
      "CountryCode": "AG"
  },
  {
      "CityCode": "AXA",
      "ProvinceId": null,
      "CountryCode": "AI"
  },
  {
      "CityCode": "TIA",
      "ProvinceId": null,
      "CountryCode": "AL"
  },
  {
      "CityCode": "EVN",
      "ProvinceId": null,
      "CountryCode": "AM"
  },
  {
      "CityCode": "EUX",
      "ProvinceId": null,
      "CountryCode": "AN"
  },
  {
      "CityCode": "CUR",
      "ProvinceId": null,
      "CountryCode": "AN"
  },
  {
      "CityCode": "BON",
      "ProvinceId": null,
      "CountryCode": "AN"
  },
  {
      "CityCode": "SAB",
      "ProvinceId": null,
      "CountryCode": "AN"
  },
  {
      "CityCode": "PH1",
      "ProvinceId": null,
      "CountryCode": "AN"
  },
  {
      "CityCode": "SXM",
      "ProvinceId": null,
      "CountryCode": "AN"
  },
  {
      "CityCode": "LAD",
      "ProvinceId": null,
      "CountryCode": "AO"
  },
  {
      "CityCode": "PPG",
      "ProvinceId": null,
      "CountryCode": "AS"
  },
  {
      "CityCode": "SZG",
      "ProvinceId": null,
      "CountryCode": "AT"
  },
  {
      "CityCode": "VIE",
      "ProvinceId": null,
      "CountryCode": "AT"
  },
  {
      "CityCode": "GRZ",
      "ProvinceId": null,
      "CountryCode": "AT"
  },
  {
      "CityCode": "INN",
      "ProvinceId": null,
      "CountryCode": "AT"
  },
  {
      "CityCode": "LNZ",
      "ProvinceId": null,
      "CountryCode": "AT"
  },
  {
      "CityCode": "KLU",
      "ProvinceId": null,
      "CountryCode": "AT"
  },
  {
      "CityCode": "KNS",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "KNX",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "KPS",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "JAB",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "LNO",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "LVO",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "MEL",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "MGB",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "MGV",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "MMG",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "MMM",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "MNQ",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "MTL",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "NGA",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "NLK",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "RMA",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "QLE",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "SGO",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "SHT",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "SNH",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "SOI",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "NOA",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "NRA",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "OLP",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "PBO",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "PKE",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "PLO",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "PPI",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "PPP",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "PQQ",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "BME",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "BNE",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "BNK",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "BUY",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "BWQ",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "BWT",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "CBR",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "CDA",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "CED",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "CES",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "CMQ",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "CSI",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "CTL",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "CUG",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "BLT",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "ABM",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "ABX",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "ALH",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "ASP",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "DDI",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "DGE",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "DKI",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "ECH",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "EXM",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "FOT",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "GLI",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "GLT",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "GUH",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "GYP",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "HAP",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "HIS",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "HLS",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "HVB",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "IVR",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "ADL",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "LOC",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "TCA",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "TCW",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "TMW",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "TWB",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "WAZ",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "WYA",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "WYN",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "XCO",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "LHG",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "LRE",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "LDH",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "LEA",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "LER",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "KGC",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "KGI",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "KTA",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "KTR",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "LST",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "LSY",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "MBH",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "MBW",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "MCY",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "MHU",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "MIM",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "MKR",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "MKY",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "MQL",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "MQZ",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "ISA",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "JFM",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "JHQ",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "KBJ",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "KCE",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "HID",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "HTI",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "HBA",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "GOO",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "GOV",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "GET",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "GEX",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "GFF",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "GFN",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "AYQ",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "AYR",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "AVV",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "BDB",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "ARM",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "BHQ",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "BHS",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "BOX",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "BQB",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "BRK",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "BRT",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "BSJ",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "BWU",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "CAZ",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "EMD",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "EPR",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "DNQ",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "DOX",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "DPO",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "DRB",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "DRW",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "CFS",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "CNB",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "CNJ",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "CNS",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "COJ",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "CPD",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "CVQ",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "CWT",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "DBO",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "DBY",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "USL",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "UEE",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "UIR",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "ULP",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "WEI",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "WEW",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "WGA",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "WGE",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "WGT",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "WHL",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "WMB",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "WNR",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "WOL",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "WSY",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "YNN",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "ZBL",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "ZNE",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "SXE",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "SYD",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "TGN",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "SRN",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "SWH",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "TIS",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "THG",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "TPR",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "TRO",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "TSV",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "RMK",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "ROK",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "RTS",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "SIX",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "PTI",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "PTJ",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "PUG",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "PER",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "PHE",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "MRZ",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "MYA",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "NAA",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "NSA",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "NSM",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "NSO",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "NTL",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "NUR",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "NYN",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "OAG",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "OOL",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "OOM",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "ORS",
      "ProvinceId": null,
      "CountryCode": "AU"
  },
  {
      "CityCode": "BAK",
      "ProvinceId": null,
      "CountryCode": "AZ"
  },
  {
      "CityCode": "SJJ",
      "ProvinceId": null,
      "CountryCode": "BA"
  },
  {
      "CityCode": "TZL",
      "ProvinceId": null,
      "CountryCode": "BA"
  },
  {
      "CityCode": "BNX",
      "ProvinceId": null,
      "CountryCode": "BA"
  },
  {
      "CityCode": "OMO",
      "ProvinceId": null,
      "CountryCode": "BA"
  },
  {
      "CityCode": "BGI",
      "ProvinceId": null,
      "CountryCode": "BB"
  },
  {
      "CityCode": "ZYL",
      "ProvinceId": null,
      "CountryCode": "BD"
  },
  {
      "CityCode": "DAC",
      "ProvinceId": null,
      "CountryCode": "BD"
  },
  {
      "CityCode": "CGP",
      "ProvinceId": null,
      "CountryCode": "BD"
  },
  {
      "CityCode": "ANR",
      "ProvinceId": null,
      "CountryCode": "BE"
  },
  {
      "CityCode": "BRU",
      "ProvinceId": null,
      "CountryCode": "BE"
  },
  {
      "CityCode": "KJK",
      "ProvinceId": null,
      "CountryCode": "BE"
  },
  {
      "CityCode": "LGG",
      "ProvinceId": null,
      "CountryCode": "BE"
  },
  {
      "CityCode": "OST",
      "ProvinceId": null,
      "CountryCode": "BE"
  },
  {
      "CityCode": "ZGK",
      "ProvinceId": null,
      "CountryCode": "BE"
  },
  {
      "CityCode": "OUA",
      "ProvinceId": null,
      "CountryCode": "BF"
  },
  {
      "CityCode": "VAR",
      "ProvinceId": null,
      "CountryCode": "BG"
  },
  {
      "CityCode": "BOJ",
      "ProvinceId": null,
      "CountryCode": "BG"
  },
  {
      "CityCode": "SOF",
      "ProvinceId": null,
      "CountryCode": "BG"
  },
  {
      "CityCode": "BAH",
      "ProvinceId": null,
      "CountryCode": "BH"
  },
  {
      "CityCode": "BJM",
      "ProvinceId": null,
      "CountryCode": "BI"
  },
  {
      "CityCode": "COO",
      "ProvinceId": null,
      "CountryCode": "BJ"
  },
  {
      "CityCode": "BDA",
      "ProvinceId": null,
      "CountryCode": "BM"
  },
  {
      "CityCode": "KUB",
      "ProvinceId": null,
      "CountryCode": "BN"
  },
  {
      "CityCode": "BWN",
      "ProvinceId": null,
      "CountryCode": "BN"
  },
  {
      "CityCode": "TDD",
      "ProvinceId": null,
      "CountryCode": "BO"
  },
  {
      "CityCode": "MHW",
      "ProvinceId": null,
      "CountryCode": "BO"
  },
  {
      "CityCode": "LPB",
      "ProvinceId": null,
      "CountryCode": "BO"
  },
  {
      "CityCode": "CIJ",
      "ProvinceId": null,
      "CountryCode": "BO"
  },
  {
      "CityCode": "CCA",
      "ProvinceId": null,
      "CountryCode": "BO"
  },
  {
      "CityCode": "CAM",
      "ProvinceId": null,
      "CountryCode": "BO"
  },
  {
      "CityCode": "CBB",
      "ProvinceId": null,
      "CountryCode": "BO"
  },
  {
      "CityCode": "ORU",
      "ProvinceId": null,
      "CountryCode": "BO"
  },
  {
      "CityCode": "POI",
      "ProvinceId": null,
      "CountryCode": "BO"
  },
  {
      "CityCode": "GYA",
      "ProvinceId": null,
      "CountryCode": "BO"
  },
  {
      "CityCode": "MQK",
      "ProvinceId": null,
      "CountryCode": "BO"
  },
  {
      "CityCode": "PSZ",
      "ProvinceId": null,
      "CountryCode": "BO"
  },
  {
      "CityCode": "TJA",
      "ProvinceId": null,
      "CountryCode": "BO"
  },
  {
      "CityCode": "SRZ",
      "ProvinceId": null,
      "CountryCode": "BO"
  },
  {
      "CityCode": "SRE",
      "ProvinceId": null,
      "CountryCode": "BO"
  },
  {
      "CityCode": "SNG",
      "ProvinceId": null,
      "CountryCode": "BO"
  },
  {
      "CityCode": "BYC",
      "ProvinceId": null,
      "CountryCode": "BO"
  },
  {
      "CityCode": "RIB",
      "ProvinceId": null,
      "CountryCode": "BO"
  },
  {
      "CityCode": "UYU",
      "ProvinceId": null,
      "CountryCode": "BO"
  },
  {
      "CityCode": "RBQ",
      "ProvinceId": null,
      "CountryCode": "BO"
  },
  {
      "CityCode": "BR1",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR2",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR3",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR4",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR5",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR6",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR7",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR8",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR9",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "UMU",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "UNA",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "URG",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "UDI",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "VIX",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "ZBW",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "SSA",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "TFF",
      "ProvinceId": "BR_AM",
      "CountryCode": "BR"
  },
  {
      "CityCode": "TOW",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "THE",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "SJK",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "SJP",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "ROO",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "RBR",
      "ProvinceId": "BR_AC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "REC",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "PT1",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "PTO",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "PNZ",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "POA",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "PPB",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "PVH",
      "ProvinceId": "BR_RO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "RAO",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "PHB",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "PMW",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "PNG",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "PET",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "PFB",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "NAT",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "NVT",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "OAL",
      "ProvinceId": "BR_RO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "B18",
      "ProvinceId": null,
      "CountryCode": "BR"
  },
  {
      "CityCode": "FEN",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "PP2",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "CFB",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "CGB",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "CGR",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "CPQ",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "CPV",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "CZS",
      "ProvinceId": "BR_AC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "CXJ",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "CWB",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "CAC",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "CB1",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "CAU",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "CAW",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BSB",
      "ProvinceId": "BR_DF",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BZC",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BPS",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BRA",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BHZ",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BGV",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "JTC",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BB1",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "APS",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "ARU",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "AR1",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "LEC",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "LDB",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "MII",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "MCZ",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "MCP",
      "ProvinceId": "BR_AP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "MAO",
      "ProvinceId": "BR_AM",
      "CountryCode": "BR"
  },
  {
      "CityCode": "GCV",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "FLB",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "FLN",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "B15",
      "ProvinceId": null,
      "CountryCode": "BR"
  },
  {
      "CityCode": "HRZ",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "JDO",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "IPN",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "JC1",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "JDF",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "IMP",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "IOS",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "B20",
      "ProvinceId": null,
      "CountryCode": "BR"
  },
  {
      "CityCode": "AFL",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_10150",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_10151",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_10152",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_10153",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_10154",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_10155",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_10156",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_10157",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_10159",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_10161",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_10164",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "AI1",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "CLV",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "IUF",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "GM1",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7530",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4857",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8896",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1156",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "FSG",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1006",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_10089",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1078",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1114",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_114",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1145",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1158",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1190",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1208",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1218",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1247",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1284",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1308",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_37",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1348",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4874",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_138",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1443",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8956",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1486",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_42",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4877",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1577",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_171",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1722",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1746",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1816",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4881",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1844",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1847",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1848",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1861",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1879",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1925",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_200",
      "ProvinceId": "BR_AM",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2028",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2037",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2060",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2069",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2096",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2125",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2204",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2209",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2234",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2282",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2298",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BYO",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_432",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_232",
      "ProvinceId": "BR_AM",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4577",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_233",
      "ProvinceId": "BR_AM",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5182",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2395",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2399",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2585",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_261",
      "ProvinceId": "BR_AM",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_58",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2651",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7149",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2695",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2704",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2733",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2762",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "B05",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2834",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2842",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2918",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2971",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2976",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2980",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2990",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_30",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3036",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3047",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3104",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3128",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3164",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3234",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3236",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3245",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3275",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3277",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3279",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3327",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3334",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3360",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1278",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_342",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3460",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3480",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3486",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2431",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3531",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3532",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3547",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3549",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3654",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3724",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3726",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3857",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3872",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4921",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3892",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3986",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_537",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4017",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4019",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4020",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4035",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4043",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_405",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4081",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4091",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_575",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4163",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4197",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4263",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4300",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4331",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4389",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4416",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4437",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4451",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9144",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4473",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4493",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4495",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4498",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4539",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6115",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_465",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9162",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_472",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4728",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_473",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4730",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_474",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4762",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9182",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4870",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9214",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5017",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_684",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8507",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_745",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5189",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "B11",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5259",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5264",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5285",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5293",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5302",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2347",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3332",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7823",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9874",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5467",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9369",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5774",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5780",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5783",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5789",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_579",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5793",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_582",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5894",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5906",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5911",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5914",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5959",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5964",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6094",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6131",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6135",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6212",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6321",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "B03",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9432",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6420",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6445",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3507",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6598",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6401",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6656",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6796",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_683",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6832",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5379",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6862",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6875",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6881",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6912",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6941",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6943",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6951",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6955",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6966",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5018",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6993",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6994",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5384",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7023",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7031",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7035",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7039",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7041",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7042",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7068",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7069",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7078",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7085",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7102",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7107",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_711",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7113",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7121",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "B23",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7167",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7174",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7222",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3632",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7271",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7275",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6471",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8625",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7300",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9527",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_731",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7358",
      "ProvinceId": "BR_RO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7396",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_749",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6501",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7517",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7533",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7539",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7650",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7675",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7697",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7710",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7719",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7730",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7733",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7750",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7768",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7771",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7850",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_789",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7910",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8066",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8079",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8090",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8101",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8146",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4459",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7040",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9566",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8242",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8245",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_827",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8288",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8357",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8380",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8390",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8391",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8403",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8456",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8461",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8463",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8465",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8468",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8486",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8488",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8511",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8520",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8525",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8528",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8543",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2562",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5062",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6578",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_994",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8589",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8602",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2563",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8607",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3749",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8614",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8622",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5063",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_995",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8650",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7256",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8684",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8692",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8700",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8735",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8742",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8763",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5073",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8774",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8780",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "B16",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8804",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8687",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9643",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8859",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8861",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8883",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8912",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8926",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8933",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8954",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3827",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8962",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8967",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8977",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8989",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8992",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8998",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9004",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9005",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9007",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1682",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9043",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9046",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9087",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_909",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_91",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9136",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9146",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9177",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9183",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9189",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9201",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9216",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9237",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9239",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9244",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9254",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9260",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9261",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9265",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9267",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9273",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9283",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9285",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9295",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9317",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9319",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9321",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9338",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9354",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9355",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9366",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_172",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9370",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9371",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9374",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9376",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9673",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9396",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9415",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9425",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9434",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9435",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7280",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9447",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9678",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9464",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9477",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_948",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9480",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9483",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9485",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9493",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9500",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9501",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6709",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9518",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9531",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9533",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9549",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5109",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9686",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9587",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9622",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9632",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9636",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9640",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9642",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9671",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9684",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9693",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9707",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9726",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9748",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9756",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9768",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9783",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9789",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7298",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4026",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_992",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9948",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1102",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "B06",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4511",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5726",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "B12",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_188",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4082",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "B21",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7308",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2044",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "PG8",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "RQR",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_10146",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_10147",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_10148",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_10149",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "TBT",
      "ProvinceId": "BR_AM",
      "CountryCode": "BR"
  },
  {
      "CityCode": "TEC",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "STM",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "UBA",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "TMT",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "TUR",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "VAG",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "VDC",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "XAP",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "CCM",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BVB",
      "ProvinceId": "BR_RR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BVH",
      "ProvinceId": "BR_RO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BNU",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "CMG",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "CS1",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "CKS",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "CDI",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "ATM",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "AUX",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BEL",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "AC1",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "AJU",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "AAG",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "ITP",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "IT1",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "IG1",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "IGU",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "GYN",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "GVR",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "GJ1",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "FOR",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "SOD",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "SLZ",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "QNT",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "QHV",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "QIG",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "RIA",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "RIG",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "RIO",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "RWS",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "SAO",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "SA1",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "OIA",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "PS1",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "PMG",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "MVF",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "MO1",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "MOC",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "MG1",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "MGF",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "MEU",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "MEA",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "MA1",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "MAB",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "LAJ",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "JOI",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "JPA",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "JPR",
      "ProvinceId": "BR_RO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "FPO",
      "ProvinceId": null,
      "CountryCode": "BS"
  },
  {
      "CityCode": "GGT",
      "ProvinceId": null,
      "CountryCode": "BS"
  },
  {
      "CityCode": "GHB",
      "ProvinceId": null,
      "CountryCode": "BS"
  },
  {
      "CityCode": "ATC",
      "ProvinceId": null,
      "CountryCode": "BS"
  },
  {
      "CityCode": "TZN",
      "ProvinceId": null,
      "CountryCode": "BS"
  },
  {
      "CityCode": "TCB",
      "ProvinceId": null,
      "CountryCode": "BS"
  },
  {
      "CityCode": "ZSA",
      "ProvinceId": null,
      "CountryCode": "BS"
  },
  {
      "CityCode": "HBI",
      "ProvinceId": null,
      "CountryCode": "BS"
  },
  {
      "CityCode": "MHH",
      "ProvinceId": null,
      "CountryCode": "BS"
  },
  {
      "CityCode": "ASD",
      "ProvinceId": null,
      "CountryCode": "BS"
  },
  {
      "CityCode": "BIM",
      "ProvinceId": null,
      "CountryCode": "BS"
  },
  {
      "CityCode": "ELH",
      "ProvinceId": null,
      "CountryCode": "BS"
  },
  {
      "CityCode": "NAS",
      "ProvinceId": null,
      "CountryCode": "BS"
  },
  {
      "CityCode": "RSD",
      "ProvinceId": null,
      "CountryCode": "BS"
  },
  {
      "CityCode": "BBK",
      "ProvinceId": null,
      "CountryCode": "BW"
  },
  {
      "CityCode": "GBE",
      "ProvinceId": null,
      "CountryCode": "BW"
  },
  {
      "CityCode": "FRW",
      "ProvinceId": null,
      "CountryCode": "BW"
  },
  {
      "CityCode": "MUB",
      "ProvinceId": null,
      "CountryCode": "BW"
  },
  {
      "CityCode": "PKW",
      "ProvinceId": null,
      "CountryCode": "BW"
  },
  {
      "CityCode": "MVQ",
      "ProvinceId": null,
      "CountryCode": "BY"
  },
  {
      "CityCode": "GME",
      "ProvinceId": null,
      "CountryCode": "BY"
  },
  {
      "CityCode": "GNA",
      "ProvinceId": null,
      "CountryCode": "BY"
  },
  {
      "CityCode": "VTB",
      "ProvinceId": null,
      "CountryCode": "BY"
  },
  {
      "CityCode": "BQT",
      "ProvinceId": null,
      "CountryCode": "BY"
  },
  {
      "CityCode": "MSQ",
      "ProvinceId": null,
      "CountryCode": "BY"
  },
  {
      "CityCode": "SPR",
      "ProvinceId": null,
      "CountryCode": "BZ"
  },
  {
      "CityCode": "BZE",
      "ProvinceId": null,
      "CountryCode": "BZ"
  },
  {
      "CityCode": "PLJ",
      "ProvinceId": null,
      "CountryCode": "BZ"
  },
  {
      "CityCode": "PIW",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "QBC",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "LL1",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "FSP",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "XDL",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "XDM",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "XDO",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "XDU",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "XEE",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "XEH",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "XEJ",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "XEK",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "XEL",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "XEM",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "XFD",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "XFE",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "XFG",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "XFI",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "XFK",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "XFL",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "XFM",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "XFO",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "XFQ",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "XFS",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "XFV",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "XAW",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "XAZ",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "XBR",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "XBW",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "XCI",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "XCM",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "XGJ",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "XGK",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "XGW",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "XGY",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "XHM",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "XHS",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "XIA",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "XIB",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "XID",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "XIF",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "XII",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "XIM",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "XIO",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "XIP",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "XJL",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "XJQ",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "XKV",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "XLP",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "XLV",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "XLY",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "XLZ",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "XOK",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "XON",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "XPB",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "XPH",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "XPK",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "XPN",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "XPX",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "XQU",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "XRP",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "XTY",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "XVV",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YGK",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YGL",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YGP",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YGR",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YGV",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YGX",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YHB",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YHD",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YHE",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YHF",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YHG",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YHM",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YHN",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YHR",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YHS",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YHY",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YHZ",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YIB",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YIF",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YJA",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YJT",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YKA",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YKF",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YKL",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "ZQS",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YEY",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YFB",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YFC",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YFO",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "XWA",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "XWY",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "XZB",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "XZC",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "XZK",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YAG",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "ZSJ",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "ZTB",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YKQ",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YPM",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YPN",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YPQ",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YPR",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YPS",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YPW",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YPZ",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YQA",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YQB",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YQD",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YQG",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YQH",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YQI",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YQK",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YQL",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YQM",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YQN",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YQQ",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YQR",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YQS",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YQT",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YQU",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YQV",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YQW",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YQX",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YQY",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YQZ",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YRI",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YRJ",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YRL",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YXH",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YXJ",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YXK",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YXL",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YXP",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YXS",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YXT",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YXU",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YXX",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YXY",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YXZ",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YYB",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YYC",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YYD",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YYE",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YYF",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YYG",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YYI",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YYJ",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YYL",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YYN",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YYQ",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YYR",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YYT",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YYU",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YYW",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YYY",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YZA",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YZF",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YZP",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "DUQ",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "CFQ",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "ILF",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "SSQ",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "ZGS",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "ZHO",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "ZJN",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "ZKG",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "ZLT",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "ZBM",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "ZBF",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YOO",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YOP",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YOS",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YOD",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YOJ",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YUY",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YVB",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YVE",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YVG",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YVO",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YVP",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YVQ",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YVR",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YVZ",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YWG",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YWK",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YWL",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YWR",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YWS",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YXC",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YXE",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YZR",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YZT",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YZV",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YAM",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YND",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YLJ",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YLL",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YLQ",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YLW",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YMB",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YME",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YMG",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YMI",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YMM",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YMO",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YMQ",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YMT",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YNA",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YOW",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YPA",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YPB",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YPD",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YPE",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YPF",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YPG",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YPL",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YRQ",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YRT",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YSB",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YSC",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YSH",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YSJ",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YSL",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YSM",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YSN",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YSP",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YST",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YTA",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YTD",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YTE",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YTF",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YTH",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YTJ",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YTO",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YTR",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YTS",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YAY",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YAZ",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YBA",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YBB",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YBC",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YBD",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YBG",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YBL",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YBR",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YBX",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YCA",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YCB",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YCC",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YCD",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YCG",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YCH",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YCK",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YCL",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YCM",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YCN",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YCW",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YCY",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YCZ",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YDA",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YDF",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YDL",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YDN",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YDQ",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YEA",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YEK",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YEL",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YEN",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YET",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YEV",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YKU",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YKX",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "YLD",
      "ProvinceId": null,
      "CountryCode": "CA"
  },
  {
      "CityCode": "FIH",
      "ProvinceId": null,
      "CountryCode": "CD"
  },
  {
      "CityCode": "FBM",
      "ProvinceId": null,
      "CountryCode": "CD"
  },
  {
      "CityCode": "BGF",
      "ProvinceId": null,
      "CountryCode": "CF"
  },
  {
      "CityCode": "BZV",
      "ProvinceId": null,
      "CountryCode": "CG"
  },
  {
      "CityCode": "PNR",
      "ProvinceId": null,
      "CountryCode": "CG"
  },
  {
      "CityCode": "SIR",
      "ProvinceId": null,
      "CountryCode": "CH"
  },
  {
      "CityCode": "ZIN",
      "ProvinceId": null,
      "CountryCode": "CH"
  },
  {
      "CityCode": "ZJP",
      "ProvinceId": null,
      "CountryCode": "CH"
  },
  {
      "CityCode": "ZHB",
      "ProvinceId": null,
      "CountryCode": "CH"
  },
  {
      "CityCode": "ZDV",
      "ProvinceId": null,
      "CountryCode": "CH"
  },
  {
      "CityCode": "BSL",
      "ProvinceId": null,
      "CountryCode": "CH"
  },
  {
      "CityCode": "BRN",
      "ProvinceId": null,
      "CountryCode": "CH"
  },
  {
      "CityCode": "ZHK",
      "ProvinceId": null,
      "CountryCode": "CH"
  },
  {
      "CityCode": "ACH",
      "ProvinceId": null,
      "CountryCode": "CH"
  },
  {
      "CityCode": "GVA",
      "ProvinceId": null,
      "CountryCode": "CH"
  },
  {
      "CityCode": "LUG",
      "ProvinceId": null,
      "CountryCode": "CH"
  },
  {
      "CityCode": "QLJ",
      "ProvinceId": null,
      "CountryCode": "CH"
  },
  {
      "CityCode": "QLS",
      "ProvinceId": null,
      "CountryCode": "CH"
  },
  {
      "CityCode": "SMV",
      "ProvinceId": null,
      "CountryCode": "CH"
  },
  {
      "CityCode": "ZRH",
      "ProvinceId": null,
      "CountryCode": "CH"
  },
  {
      "CityCode": "S01",
      "ProvinceId": null,
      "CountryCode": "CH"
  },
  {
      "CityCode": "XMB",
      "ProvinceId": null,
      "CountryCode": "CI"
  },
  {
      "CityCode": "ABJ",
      "ProvinceId": null,
      "CountryCode": "CI"
  },
  {
      "CityCode": "ASK",
      "ProvinceId": null,
      "CountryCode": "CI"
  },
  {
      "CityCode": "AIT",
      "ProvinceId": null,
      "CountryCode": "CK"
  },
  {
      "CityCode": "RAR",
      "ProvinceId": null,
      "CountryCode": "CK"
  },
  {
      "CityCode": "PUQ",
      "ProvinceId": null,
      "CountryCode": "CL"
  },
  {
      "CityCode": "PNT",
      "ProvinceId": null,
      "CountryCode": "CL"
  },
  {
      "CityCode": "PTV",
      "ProvinceId": null,
      "CountryCode": "CL"
  },
  {
      "CityCode": "SP1",
      "ProvinceId": null,
      "CountryCode": "CL"
  },
  {
      "CityCode": "SCL",
      "ProvinceId": null,
      "CountryCode": "CL"
  },
  {
      "CityCode": "ZCO",
      "ProvinceId": null,
      "CountryCode": "CL"
  },
  {
      "CityCode": "ZOS",
      "ProvinceId": null,
      "CountryCode": "CL"
  },
  {
      "CityCode": "ZPC",
      "ProvinceId": null,
      "CountryCode": "CL"
  },
  {
      "CityCode": "ZAL",
      "ProvinceId": null,
      "CountryCode": "CL"
  },
  {
      "CityCode": "WPA",
      "ProvinceId": null,
      "CountryCode": "CL"
  },
  {
      "CityCode": "ANF",
      "ProvinceId": null,
      "CountryCode": "CL"
  },
  {
      "CityCode": "ARI",
      "ProvinceId": null,
      "CountryCode": "CL"
  },
  {
      "CityCode": "BBA",
      "ProvinceId": null,
      "CountryCode": "CL"
  },
  {
      "CityCode": "ESR",
      "ProvinceId": null,
      "CountryCode": "CL"
  },
  {
      "CityCode": "CJC",
      "ProvinceId": null,
      "CountryCode": "CL"
  },
  {
      "CityCode": "CPO",
      "ProvinceId": null,
      "CountryCode": "CL"
  },
  {
      "CityCode": "IPC",
      "ProvinceId": null,
      "CountryCode": "CL"
  },
  {
      "CityCode": "IQQ",
      "ProvinceId": null,
      "CountryCode": "CL"
  },
  {
      "CityCode": "LSQ",
      "ProvinceId": null,
      "CountryCode": "CL"
  },
  {
      "CityCode": "LSC",
      "ProvinceId": null,
      "CountryCode": "CL"
  },
  {
      "CityCode": "CCP",
      "ProvinceId": null,
      "CountryCode": "CL"
  },
  {
      "CityCode": "GXQ",
      "ProvinceId": null,
      "CountryCode": "CL"
  },
  {
      "CityCode": "PMC",
      "ProvinceId": null,
      "CountryCode": "CL"
  },
  {
      "CityCode": "KNA",
      "ProvinceId": null,
      "CountryCode": "CL"
  },
  {
      "CityCode": "VAP",
      "ProvinceId": null,
      "CountryCode": "CL"
  },
  {
      "CityCode": "WCA",
      "ProvinceId": null,
      "CountryCode": "CL"
  },
  {
      "CityCode": "WPR",
      "ProvinceId": null,
      "CountryCode": "CL"
  },
  {
      "CityCode": "WPU",
      "ProvinceId": null,
      "CountryCode": "CL"
  },
  {
      "CityCode": "KOB",
      "ProvinceId": null,
      "CountryCode": "CM"
  },
  {
      "CityCode": "MVR",
      "ProvinceId": null,
      "CountryCode": "CM"
  },
  {
      "CityCode": "NGE",
      "ProvinceId": null,
      "CountryCode": "CM"
  },
  {
      "CityCode": "DLA",
      "ProvinceId": null,
      "CountryCode": "CM"
  },
  {
      "CityCode": "YAO",
      "ProvinceId": null,
      "CountryCode": "CM"
  },
  {
      "CityCode": "YNT",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "YNJ",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "YTY",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "ZHA",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "WNZ",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "WUH",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "WEH",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "URC",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "SIA",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "SWA",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "SZO",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "SYX",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "SZV",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "SZX",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "TSN",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "MXZ",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "NDG",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "LIA",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "KWE",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "KWL",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "KHG",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "KHN",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "MDG",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "MIG",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "JHG",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "JIU",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "HHA",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "HRB",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "HET",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "HGH",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "HFE",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "FOC",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "CGO",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "CGQ",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "BJS",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "BHY",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "CAN",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "DLC",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "DGM",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "DIG",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "DYG",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "GYS",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "HAK",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "HYN",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "HNY",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "CKG",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "CTU",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "CSX",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "NNG",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "NKG",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "NGB",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "LZH",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "LYA",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "KMG",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "JNZ",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "LLF",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "LJG",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "SHE",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "SHP",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "SHA",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "BAR",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "CZX",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "XNN",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "XMN",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "XIY",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "TAO",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "TNA",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "ZUH",
      "ProvinceId": null,
      "CountryCode": "CN"
  },
  {
      "CityCode": "TME",
      "ProvinceId": "CO03",
      "CountryCode": "CO"
  },
  {
      "CityCode": "ACD",
      "ProvinceId": "CO11",
      "CountryCode": "CO"
  },
  {
      "CityCode": "ACR",
      "ProvinceId": "CO08",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CAQ",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "COG",
      "ProvinceId": "CO11",
      "CountryCode": "CO"
  },
  {
      "CityCode": "PCE",
      "ProvinceId": "CO31",
      "CountryCode": "CO"
  },
  {
      "CityCode": "EBG",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "GIR",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "GPI",
      "ProvinceId": "CO09",
      "CountryCode": "CO"
  },
  {
      "CityCode": "LCR",
      "ProvinceId": "CO01",
      "CountryCode": "CO"
  },
  {
      "CityCode": "MCJ",
      "ProvinceId": "CO17",
      "CountryCode": "CO"
  },
  {
      "CityCode": "MVP",
      "ProvinceId": "CO30",
      "CountryCode": "CO"
  },
  {
      "CityCode": "NQU",
      "ProvinceId": "CO11",
      "CountryCode": "CO"
  },
  {
      "CityCode": "OCV",
      "ProvinceId": "CO21",
      "CountryCode": "CO"
  },
  {
      "CityCode": "PDA",
      "ProvinceId": "CO15",
      "CountryCode": "CO"
  },
  {
      "CityCode": "PCR",
      "ProvinceId": "CO31",
      "CountryCode": "CO"
  },
  {
      "CityCode": "LQM",
      "ProvinceId": "CO22",
      "CountryCode": "CO"
  },
  {
      "CityCode": "OTU",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "SJE",
      "ProvinceId": "CO14",
      "CountryCode": "CO"
  },
  {
      "CityCode": "SVI",
      "ProvinceId": "CO08",
      "CountryCode": "CO"
  },
  {
      "CityCode": "RVE",
      "ProvinceId": "CO03",
      "CountryCode": "CO"
  },
  {
      "CityCode": "MTB",
      "ProvinceId": "CO12",
      "CountryCode": "CO"
  },
  {
      "CityCode": "ULQ",
      "ProvinceId": "CO29",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CTO",
      "ProvinceId": "CO09",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CRC",
      "ProvinceId": "CO29",
      "CountryCode": "CO"
  },
  {
      "CityCode": "IGO",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "RAV",
      "ProvinceId": "CO03",
      "CountryCode": "CO"
  },
  {
      "CityCode": "MGN",
      "ProvinceId": "CO35",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0050",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0185",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0199",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0401",
      "ProvinceId": "CO12",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0402",
      "ProvinceId": "CO12",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0423",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0424",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0436",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0463",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0471",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0476",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0511",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0567",
      "ProvinceId": "CO16",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0739",
      "ProvinceId": "CO23",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0742",
      "ProvinceId": "CO23",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0744",
      "ProvinceId": "CO23",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0745",
      "ProvinceId": "CO23",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0756",
      "ProvinceId": "CO24",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0762",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0853",
      "ProvinceId": "CO27",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0881",
      "ProvinceId": "CO28",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0958",
      "ProvinceId": "CO22",
      "CountryCode": "CO"
  },
  {
      "CityCode": "TLU",
      "ProvinceId": "CO27",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CVE",
      "ProvinceId": "CO27",
      "CountryCode": "CO"
  },
  {
      "CityCode": "SGL",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "LMC",
      "ProvinceId": "CO19",
      "CountryCode": "CO"
  },
  {
      "CityCode": "A10",
      "ProvinceId": null,
      "CountryCode": "CO"
  },
  {
      "CityCode": "MMX",
      "ProvinceId": null,
      "CountryCode": "CO"
  },
  {
      "CityCode": "GOG",
      "ProvinceId": null,
      "CountryCode": "CO"
  },
  {
      "CityCode": "GUS",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "TCO",
      "ProvinceId": "CO20",
      "CountryCode": "CO"
  },
  {
      "CityCode": "VUP",
      "ProvinceId": "CO10",
      "CountryCode": "CO"
  },
  {
      "CityCode": "VVC",
      "ProvinceId": "CO19",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_9003",
      "ProvinceId": null,
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_9004",
      "ProvinceId": null,
      "CountryCode": "CO"
  },
  {
      "CityCode": "MCR",
      "ProvinceId": null,
      "CountryCode": "CO"
  },
  {
      "CityCode": "C40",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C41",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C42",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C43",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "IBU",
      "ProvinceId": null,
      "CountryCode": "CO"
  },
  {
      "CityCode": "C48",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C45",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C46",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C47",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C49",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C50",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CB3",
      "ProvinceId": null,
      "CountryCode": "CO"
  },
  {
      "CityCode": "C44",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C53",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C52",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C54",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C55",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C51",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C71",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C72",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C73",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C74",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C76",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C77",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C67",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C75",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C79",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C80",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C81",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C82",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C83",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C84",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C85",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C97",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C98",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C99",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C100",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C112",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C113",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C104",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_877",
      "ProvinceId": "CO19",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO5",
      "ProvinceId": null,
      "CountryCode": "CO"
  },
  {
      "CityCode": "C101",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C102",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C103",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C151",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C114",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C115",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C116",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C117",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C118",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C119",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C130",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C131",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C132",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C133",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C134",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C135",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C136",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "HAY",
      "ProvinceId": "CO10",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C137",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO3",
      "ProvinceId": null,
      "CountryCode": "CO"
  },
  {
      "CityCode": "C138",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "ADZ",
      "ProvinceId": "CO25",
      "CountryCode": "CO"
  },
  {
      "CityCode": "SMR",
      "ProvinceId": "CO38",
      "CountryCode": "CO"
  },
  {
      "CityCode": "PPN",
      "ProvinceId": "CO09",
      "CountryCode": "CO"
  },
  {
      "CityCode": "PSO",
      "ProvinceId": "CO20",
      "CountryCode": "CO"
  },
  {
      "CityCode": "PAI",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "JUO",
      "ProvinceId": "CO11",
      "CountryCode": "CO"
  },
  {
      "CityCode": "MTR",
      "ProvinceId": "CO12",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CTG",
      "ProvinceId": "CO35",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CUC",
      "ProvinceId": "CO21",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CLO",
      "ProvinceId": "CO29",
      "CountryCode": "CO"
  },
  {
      "CityCode": "BOG",
      "ProvinceId": "CO34",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0904",
      "ProvinceId": "CO29",
      "CountryCode": "CO"
  },
  {
      "CityCode": "BUN",
      "ProvinceId": "CO29",
      "CountryCode": "CO"
  },
  {
      "CityCode": "BGA",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "IBE",
      "ProvinceId": "CO28",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_9001",
      "ProvinceId": "CO17",
      "CountryCode": "CO"
  },
  {
      "CityCode": "EYP",
      "ProvinceId": "CO32",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C108",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C109",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C105",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C106",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C107",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "BSC",
      "ProvinceId": "CO11",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C128",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C124",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C127",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C129",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_912",
      "ProvinceId": "CO35",
      "CountryCode": "CO"
  },
  {
      "CityCode": "BYA",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C122",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C120",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C121",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C123",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C125",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C126",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C69",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C70",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO29",
      "ProvinceId": "CO29",
      "CountryCode": "CO"
  },
  {
      "CityCode": "BAQ",
      "ProvinceId": "CO04",
      "CountryCode": "CO"
  },
  {
      "CityCode": "AXM",
      "ProvinceId": "CO23",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C56",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C57",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C58",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C59",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C60",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C61",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C62",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C63",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C65",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C66",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C68",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C64",
      "ProvinceId": null,
      "CountryCode": "CO"
  },
  {
      "CityCode": "LRI",
      "ProvinceId": "CO12",
      "CountryCode": "CO"
  },
  {
      "CityCode": "APO",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C111",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "MQU",
      "ProvinceId": "CO28",
      "CountryCode": "CO"
  },
  {
      "CityCode": "NCI",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "PGT",
      "ProvinceId": "CO19",
      "CountryCode": "CO"
  },
  {
      "CityCode": "PCC",
      "ProvinceId": "CO08",
      "CountryCode": "CO"
  },
  {
      "CityCode": "NPD",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "TRB",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "TQS",
      "ProvinceId": "CO08",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0012",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C110",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CPB",
      "ProvinceId": "CO11",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C86",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C87",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C90",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C88",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_99",
      "ProvinceId": "CO19",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C89",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C92",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C93",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C91",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO4",
      "ProvinceId": null,
      "CountryCode": "CO"
  },
  {
      "CityCode": "C94",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C95",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C78",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C96",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "EJA",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "FLA",
      "ProvinceId": "CO08",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C139",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C141",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C142",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C143",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C144",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_1122",
      "ProvinceId": "CO16",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C146",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C147",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C148",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C149",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C150",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "C145",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "IPI",
      "ProvinceId": "CO20",
      "CountryCode": "CO"
  },
  {
      "CityCode": "MDE",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "LET",
      "ProvinceId": "CO01",
      "CountryCode": "CO"
  },
  {
      "CityCode": "NVA",
      "ProvinceId": "CO16",
      "CountryCode": "CO"
  },
  {
      "CityCode": "MZL",
      "ProvinceId": "CO37",
      "CountryCode": "CO"
  },
  {
      "CityCode": "PUU",
      "ProvinceId": "CO22",
      "CountryCode": "CO"
  },
  {
      "CityCode": "PVA",
      "ProvinceId": "CO25",
      "CountryCode": "CO"
  },
  {
      "CityCode": "PTX",
      "ProvinceId": "CO16",
      "CountryCode": "CO"
  },
  {
      "CityCode": "PAL",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "EPN",
      "ProvinceId": "CO28",
      "CountryCode": "CO"
  },
  {
      "CityCode": "SAQ",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "PEI",
      "ProvinceId": "CO24",
      "CountryCode": "CO"
  },
  {
      "CityCode": "AUC",
      "ProvinceId": "CO03",
      "CountryCode": "CO"
  },
  {
      "CityCode": "SOX",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "RCH",
      "ProvinceId": "CO17",
      "CountryCode": "CO"
  },
  {
      "CityCode": "VGZ",
      "ProvinceId": "CO22",
      "CountryCode": "CO"
  },
  {
      "CityCode": "VI1",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "UIB",
      "ProvinceId": "CO11",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0991",
      "ProvinceId": null,
      "CountryCode": "CO"
  },
  {
      "CityCode": "AZP",
      "ProvinceId": null,
      "CountryCode": "CO"
  },
  {
      "CityCode": "SJO",
      "ProvinceId": null,
      "CountryCode": "CR"
  },
  {
      "CityCode": "TTQ",
      "ProvinceId": null,
      "CountryCode": "CR"
  },
  {
      "CityCode": "JAP",
      "ProvinceId": null,
      "CountryCode": "CR"
  },
  {
      "CityCode": "GTE",
      "ProvinceId": null,
      "CountryCode": "CR"
  },
  {
      "CityCode": "LIO",
      "ProvinceId": null,
      "CountryCode": "CR"
  },
  {
      "CityCode": "LIR",
      "ProvinceId": null,
      "CountryCode": "CR"
  },
  {
      "CityCode": "SC1",
      "ProvinceId": null,
      "CountryCode": "CR"
  },
  {
      "CityCode": "SM3",
      "ProvinceId": null,
      "CountryCode": "CR"
  },
  {
      "CityCode": "PJM",
      "ProvinceId": null,
      "CountryCode": "CR"
  },
  {
      "CityCode": "A18",
      "ProvinceId": null,
      "CountryCode": "CR"
  },
  {
      "CityCode": "A19",
      "ProvinceId": null,
      "CountryCode": "CR"
  },
  {
      "CityCode": "XQP",
      "ProvinceId": null,
      "CountryCode": "CR"
  },
  {
      "CityCode": "TNO",
      "ProvinceId": null,
      "CountryCode": "CR"
  },
  {
      "CityCode": "TMU",
      "ProvinceId": null,
      "CountryCode": "CR"
  },
  {
      "CityCode": "TND",
      "ProvinceId": null,
      "CountryCode": "CU"
  },
  {
      "CityCode": "USS",
      "ProvinceId": null,
      "CountryCode": "CU"
  },
  {
      "CityCode": "VRO",
      "ProvinceId": null,
      "CountryCode": "CU"
  },
  {
      "CityCode": "VRA",
      "ProvinceId": null,
      "CountryCode": "CU"
  },
  {
      "CityCode": "LUC",
      "ProvinceId": null,
      "CountryCode": "CU"
  },
  {
      "CityCode": "LIN",
      "ProvinceId": null,
      "CountryCode": "CU"
  },
  {
      "CityCode": "COB",
      "ProvinceId": null,
      "CountryCode": "CU"
  },
  {
      "CityCode": "BSA",
      "ProvinceId": null,
      "CountryCode": "CU"
  },
  {
      "CityCode": "EMR",
      "ProvinceId": null,
      "CountryCode": "CU"
  },
  {
      "CityCode": "PES",
      "ProvinceId": null,
      "CountryCode": "CU"
  },
  {
      "CityCode": "GLV",
      "ProvinceId": null,
      "CountryCode": "CU"
  },
  {
      "CityCode": "BLG",
      "ProvinceId": null,
      "CountryCode": "CU"
  },
  {
      "CityCode": "BSM",
      "ProvinceId": null,
      "CountryCode": "CU"
  },
  {
      "CityCode": "CMO",
      "ProvinceId": null,
      "CountryCode": "CU"
  },
  {
      "CityCode": "A08",
      "ProvinceId": null,
      "CountryCode": "CU"
  },
  {
      "CityCode": "A09",
      "ProvinceId": null,
      "CountryCode": "CU"
  },
  {
      "CityCode": "SAE",
      "ProvinceId": null,
      "CountryCode": "CU"
  },
  {
      "CityCode": "CU_001",
      "ProvinceId": null,
      "CountryCode": "CU"
  },
  {
      "CityCode": "BCA",
      "ProvinceId": null,
      "CountryCode": "CU"
  },
  {
      "CityCode": "C01",
      "ProvinceId": null,
      "CountryCode": "CU"
  },
  {
      "CityCode": "SNU",
      "ProvinceId": null,
      "CountryCode": "CU"
  },
  {
      "CityCode": "HOG",
      "ProvinceId": null,
      "CountryCode": "CU"
  },
  {
      "CityCode": "AVI",
      "ProvinceId": null,
      "CountryCode": "CU"
  },
  {
      "CityCode": "CCC",
      "ProvinceId": null,
      "CountryCode": "CU"
  },
  {
      "CityCode": "CMW",
      "ProvinceId": null,
      "CountryCode": "CU"
  },
  {
      "CityCode": "C05",
      "ProvinceId": null,
      "CountryCode": "CU"
  },
  {
      "CityCode": "GER",
      "ProvinceId": null,
      "CountryCode": "CU"
  },
  {
      "CityCode": "HAV",
      "ProvinceId": null,
      "CountryCode": "CU"
  },
  {
      "CityCode": "ES1",
      "ProvinceId": null,
      "CountryCode": "CU"
  },
  {
      "CityCode": "CL2",
      "ProvinceId": null,
      "CountryCode": "CU"
  },
  {
      "CityCode": "VIÑ",
      "ProvinceId": null,
      "CountryCode": "CU"
  },
  {
      "CityCode": "CLS",
      "ProvinceId": null,
      "CountryCode": "CU"
  },
  {
      "CityCode": "SOR",
      "ProvinceId": null,
      "CountryCode": "CU"
  },
  {
      "CityCode": "REM",
      "ProvinceId": null,
      "CountryCode": "CU"
  },
  {
      "CityCode": "PRU",
      "ProvinceId": null,
      "CountryCode": "CU"
  },
  {
      "CityCode": "BUC",
      "ProvinceId": null,
      "CountryCode": "CU"
  },
  {
      "CityCode": "JCO",
      "ProvinceId": null,
      "CountryCode": "CU"
  },
  {
      "CityCode": "PYE",
      "ProvinceId": null,
      "CountryCode": "CU"
  },
  {
      "CityCode": "VPN",
      "ProvinceId": null,
      "CountryCode": "CU"
  },
  {
      "CityCode": "CYO",
      "ProvinceId": null,
      "CountryCode": "CU"
  },
  {
      "CityCode": "C03",
      "ProvinceId": null,
      "CountryCode": "CU"
  },
  {
      "CityCode": "C04",
      "ProvinceId": null,
      "CountryCode": "CU"
  },
  {
      "CityCode": "C02",
      "ProvinceId": null,
      "CountryCode": "CU"
  },
  {
      "CityCode": "CFG",
      "ProvinceId": null,
      "CountryCode": "CU"
  },
  {
      "CityCode": "C09",
      "ProvinceId": null,
      "CountryCode": "CU"
  },
  {
      "CityCode": "C06",
      "ProvinceId": null,
      "CountryCode": "CU"
  },
  {
      "CityCode": "C08",
      "ProvinceId": null,
      "CountryCode": "CU"
  },
  {
      "CityCode": "C07",
      "ProvinceId": null,
      "CountryCode": "CU"
  },
  {
      "CityCode": "SZJ",
      "ProvinceId": null,
      "CountryCode": "CU"
  },
  {
      "CityCode": "SCU",
      "ProvinceId": null,
      "CountryCode": "CU"
  },
  {
      "CityCode": "MZO",
      "ProvinceId": null,
      "CountryCode": "CU"
  },
  {
      "CityCode": "NTO",
      "ProvinceId": null,
      "CountryCode": "CV"
  },
  {
      "CityCode": "RAI",
      "ProvinceId": null,
      "CountryCode": "CV"
  },
  {
      "CityCode": "SID",
      "ProvinceId": null,
      "CountryCode": "CV"
  },
  {
      "CityCode": "BVC",
      "ProvinceId": null,
      "CountryCode": "CV"
  },
  {
      "CityCode": "BVR",
      "ProvinceId": null,
      "CountryCode": "CV"
  },
  {
      "CityCode": "SNE",
      "ProvinceId": null,
      "CountryCode": "CV"
  },
  {
      "CityCode": "SFL",
      "ProvinceId": null,
      "CountryCode": "CV"
  },
  {
      "CityCode": "MMO",
      "ProvinceId": null,
      "CountryCode": "CV"
  },
  {
      "CityCode": "VXE",
      "ProvinceId": null,
      "CountryCode": "CV"
  },
  {
      "CityCode": "LCA",
      "ProvinceId": null,
      "CountryCode": "CY"
  },
  {
      "CityCode": "ECN",
      "ProvinceId": null,
      "CountryCode": "CY"
  },
  {
      "CityCode": "PFO",
      "ProvinceId": null,
      "CountryCode": "CY"
  },
  {
      "CityCode": "OSR",
      "ProvinceId": null,
      "CountryCode": "CZ"
  },
  {
      "CityCode": "BRQ",
      "ProvinceId": null,
      "CountryCode": "CZ"
  },
  {
      "CityCode": "MKA",
      "ProvinceId": null,
      "CountryCode": "CZ"
  },
  {
      "CityCode": "KLV",
      "ProvinceId": null,
      "CountryCode": "CZ"
  },
  {
      "CityCode": "PED",
      "ProvinceId": null,
      "CountryCode": "CZ"
  },
  {
      "CityCode": "PRG",
      "ProvinceId": null,
      "CountryCode": "CZ"
  },
  {
      "CityCode": "PAD",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "SGE",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "QMZ",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "QFB",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "RLG",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "LBC",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "MUC",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "EIB",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "FRZ",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "FRA",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "HAM",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "HAJ",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "GWT",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "GUT",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "BWE",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "BNJ",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "BER",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "BFE",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "AAH",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "WVN",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "UWE",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "STR",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "ZWM",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "ZSR",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "ZQU",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "AGE",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "MHG",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "LEJ",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "LHA",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "KLT",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "KSF",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "HEI",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "HGL",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "HOQ",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "KEL",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "FMO",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "FKB",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "FDH",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "FLF",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "GTI",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "HDB",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "HDF",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "BRV",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "BYU",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "BRE",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "BBH",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "BBJ",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "AOC",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "CGN",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "ESS",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "FMM",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "ERF",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "DRS",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "DTM",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "DUS",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "NUE",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "PEF",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "ZCE",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "QTK",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "QWU",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "SCN",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "RBM",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "RMS",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "ZEI",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "ZCC",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "ZPM",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "ZQF",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "ZMG",
      "ProvinceId": null,
      "CountryCode": "DE"
  },
  {
      "CityCode": "JIB",
      "ProvinceId": null,
      "CountryCode": "DJ"
  },
  {
      "CityCode": "KRP",
      "ProvinceId": null,
      "CountryCode": "DK"
  },
  {
      "CityCode": "CPH",
      "ProvinceId": null,
      "CountryCode": "DK"
  },
  {
      "CityCode": "VEJ",
      "ProvinceId": null,
      "CountryCode": "DK"
  },
  {
      "CityCode": "RNN",
      "ProvinceId": null,
      "CountryCode": "DK"
  },
  {
      "CityCode": "SKS",
      "ProvinceId": null,
      "CountryCode": "DK"
  },
  {
      "CityCode": "TED",
      "ProvinceId": null,
      "CountryCode": "DK"
  },
  {
      "CityCode": "AAL",
      "ProvinceId": null,
      "CountryCode": "DK"
  },
  {
      "CityCode": "AAR",
      "ProvinceId": null,
      "CountryCode": "DK"
  },
  {
      "CityCode": "BLL",
      "ProvinceId": null,
      "CountryCode": "DK"
  },
  {
      "CityCode": "FAE",
      "ProvinceId": null,
      "CountryCode": "DK"
  },
  {
      "CityCode": "EBJ",
      "ProvinceId": null,
      "CountryCode": "DK"
  },
  {
      "CityCode": "RKE",
      "ProvinceId": null,
      "CountryCode": "DK"
  },
  {
      "CityCode": "SGD",
      "ProvinceId": null,
      "CountryCode": "DK"
  },
  {
      "CityCode": "ODE",
      "ProvinceId": null,
      "CountryCode": "DK"
  },
  {
      "CityCode": "SLU",
      "ProvinceId": null,
      "CountryCode": "DM"
  },
  {
      "CityCode": "MNI",
      "ProvinceId": null,
      "CountryCode": "DM"
  },
  {
      "CityCode": "CIW",
      "ProvinceId": null,
      "CountryCode": "DM"
  },
  {
      "CityCode": "DOM",
      "ProvinceId": null,
      "CountryCode": "DM"
  },
  {
      "CityCode": "D01",
      "ProvinceId": null,
      "CountryCode": "DO"
  },
  {
      "CityCode": "D03",
      "ProvinceId": null,
      "CountryCode": "DO"
  },
  {
      "CityCode": "AZS",
      "ProvinceId": null,
      "CountryCode": "DO"
  },
  {
      "CityCode": "BRX",
      "ProvinceId": null,
      "CountryCode": "DO"
  },
  {
      "CityCode": "LRM",
      "ProvinceId": null,
      "CountryCode": "DO"
  },
  {
      "CityCode": "SJL",
      "ProvinceId": null,
      "CountryCode": "DO"
  },
  {
      "CityCode": "RCA",
      "ProvinceId": null,
      "CountryCode": "DO"
  },
  {
      "CityCode": "VTR",
      "ProvinceId": null,
      "CountryCode": "DO"
  },
  {
      "CityCode": "VGJ",
      "ProvinceId": null,
      "CountryCode": "DO"
  },
  {
      "CityCode": "JBC",
      "ProvinceId": null,
      "CountryCode": "DO"
  },
  {
      "CityCode": "PE1",
      "ProvinceId": null,
      "CountryCode": "DO"
  },
  {
      "CityCode": "PM1",
      "ProvinceId": null,
      "CountryCode": "DO"
  },
  {
      "CityCode": "ST1",
      "ProvinceId": null,
      "CountryCode": "DO"
  },
  {
      "CityCode": "AC2",
      "ProvinceId": null,
      "CountryCode": "DO"
  },
  {
      "CityCode": "CB2",
      "ProvinceId": null,
      "CountryCode": "DO"
  },
  {
      "CityCode": "LT1",
      "ProvinceId": null,
      "CountryCode": "DO"
  },
  {
      "CityCode": "MRN",
      "ProvinceId": null,
      "CountryCode": "DO"
  },
  {
      "CityCode": "PLG",
      "ProvinceId": null,
      "CountryCode": "DO"
  },
  {
      "CityCode": "PGI",
      "ProvinceId": null,
      "CountryCode": "DO"
  },
  {
      "CityCode": "SDQ",
      "ProvinceId": null,
      "CountryCode": "DO"
  },
  {
      "CityCode": "PUJ",
      "ProvinceId": null,
      "CountryCode": "DO"
  },
  {
      "CityCode": "POP",
      "ProvinceId": null,
      "CountryCode": "DO"
  },
  {
      "CityCode": "STI",
      "ProvinceId": null,
      "CountryCode": "DO"
  },
  {
      "CityCode": "CDN",
      "ProvinceId": null,
      "CountryCode": "DO"
  },
  {
      "CityCode": "RLM",
      "ProvinceId": null,
      "CountryCode": "DO"
  },
  {
      "CityCode": "CCB",
      "ProvinceId": null,
      "CountryCode": "DO"
  },
  {
      "CityCode": "ACN",
      "ProvinceId": null,
      "CountryCode": "DO"
  },
  {
      "CityCode": "AGC",
      "ProvinceId": null,
      "CountryCode": "DO"
  },
  {
      "CityCode": "WJY",
      "ProvinceId": null,
      "CountryCode": "DO"
  },
  {
      "CityCode": "VMG",
      "ProvinceId": null,
      "CountryCode": "DO"
  },
  {
      "CityCode": "RSJ",
      "ProvinceId": null,
      "CountryCode": "DO"
  },
  {
      "CityCode": "UVA",
      "ProvinceId": null,
      "CountryCode": "DO"
  },
  {
      "CityCode": "AR6",
      "ProvinceId": null,
      "CountryCode": "DO"
  },
  {
      "CityCode": "MTZ",
      "ProvinceId": null,
      "CountryCode": "DO"
  },
  {
      "CityCode": "MGO",
      "ProvinceId": null,
      "CountryCode": "DO"
  },
  {
      "CityCode": "MPO",
      "ProvinceId": null,
      "CountryCode": "DO"
  },
  {
      "CityCode": "MOK",
      "ProvinceId": null,
      "CountryCode": "DO"
  },
  {
      "CityCode": "GUN",
      "ProvinceId": null,
      "CountryCode": "DO"
  },
  {
      "CityCode": "LYG",
      "ProvinceId": null,
      "CountryCode": "DO"
  },
  {
      "CityCode": "GNM",
      "ProvinceId": null,
      "CountryCode": "DO"
  },
  {
      "CityCode": "GPD",
      "ProvinceId": null,
      "CountryCode": "DO"
  },
  {
      "CityCode": "ELG",
      "ProvinceId": null,
      "CountryCode": "DO"
  },
  {
      "CityCode": "SLT",
      "ProvinceId": null,
      "CountryCode": "DO"
  },
  {
      "CityCode": "BYE",
      "ProvinceId": null,
      "CountryCode": "DO"
  },
  {
      "CityCode": "MC2",
      "ProvinceId": null,
      "CountryCode": "DO"
  },
  {
      "CityCode": "D02",
      "ProvinceId": null,
      "CountryCode": "DO"
  },
  {
      "CityCode": "A12",
      "ProvinceId": null,
      "CountryCode": "DO"
  },
  {
      "CityCode": "SKI",
      "ProvinceId": null,
      "CountryCode": "DZ"
  },
  {
      "CityCode": "GHA",
      "ProvinceId": null,
      "CountryCode": "DZ"
  },
  {
      "CityCode": "AAE",
      "ProvinceId": null,
      "CountryCode": "DZ"
  },
  {
      "CityCode": "ALG",
      "ProvinceId": null,
      "CountryCode": "DZ"
  },
  {
      "CityCode": "ORN",
      "ProvinceId": null,
      "CountryCode": "DZ"
  },
  {
      "CityCode": "CZL",
      "ProvinceId": null,
      "CountryCode": "DZ"
  },
  {
      "CityCode": "ESM",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "A03",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "GPS",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "SCY",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "UIO",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "VI2",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "CUE",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "GYE",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "MEC",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "PTZ",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "OCC",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "LGQ",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "AL1",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "AL2",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "AL3",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "QUI",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "AL4",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "AGM",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "ATF",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "AM1",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "AN1",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "AD1",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "AA1",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "AA2",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "AA3",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "AT1",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "AT2",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "AT3",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "ZOG",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "BA1",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "BA2",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "BA3",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "BA4",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "BA5",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "BA6",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "BA7",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "BA8",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "BI1",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "BO1",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "BO2",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "CA1",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "CA2",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "CA3",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "CA4",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "CA5",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "CA6",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "CA7",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "CA8",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "CA9",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "C10",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "C11",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "C12",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "C13",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "C14",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "C15",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "C16",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "C17",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "C18",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "C19",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "C20",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "C21",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "C22",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "C23",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "C24",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "C25",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "C26",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "C27",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "C28",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "C29",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "DA1",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "DU1",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "ECE",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "C30",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "C31",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "C32",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "EM2",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "GU1",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "GU2",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "ET1",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "EA1",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "EA2",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "FA1",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "GI1",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "GP1",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "GO1",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "GU3",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "GU4",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "GU5",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "GU6",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "GU7",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "HU1",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "HU2",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "HU3",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "IB1",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "IS1",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "IZ1",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "JA1",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "JIP",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "JU1",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "JNI",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "LA1",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "LC1",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "LI1",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "LJ1",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "LJ2",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "LM1",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "LM2",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "LM3",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "LP1",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "LP2",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "LU1",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "LN1",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "LA2",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "LTX",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "LI2",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "LI3",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "LOH",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "LO1",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "LU2",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "MRR",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "XMS",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "MC1",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "MCH",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "MA2",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "ME1",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "MI1",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "MI2",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "MI3",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "MO2",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "MO3",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "MO4",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "MU1",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "MU2",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "NA1",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "NA2",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "NA3",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "NA4",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "NA5",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "NU1",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "NU2",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "OT1",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "PA2",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "PA3",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "PA4",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "PA5",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "PA6",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "PA7",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "PA8",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "PA9",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "PDZ",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "PE3",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "PE4",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "PI1",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "PI2",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "PI3",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "PI4",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "PI5",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "PI6",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "PI7",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "PL1",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "PO2",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "PO3",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "PO4",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "PVO",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "PU1",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "PU2",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "PU3",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "PU4",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "PU5",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "PU6",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "PU7",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "PU8",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "PU9",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "P10",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "PYO",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "P11",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "QU1",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "QU2",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "QU3",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "QU4",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "QU5",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "RI1",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "RI2",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "RO1",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "SA3",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "SA4",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "SA5",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "SA6",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "SA7",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "SA8",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "FDO",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "SA9",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "S10",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "S11",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "S12",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "NMG",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "S13",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "S14",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "S15",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "S16",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "S17",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "S18",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "S19",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "S20",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "S21",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "S22",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "S23",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "S24",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "S26",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "S27",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "S28",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "S29",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "S30",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "S31",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "S32",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "S33",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "S34",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "S35",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "S36",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "S37",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "TA1",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "TA2",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "TA3",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "TA4",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "TA5",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "TE1",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "TI1",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "TO1",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "TO2",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "TO3",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "TUA",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "TU1",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "TU2",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "UR1",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "VA1",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "VA2",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "VE1",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "VE2",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "YA1",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "YA2",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "YA3",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "YA4",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "ZMM",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "ZA1",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "ZA2",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "P18",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "AR5",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "AR4",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "TAY",
      "ProvinceId": null,
      "CountryCode": "EE"
  },
  {
      "CityCode": "TLL",
      "ProvinceId": null,
      "CountryCode": "EE"
  },
  {
      "CityCode": "TCP",
      "ProvinceId": null,
      "CountryCode": "EG"
  },
  {
      "CityCode": "UVL",
      "ProvinceId": null,
      "CountryCode": "EG"
  },
  {
      "CityCode": "LXR",
      "ProvinceId": null,
      "CountryCode": "EG"
  },
  {
      "CityCode": "RMF",
      "ProvinceId": null,
      "CountryCode": "EG"
  },
  {
      "CityCode": "ALY",
      "ProvinceId": null,
      "CountryCode": "EG"
  },
  {
      "CityCode": "ABS",
      "ProvinceId": null,
      "CountryCode": "EG"
  },
  {
      "CityCode": "ASW",
      "ProvinceId": null,
      "CountryCode": "EG"
  },
  {
      "CityCode": "SSH",
      "ProvinceId": null,
      "CountryCode": "EG"
  },
  {
      "CityCode": "HBE",
      "ProvinceId": null,
      "CountryCode": "EG"
  },
  {
      "CityCode": "HRG",
      "ProvinceId": null,
      "CountryCode": "EG"
  },
  {
      "CityCode": "DAK",
      "ProvinceId": null,
      "CountryCode": "EG"
  },
  {
      "CityCode": "CAI",
      "ProvinceId": null,
      "CountryCode": "EG"
  },
  {
      "CityCode": "ASM",
      "ProvinceId": null,
      "CountryCode": "ER"
  },
  {
      "CityCode": "ALC",
      "ProvinceId": null,
      "CountryCode": "ES"
  },
  {
      "CityCode": "ACE",
      "ProvinceId": null,
      "CountryCode": "ES"
  },
  {
      "CityCode": "ABC",
      "ProvinceId": null,
      "CountryCode": "ES"
  },
  {
      "CityCode": "CDZ",
      "ProvinceId": null,
      "CountryCode": "ES"
  },
  {
      "CityCode": "GMZ",
      "ProvinceId": null,
      "CountryCode": "ES"
  },
  {
      "CityCode": "IBZ",
      "ProvinceId": null,
      "CountryCode": "ES"
  },
  {
      "CityCode": "FUE",
      "ProvinceId": null,
      "CountryCode": "ES"
  },
  {
      "CityCode": "EAS",
      "ProvinceId": null,
      "CountryCode": "ES"
  },
  {
      "CityCode": "RJL",
      "ProvinceId": null,
      "CountryCode": "ES"
  },
  {
      "CityCode": "QRL",
      "ProvinceId": null,
      "CountryCode": "ES"
  },
  {
      "CityCode": "ODB",
      "ProvinceId": null,
      "CountryCode": "ES"
  },
  {
      "CityCode": "PMI",
      "ProvinceId": null,
      "CountryCode": "ES"
  },
  {
      "CityCode": "MLN",
      "ProvinceId": null,
      "CountryCode": "ES"
  },
  {
      "CityCode": "LCG",
      "ProvinceId": null,
      "CountryCode": "ES"
  },
  {
      "CityCode": "VDE",
      "ProvinceId": null,
      "CountryCode": "ES"
  },
  {
      "CityCode": "XRY",
      "ProvinceId": null,
      "CountryCode": "ES"
  },
  {
      "CityCode": "XTJ",
      "ProvinceId": null,
      "CountryCode": "ES"
  },
  {
      "CityCode": "TCI",
      "ProvinceId": null,
      "CountryCode": "ES"
  },
  {
      "CityCode": "UTL",
      "ProvinceId": null,
      "CountryCode": "ES"
  },
  {
      "CityCode": "PCZ",
      "ProvinceId": null,
      "CountryCode": "ES"
  },
  {
      "CityCode": "BJ1",
      "ProvinceId": null,
      "CountryCode": "ES"
  },
  {
      "CityCode": "FU1",
      "ProvinceId": null,
      "CountryCode": "ES"
  },
  {
      "CityCode": "CE5",
      "ProvinceId": null,
      "CountryCode": "ES"
  },
  {
      "CityCode": "CM5",
      "ProvinceId": null,
      "CountryCode": "ES"
  },
  {
      "CityCode": "SN1",
      "ProvinceId": null,
      "CountryCode": "ES"
  },
  {
      "CityCode": "SLM",
      "ProvinceId": null,
      "CountryCode": "ES"
  },
  {
      "CityCode": "AGP",
      "ProvinceId": null,
      "CountryCode": "ES"
  },
  {
      "CityCode": "BJZ",
      "ProvinceId": null,
      "CountryCode": "ES"
  },
  {
      "CityCode": "BIO",
      "ProvinceId": null,
      "CountryCode": "ES"
  },
  {
      "CityCode": "BCN",
      "ProvinceId": null,
      "CountryCode": "ES"
  },
  {
      "CityCode": "QUQ",
      "ProvinceId": null,
      "CountryCode": "ES"
  },
  {
      "CityCode": "GRO",
      "ProvinceId": null,
      "CountryCode": "ES"
  },
  {
      "CityCode": "GRX",
      "ProvinceId": null,
      "CountryCode": "ES"
  },
  {
      "CityCode": "OC1",
      "ProvinceId": null,
      "CountryCode": "ES"
  },
  {
      "CityCode": "MJV",
      "ProvinceId": null,
      "CountryCode": "ES"
  },
  {
      "CityCode": "MAD",
      "ProvinceId": null,
      "CountryCode": "ES"
  },
  {
      "CityCode": "MAH",
      "ProvinceId": null,
      "CountryCode": "ES"
  },
  {
      "CityCode": "LPA",
      "ProvinceId": null,
      "CountryCode": "ES"
  },
  {
      "CityCode": "LEI",
      "ProvinceId": null,
      "CountryCode": "ES"
  },
  {
      "CityCode": "LEN",
      "ProvinceId": null,
      "CountryCode": "ES"
  },
  {
      "CityCode": "SVQ",
      "ProvinceId": null,
      "CountryCode": "ES"
  },
  {
      "CityCode": "SDR",
      "ProvinceId": null,
      "CountryCode": "ES"
  },
  {
      "CityCode": "SPC",
      "ProvinceId": null,
      "CountryCode": "ES"
  },
  {
      "CityCode": "REU",
      "ProvinceId": null,
      "CountryCode": "ES"
  },
  {
      "CityCode": "SCQ",
      "ProvinceId": null,
      "CountryCode": "ES"
  },
  {
      "CityCode": "OVD",
      "ProvinceId": null,
      "CountryCode": "ES"
  },
  {
      "CityCode": "YJE",
      "ProvinceId": null,
      "CountryCode": "ES"
  },
  {
      "CityCode": "PNA",
      "ProvinceId": null,
      "CountryCode": "ES"
  },
  {
      "CityCode": "QWX",
      "ProvinceId": null,
      "CountryCode": "ES"
  },
  {
      "CityCode": "S38",
      "ProvinceId": null,
      "CountryCode": "ES"
  },
  {
      "CityCode": "VIT",
      "ProvinceId": null,
      "CountryCode": "ES"
  },
  {
      "CityCode": "VGO",
      "ProvinceId": null,
      "CountryCode": "ES"
  },
  {
      "CityCode": "VLC",
      "ProvinceId": null,
      "CountryCode": "ES"
  },
  {
      "CityCode": "VLL",
      "ProvinceId": null,
      "CountryCode": "ES"
  },
  {
      "CityCode": "ZAZ",
      "ProvinceId": null,
      "CountryCode": "ES"
  },
  {
      "CityCode": "JIM",
      "ProvinceId": null,
      "CountryCode": "ET"
  },
  {
      "CityCode": "ADD",
      "ProvinceId": null,
      "CountryCode": "ET"
  },
  {
      "CityCode": "DIR",
      "ProvinceId": null,
      "CountryCode": "ET"
  },
  {
      "CityCode": "KAO",
      "ProvinceId": null,
      "CountryCode": "FI"
  },
  {
      "CityCode": "JYV",
      "ProvinceId": null,
      "CountryCode": "FI"
  },
  {
      "CityCode": "KAJ",
      "ProvinceId": null,
      "CountryCode": "FI"
  },
  {
      "CityCode": "KOK",
      "ProvinceId": null,
      "CountryCode": "FI"
  },
  {
      "CityCode": "JOE",
      "ProvinceId": null,
      "CountryCode": "FI"
  },
  {
      "CityCode": "IVL",
      "ProvinceId": null,
      "CountryCode": "FI"
  },
  {
      "CityCode": "RVI",
      "ProvinceId": null,
      "CountryCode": "FI"
  },
  {
      "CityCode": "TMP",
      "ProvinceId": null,
      "CountryCode": "FI"
  },
  {
      "CityCode": "TKU",
      "ProvinceId": null,
      "CountryCode": "FI"
  },
  {
      "CityCode": "VAA",
      "ProvinceId": null,
      "CountryCode": "FI"
  },
  {
      "CityCode": "VRK",
      "ProvinceId": null,
      "CountryCode": "FI"
  },
  {
      "CityCode": "KEM",
      "ProvinceId": null,
      "CountryCode": "FI"
  },
  {
      "CityCode": "HEL",
      "ProvinceId": null,
      "CountryCode": "FI"
  },
  {
      "CityCode": "LPP",
      "ProvinceId": null,
      "CountryCode": "FI"
  },
  {
      "CityCode": "KTT",
      "ProvinceId": null,
      "CountryCode": "FI"
  },
  {
      "CityCode": "KUO",
      "ProvinceId": null,
      "CountryCode": "FI"
  },
  {
      "CityCode": "MHQ",
      "ProvinceId": null,
      "CountryCode": "FI"
  },
  {
      "CityCode": "MIK",
      "ProvinceId": null,
      "CountryCode": "FI"
  },
  {
      "CityCode": "YLI",
      "ProvinceId": null,
      "CountryCode": "FI"
  },
  {
      "CityCode": "POR",
      "ProvinceId": null,
      "CountryCode": "FI"
  },
  {
      "CityCode": "OUL",
      "ProvinceId": null,
      "CountryCode": "FI"
  },
  {
      "CityCode": "RVN",
      "ProvinceId": null,
      "CountryCode": "FI"
  },
  {
      "CityCode": "SJY",
      "ProvinceId": null,
      "CountryCode": "FI"
  },
  {
      "CityCode": "SVL",
      "ProvinceId": null,
      "CountryCode": "FI"
  },
  {
      "CityCode": "SVU",
      "ProvinceId": null,
      "CountryCode": "FJ"
  },
  {
      "CityCode": "NAN",
      "ProvinceId": null,
      "CountryCode": "FJ"
  },
  {
      "CityCode": "SUV",
      "ProvinceId": null,
      "CountryCode": "FJ"
  },
  {
      "CityCode": "TVU",
      "ProvinceId": null,
      "CountryCode": "FJ"
  },
  {
      "CityCode": "LBS",
      "ProvinceId": null,
      "CountryCode": "FJ"
  },
  {
      "CityCode": "BFJ",
      "ProvinceId": null,
      "CountryCode": "FJ"
  },
  {
      "CityCode": "MPN",
      "ProvinceId": null,
      "CountryCode": "FK"
  },
  {
      "CityCode": "PNI",
      "ProvinceId": null,
      "CountryCode": "FM"
  },
  {
      "CityCode": "TKK",
      "ProvinceId": null,
      "CountryCode": "FM"
  },
  {
      "CityCode": "TUF",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "SXB",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "SXD",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "RNE",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "RNS",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "RCO",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "RDZ",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "PIS",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "PGX",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "PGF",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "POX",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "PUF",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "MZM",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "NCE",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "NCY",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "NTE",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "ZAO",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "ZAF",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "VHY",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "UIP",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "URO",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "VNE",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "MPL",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "MRS",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "MCU",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "LTQ",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "LTT",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "LSO",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "LPY",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "LRH",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "LRT",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "LDE",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "LEH",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "FNI",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "GAT",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "ANG",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "ANE",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "BIQ",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "BIA",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "BZR",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "DCM",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "CQF",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "CFE",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "CFR",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "CET",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "CNG",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "CHR",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "EPL",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "DPE",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "DNR",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "ENC",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "DOL",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "BES",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "AVN",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "AUR",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "AJA",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "CEQ",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "CER",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "CSF",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "CMR",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "CLY",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "CMF",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "BOD",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "BVE",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "CCF",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "DIJ",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "CVF",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "EAP",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "DLE",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "EBU",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "EDM",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "EGC",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "FSC",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "FRJ",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "ETZ",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "EVX",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "GNB",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "LBI",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "LBY",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "LIG",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "LIL",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "LAI",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "LME",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "MLH",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "LYS",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "MXN",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "PRP",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "QAM",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "PAR",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "QRV",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "RHE",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "SNR",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "SBK",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "TLN",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "TLS",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "VAF",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "XSB",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "XDK",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "AGF",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "XMT",
      "ProvinceId": null,
      "CountryCode": "FR"
  },
  {
      "CityCode": "MVB",
      "ProvinceId": null,
      "CountryCode": "GA"
  },
  {
      "CityCode": "LBV",
      "ProvinceId": null,
      "CountryCode": "GA"
  },
  {
      "CityCode": "ABY",
      "ProvinceId": null,
      "CountryCode": "GA"
  },
  {
      "CityCode": "POG",
      "ProvinceId": null,
      "CountryCode": "GA"
  },
  {
      "CityCode": "OXF",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "OBN",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "ORM",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "NCL",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "NDY",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "NRL",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "NWI",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "SKL",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "SOY",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "SOU",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "SDZ",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "SEN",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "SWI",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "SWS",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "SZD",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "SYY",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "TRE",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "WRY",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "WIC",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "UNT",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "ZFI",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "EOI",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "DND",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "DOC",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "CVT",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "CWL",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "BRR",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "BRS",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "BSH",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "CAX",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "CAL",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "CBG",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "BHX",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "BRF",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "FIE",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "GCI",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "GSY",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "HRT",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "ILY",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "HTF",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "JER",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "IPW",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "ISC",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "INV",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "IOM",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "LDY",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "KYN",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "LEQ",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "LPL",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "LON",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "LSI",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "LTN",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "MAN",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "MHZ",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "MSE",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "ABZ",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "ACI",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "BEB",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "BEQ",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "BFS",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "BLK",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "BWF",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "BOH",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "CEG",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "GLO",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "GLA",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "HUY",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "HLY",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "EXT",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "FWM",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "EDI",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "DCS",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "LBA",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "KOI",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "KNF",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "LYX",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "MME",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "QEW",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "QQX",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "QQY",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "NQT",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "NQY",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "PZE",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "PSL",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "PPW",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "PME",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "PLH",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "COL",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "ADX",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "XPT",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "XNM",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "XRU",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "XQG",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "XSR",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "XVW",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "XVA",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "XVJ",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "WXF",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "XWD",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "XWH",
      "ProvinceId": null,
      "CountryCode": "GB"
  },
  {
      "CityCode": "GND",
      "ProvinceId": null,
      "CountryCode": "GD"
  },
  {
      "CityCode": "BUS",
      "ProvinceId": null,
      "CountryCode": "GE"
  },
  {
      "CityCode": "TBS",
      "ProvinceId": null,
      "CountryCode": "GE"
  },
  {
      "CityCode": "CAY",
      "ProvinceId": null,
      "CountryCode": "GF"
  },
  {
      "CityCode": "ACC",
      "ProvinceId": null,
      "CountryCode": "GH"
  },
  {
      "CityCode": "GIB",
      "ProvinceId": null,
      "CountryCode": "GI"
  },
  {
      "CityCode": "SFJ",
      "ProvinceId": null,
      "CountryCode": "GL"
  },
  {
      "CityCode": "JNS",
      "ProvinceId": null,
      "CountryCode": "GL"
  },
  {
      "CityCode": "JSU",
      "ProvinceId": null,
      "CountryCode": "GL"
  },
  {
      "CityCode": "LLU",
      "ProvinceId": null,
      "CountryCode": "GL"
  },
  {
      "CityCode": "UAK",
      "ProvinceId": null,
      "CountryCode": "GL"
  },
  {
      "CityCode": "JAV",
      "ProvinceId": null,
      "CountryCode": "GL"
  },
  {
      "CityCode": "JEG",
      "ProvinceId": null,
      "CountryCode": "GL"
  },
  {
      "CityCode": "JGR",
      "ProvinceId": null,
      "CountryCode": "GL"
  },
  {
      "CityCode": "JHS",
      "ProvinceId": null,
      "CountryCode": "GL"
  },
  {
      "CityCode": "JJU",
      "ProvinceId": null,
      "CountryCode": "GL"
  },
  {
      "CityCode": "GOH",
      "ProvinceId": null,
      "CountryCode": "GL"
  },
  {
      "CityCode": "BJL",
      "ProvinceId": null,
      "CountryCode": "GM"
  },
  {
      "CityCode": "CKY",
      "ProvinceId": null,
      "CountryCode": "GN"
  },
  {
      "CityCode": "CCE",
      "ProvinceId": null,
      "CountryCode": "GP"
  },
  {
      "CityCode": "SBH",
      "ProvinceId": null,
      "CountryCode": "GP"
  },
  {
      "CityCode": "BBR",
      "ProvinceId": null,
      "CountryCode": "GP"
  },
  {
      "CityCode": "DSD",
      "ProvinceId": null,
      "CountryCode": "GP"
  },
  {
      "CityCode": "PTP",
      "ProvinceId": null,
      "CountryCode": "GP"
  },
  {
      "CityCode": "SSG",
      "ProvinceId": null,
      "CountryCode": "GQ"
  },
  {
      "CityCode": "SKG",
      "ProvinceId": null,
      "CountryCode": "GR"
  },
  {
      "CityCode": "PVK",
      "ProvinceId": null,
      "CountryCode": "GR"
  },
  {
      "CityCode": "CHQ",
      "ProvinceId": null,
      "CountryCode": "GR"
  },
  {
      "CityCode": "CFU",
      "ProvinceId": null,
      "CountryCode": "GR"
  },
  {
      "CityCode": "AXD",
      "ProvinceId": null,
      "CountryCode": "GR"
  },
  {
      "CityCode": "AOK",
      "ProvinceId": null,
      "CountryCode": "GR"
  },
  {
      "CityCode": "GPA",
      "ProvinceId": null,
      "CountryCode": "GR"
  },
  {
      "CityCode": "JKH",
      "ProvinceId": null,
      "CountryCode": "GR"
  },
  {
      "CityCode": "JMK",
      "ProvinceId": null,
      "CountryCode": "GR"
  },
  {
      "CityCode": "JIK",
      "ProvinceId": null,
      "CountryCode": "GR"
  },
  {
      "CityCode": "IOA",
      "ProvinceId": null,
      "CountryCode": "GR"
  },
  {
      "CityCode": "HER",
      "ProvinceId": null,
      "CountryCode": "GR"
  },
  {
      "CityCode": "MJT",
      "ProvinceId": null,
      "CountryCode": "GR"
  },
  {
      "CityCode": "LRS",
      "ProvinceId": null,
      "CountryCode": "GR"
  },
  {
      "CityCode": "KVA",
      "ProvinceId": null,
      "CountryCode": "GR"
  },
  {
      "CityCode": "KSO",
      "ProvinceId": null,
      "CountryCode": "GR"
  },
  {
      "CityCode": "KGS",
      "ProvinceId": null,
      "CountryCode": "GR"
  },
  {
      "CityCode": "SMI",
      "ProvinceId": null,
      "CountryCode": "GR"
  },
  {
      "CityCode": "RHO",
      "ProvinceId": null,
      "CountryCode": "GR"
  },
  {
      "CityCode": "PAS",
      "ProvinceId": null,
      "CountryCode": "GR"
  },
  {
      "CityCode": "JSY",
      "ProvinceId": null,
      "CountryCode": "GR"
  },
  {
      "CityCode": "JSI",
      "ProvinceId": null,
      "CountryCode": "GR"
  },
  {
      "CityCode": "JNX",
      "ProvinceId": null,
      "CountryCode": "GR"
  },
  {
      "CityCode": "KLX",
      "ProvinceId": null,
      "CountryCode": "GR"
  },
  {
      "CityCode": "LXS",
      "ProvinceId": null,
      "CountryCode": "GR"
  },
  {
      "CityCode": "ATH",
      "ProvinceId": null,
      "CountryCode": "GR"
  },
  {
      "CityCode": "EFL",
      "ProvinceId": null,
      "CountryCode": "GR"
  },
  {
      "CityCode": "VOL",
      "ProvinceId": null,
      "CountryCode": "GR"
  },
  {
      "CityCode": "ZTH",
      "ProvinceId": null,
      "CountryCode": "GR"
  },
  {
      "CityCode": "JTR",
      "ProvinceId": null,
      "CountryCode": "GR"
  },
  {
      "CityCode": "FRS",
      "ProvinceId": null,
      "CountryCode": "GT"
  },
  {
      "CityCode": "ATG",
      "ProvinceId": null,
      "CountryCode": "GT"
  },
  {
      "CityCode": "ATT",
      "ProvinceId": null,
      "CountryCode": "GT"
  },
  {
      "CityCode": "LCF",
      "ProvinceId": null,
      "CountryCode": "GT"
  },
  {
      "CityCode": "PBR",
      "ProvinceId": null,
      "CountryCode": "GT"
  },
  {
      "CityCode": "PKJ",
      "ProvinceId": null,
      "CountryCode": "GT"
  },
  {
      "CityCode": "GUA",
      "ProvinceId": null,
      "CountryCode": "GT"
  },
  {
      "CityCode": "RER",
      "ProvinceId": null,
      "CountryCode": "GT"
  },
  {
      "CityCode": "TKM",
      "ProvinceId": null,
      "CountryCode": "GT"
  },
  {
      "CityCode": "GUM",
      "ProvinceId": null,
      "CountryCode": "GU"
  },
  {
      "CityCode": "OXB",
      "ProvinceId": null,
      "CountryCode": "GW"
  },
  {
      "CityCode": "GEO",
      "ProvinceId": null,
      "CountryCode": "GY"
  },
  {
      "CityCode": "HKG",
      "ProvinceId": null,
      "CountryCode": "HK"
  },
  {
      "CityCode": "CDD",
      "ProvinceId": null,
      "CountryCode": "HN"
  },
  {
      "CityCode": "SAP",
      "ProvinceId": null,
      "CountryCode": "HN"
  },
  {
      "CityCode": "LCE",
      "ProvinceId": null,
      "CountryCode": "HN"
  },
  {
      "CityCode": "A20",
      "ProvinceId": null,
      "CountryCode": "HN"
  },
  {
      "CityCode": "D4N",
      "ProvinceId": null,
      "CountryCode": "HN"
  },
  {
      "CityCode": "TCF",
      "ProvinceId": null,
      "CountryCode": "HN"
  },
  {
      "CityCode": "PEU",
      "ProvinceId": null,
      "CountryCode": "HN"
  },
  {
      "CityCode": "PC3",
      "ProvinceId": null,
      "CountryCode": "HN"
  },
  {
      "CityCode": "XPL",
      "ProvinceId": null,
      "CountryCode": "HN"
  },
  {
      "CityCode": "TEA",
      "ProvinceId": null,
      "CountryCode": "HN"
  },
  {
      "CityCode": "UII",
      "ProvinceId": null,
      "CountryCode": "HN"
  },
  {
      "CityCode": "CH0",
      "ProvinceId": null,
      "CountryCode": "HN"
  },
  {
      "CityCode": "SDH",
      "ProvinceId": null,
      "CountryCode": "HN"
  },
  {
      "CityCode": "GAC",
      "ProvinceId": null,
      "CountryCode": "HN"
  },
  {
      "CityCode": "GJA",
      "ProvinceId": null,
      "CountryCode": "HN"
  },
  {
      "CityCode": "TGU",
      "ProvinceId": null,
      "CountryCode": "HN"
  },
  {
      "CityCode": "RTB",
      "ProvinceId": null,
      "CountryCode": "HN"
  },
  {
      "CityCode": "SPU",
      "ProvinceId": null,
      "CountryCode": "HR"
  },
  {
      "CityCode": "PUY",
      "ProvinceId": null,
      "CountryCode": "HR"
  },
  {
      "CityCode": "ZAG",
      "ProvinceId": null,
      "CountryCode": "HR"
  },
  {
      "CityCode": "ZAD",
      "ProvinceId": null,
      "CountryCode": "HR"
  },
  {
      "CityCode": "DBV",
      "ProvinceId": null,
      "CountryCode": "HR"
  },
  {
      "CityCode": "HR3",
      "ProvinceId": null,
      "CountryCode": "HR"
  },
  {
      "CityCode": "RJK",
      "ProvinceId": null,
      "CountryCode": "HR"
  },
  {
      "CityCode": "PAP",
      "ProvinceId": null,
      "CountryCode": "HT"
  },
  {
      "CityCode": "CAP",
      "ProvinceId": null,
      "CountryCode": "HT"
  },
  {
      "CityCode": "SOB",
      "ProvinceId": null,
      "CountryCode": "HU"
  },
  {
      "CityCode": "BUD",
      "ProvinceId": null,
      "CountryCode": "HU"
  },
  {
      "CityCode": "CBN",
      "ProvinceId": null,
      "CountryCode": "ID"
  },
  {
      "CityCode": "AMI",
      "ProvinceId": null,
      "CountryCode": "ID"
  },
  {
      "CityCode": "GNS",
      "ProvinceId": null,
      "CountryCode": "ID"
  },
  {
      "CityCode": "DJB",
      "ProvinceId": null,
      "CountryCode": "ID"
  },
  {
      "CityCode": "SOC",
      "ProvinceId": null,
      "CountryCode": "ID"
  },
  {
      "CityCode": "PDG",
      "ProvinceId": null,
      "CountryCode": "ID"
  },
  {
      "CityCode": "PKU",
      "ProvinceId": null,
      "CountryCode": "ID"
  },
  {
      "CityCode": "PLM",
      "ProvinceId": null,
      "CountryCode": "ID"
  },
  {
      "CityCode": "JOG",
      "ProvinceId": null,
      "CountryCode": "ID"
  },
  {
      "CityCode": "MES",
      "ProvinceId": null,
      "CountryCode": "ID"
  },
  {
      "CityCode": "AHI",
      "ProvinceId": null,
      "CountryCode": "ID"
  },
  {
      "CityCode": "SUB",
      "ProvinceId": null,
      "CountryCode": "ID"
  },
  {
      "CityCode": "SMN",
      "ProvinceId": null,
      "CountryCode": "ID"
  },
  {
      "CityCode": "BTH",
      "ProvinceId": null,
      "CountryCode": "ID"
  },
  {
      "CityCode": "BTJ",
      "ProvinceId": null,
      "CountryCode": "ID"
  },
  {
      "CityCode": "BIK",
      "ProvinceId": null,
      "CountryCode": "ID"
  },
  {
      "CityCode": "BPN",
      "ProvinceId": null,
      "CountryCode": "ID"
  },
  {
      "CityCode": "BAJ",
      "ProvinceId": null,
      "CountryCode": "ID"
  },
  {
      "CityCode": "BDO",
      "ProvinceId": null,
      "CountryCode": "ID"
  },
  {
      "CityCode": "DPS",
      "ProvinceId": null,
      "CountryCode": "ID"
  },
  {
      "CityCode": "CXP",
      "ProvinceId": null,
      "CountryCode": "ID"
  },
  {
      "CityCode": "JKT",
      "ProvinceId": null,
      "CountryCode": "ID"
  },
  {
      "CityCode": "MDC",
      "ProvinceId": null,
      "CountryCode": "ID"
  },
  {
      "CityCode": "UPG",
      "ProvinceId": null,
      "CountryCode": "ID"
  },
  {
      "CityCode": "UBU",
      "ProvinceId": null,
      "CountryCode": "ID"
  },
  {
      "CityCode": "SRG",
      "ProvinceId": null,
      "CountryCode": "ID"
  },
  {
      "CityCode": "TIM",
      "ProvinceId": null,
      "CountryCode": "ID"
  },
  {
      "CityCode": "TJQ",
      "ProvinceId": null,
      "CountryCode": "ID"
  },
  {
      "CityCode": "TKG",
      "ProvinceId": null,
      "CountryCode": "ID"
  },
  {
      "CityCode": "SOQ",
      "ProvinceId": null,
      "CountryCode": "ID"
  },
  {
      "CityCode": "SXL",
      "ProvinceId": null,
      "CountryCode": "IE"
  },
  {
      "CityCode": "ORK",
      "ProvinceId": null,
      "CountryCode": "IE"
  },
  {
      "CityCode": "WEX",
      "ProvinceId": null,
      "CountryCode": "IE"
  },
  {
      "CityCode": "KIR",
      "ProvinceId": null,
      "CountryCode": "IE"
  },
  {
      "CityCode": "CFN",
      "ProvinceId": null,
      "CountryCode": "IE"
  },
  {
      "CityCode": "DUB",
      "ProvinceId": null,
      "CountryCode": "IE"
  },
  {
      "CityCode": "ENK",
      "ProvinceId": null,
      "CountryCode": "IE"
  },
  {
      "CityCode": "WAT",
      "ProvinceId": null,
      "CountryCode": "IE"
  },
  {
      "CityCode": "NNR",
      "ProvinceId": null,
      "CountryCode": "IE"
  },
  {
      "CityCode": "LMK",
      "ProvinceId": null,
      "CountryCode": "IE"
  },
  {
      "CityCode": "NOC",
      "ProvinceId": null,
      "CountryCode": "IE"
  },
  {
      "CityCode": "SNN",
      "ProvinceId": null,
      "CountryCode": "IE"
  },
  {
      "CityCode": "GWY",
      "ProvinceId": null,
      "CountryCode": "IE"
  },
  {
      "CityCode": "ETH",
      "ProvinceId": null,
      "CountryCode": "IL"
  },
  {
      "CityCode": "JRS",
      "ProvinceId": null,
      "CountryCode": "IL"
  },
  {
      "CityCode": "VDA",
      "ProvinceId": null,
      "CountryCode": "IL"
  },
  {
      "CityCode": "TLV",
      "ProvinceId": null,
      "CountryCode": "IL"
  },
  {
      "CityCode": "KSW",
      "ProvinceId": null,
      "CountryCode": "IL"
  },
  {
      "CityCode": "HFA",
      "ProvinceId": null,
      "CountryCode": "IL"
  },
  {
      "CityCode": "YOT",
      "ProvinceId": null,
      "CountryCode": "IL"
  },
  {
      "CityCode": "RPN",
      "ProvinceId": null,
      "CountryCode": "IL"
  },
  {
      "CityCode": "SXR",
      "ProvinceId": null,
      "CountryCode": "IN"
  },
  {
      "CityCode": "TIR",
      "ProvinceId": null,
      "CountryCode": "IN"
  },
  {
      "CityCode": "TRV",
      "ProvinceId": null,
      "CountryCode": "IN"
  },
  {
      "CityCode": "NAG",
      "ProvinceId": null,
      "CountryCode": "IN"
  },
  {
      "CityCode": "MYQ",
      "ProvinceId": null,
      "CountryCode": "IN"
  },
  {
      "CityCode": "PNQ",
      "ProvinceId": null,
      "CountryCode": "IN"
  },
  {
      "CityCode": "VNS",
      "ProvinceId": null,
      "CountryCode": "IN"
  },
  {
      "CityCode": "UDR",
      "ProvinceId": null,
      "CountryCode": "IN"
  },
  {
      "CityCode": "JGA",
      "ProvinceId": null,
      "CountryCode": "IN"
  },
  {
      "CityCode": "JDH",
      "ProvinceId": null,
      "CountryCode": "IN"
  },
  {
      "CityCode": "GOI",
      "ProvinceId": null,
      "CountryCode": "IN"
  },
  {
      "CityCode": "KUU",
      "ProvinceId": null,
      "CountryCode": "IN"
  },
  {
      "CityCode": "CJB",
      "ProvinceId": null,
      "CountryCode": "IN"
  },
  {
      "CityCode": "COK",
      "ProvinceId": null,
      "CountryCode": "IN"
  },
  {
      "CityCode": "BBI",
      "ProvinceId": null,
      "CountryCode": "IN"
  },
  {
      "CityCode": "BHO",
      "ProvinceId": null,
      "CountryCode": "IN"
  },
  {
      "CityCode": "BHJ",
      "ProvinceId": null,
      "CountryCode": "IN"
  },
  {
      "CityCode": "VTZ",
      "ProvinceId": null,
      "CountryCode": "IN"
  },
  {
      "CityCode": "AGR",
      "ProvinceId": null,
      "CountryCode": "IN"
  },
  {
      "CityCode": "JAI",
      "ProvinceId": null,
      "CountryCode": "IN"
  },
  {
      "CityCode": "IXB",
      "ProvinceId": null,
      "CountryCode": "IN"
  },
  {
      "CityCode": "IXE",
      "ProvinceId": null,
      "CountryCode": "IN"
  },
  {
      "CityCode": "IXJ",
      "ProvinceId": null,
      "CountryCode": "IN"
  },
  {
      "CityCode": "IXM",
      "ProvinceId": null,
      "CountryCode": "IN"
  },
  {
      "CityCode": "IXU",
      "ProvinceId": null,
      "CountryCode": "IN"
  },
  {
      "CityCode": "IXZ",
      "ProvinceId": null,
      "CountryCode": "IN"
  },
  {
      "CityCode": "MAA",
      "ProvinceId": null,
      "CountryCode": "IN"
  },
  {
      "CityCode": "LKO",
      "ProvinceId": null,
      "CountryCode": "IN"
  },
  {
      "CityCode": "SLV",
      "ProvinceId": null,
      "CountryCode": "IN"
  },
  {
      "CityCode": "PAT",
      "ProvinceId": null,
      "CountryCode": "IN"
  },
  {
      "CityCode": "PBD",
      "ProvinceId": null,
      "CountryCode": "IN"
  },
  {
      "CityCode": "DIU",
      "ProvinceId": null,
      "CountryCode": "IN"
  },
  {
      "CityCode": "DEL",
      "ProvinceId": null,
      "CountryCode": "IN"
  },
  {
      "CityCode": "HJR",
      "ProvinceId": null,
      "CountryCode": "IN"
  },
  {
      "CityCode": "HYD",
      "ProvinceId": null,
      "CountryCode": "IN"
  },
  {
      "CityCode": "AMD",
      "ProvinceId": null,
      "CountryCode": "IN"
  },
  {
      "CityCode": "BDQ",
      "ProvinceId": null,
      "CountryCode": "IN"
  },
  {
      "CityCode": "BLR",
      "ProvinceId": null,
      "CountryCode": "IN"
  },
  {
      "CityCode": "CCJ",
      "ProvinceId": null,
      "CountryCode": "IN"
  },
  {
      "CityCode": "CCU",
      "ProvinceId": null,
      "CountryCode": "IN"
  },
  {
      "CityCode": "BOM",
      "ProvinceId": null,
      "CountryCode": "IN"
  },
  {
      "CityCode": "BGW",
      "ProvinceId": null,
      "CountryCode": "IQ"
  },
  {
      "CityCode": "BSR",
      "ProvinceId": null,
      "CountryCode": "IQ"
  },
  {
      "CityCode": "AZD",
      "ProvinceId": null,
      "CountryCode": "IR"
  },
  {
      "CityCode": "CQD",
      "ProvinceId": null,
      "CountryCode": "IR"
  },
  {
      "CityCode": "KSH",
      "ProvinceId": null,
      "CountryCode": "IR"
  },
  {
      "CityCode": "KHD",
      "ProvinceId": null,
      "CountryCode": "IR"
  },
  {
      "CityCode": "KER",
      "ProvinceId": null,
      "CountryCode": "IR"
  },
  {
      "CityCode": "THR",
      "ProvinceId": null,
      "CountryCode": "IR"
  },
  {
      "CityCode": "SYZ",
      "ProvinceId": null,
      "CountryCode": "IR"
  },
  {
      "CityCode": "IFN",
      "ProvinceId": null,
      "CountryCode": "IR"
  },
  {
      "CityCode": "MHD",
      "ProvinceId": null,
      "CountryCode": "IR"
  },
  {
      "CityCode": "JWN",
      "ProvinceId": null,
      "CountryCode": "IR"
  },
  {
      "CityCode": "IFJ",
      "ProvinceId": null,
      "CountryCode": "IS"
  },
  {
      "CityCode": "EGS",
      "ProvinceId": null,
      "CountryCode": "IS"
  },
  {
      "CityCode": "AEY",
      "ProvinceId": null,
      "CountryCode": "IS"
  },
  {
      "CityCode": "REK",
      "ProvinceId": null,
      "CountryCode": "IS"
  },
  {
      "CityCode": "OPA",
      "ProvinceId": null,
      "CountryCode": "IS"
  },
  {
      "CityCode": "NAP",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "PEG",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "PEJ",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "QSR",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "QVA",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "PSR",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "REG",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "RAN",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "ROM",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "RMI",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "RRO",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "TFC",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "TRS",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "TPS",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "TQR",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "TRN",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "TSF",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "TTB",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "UDN",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "VIC",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "VIF",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "ZIA",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "SUL",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "GRS",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "GOA",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "GBN",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "FLR",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "LCV",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "MIL",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "CRV",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "OSI",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "IAN",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "QPR",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "AOI",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "BZO",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "CAG",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "BGY",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "BRI",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "IT2",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "AHO",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "ELL",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "PTF",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "LFI",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "LZ1",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "IT3",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "VCE",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "VRN",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "SUF",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "TAR",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "EBA",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "FRL",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "FOG",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "ISH",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "CUF",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "CTA",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "BLQ",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "BDS",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "ALL",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "LCC",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "OLB",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "PMF",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "PMO",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "PSA",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "PRJ",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "SAY",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "QPA",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "QBS",
      "ProvinceId": null,
      "CountryCode": "IT"
  },
  {
      "CityCode": "A05",
      "ProvinceId": null,
      "CountryCode": "JM"
  },
  {
      "CityCode": "SCT",
      "ProvinceId": null,
      "CountryCode": "JM"
  },
  {
      "CityCode": "PAN",
      "ProvinceId": null,
      "CountryCode": "JM"
  },
  {
      "CityCode": "TRY",
      "ProvinceId": null,
      "CountryCode": "JM"
  },
  {
      "CityCode": "STF",
      "ProvinceId": null,
      "CountryCode": "JM"
  },
  {
      "CityCode": "RHL",
      "ProvinceId": null,
      "CountryCode": "JM"
  },
  {
      "CityCode": "FRE",
      "ProvinceId": null,
      "CountryCode": "JM"
  },
  {
      "CityCode": "MBJ",
      "ProvinceId": null,
      "CountryCode": "JM"
  },
  {
      "CityCode": "KIN",
      "ProvinceId": null,
      "CountryCode": "JM"
  },
  {
      "CityCode": "NEG",
      "ProvinceId": null,
      "CountryCode": "JM"
  },
  {
      "CityCode": "OCJ",
      "ProvinceId": null,
      "CountryCode": "JM"
  },
  {
      "CityCode": "MPQ",
      "ProvinceId": null,
      "CountryCode": "JO"
  },
  {
      "CityCode": "AQJ",
      "ProvinceId": null,
      "CountryCode": "JO"
  },
  {
      "CityCode": "PE2",
      "ProvinceId": null,
      "CountryCode": "JO"
  },
  {
      "CityCode": "AMM",
      "ProvinceId": null,
      "CountryCode": "JO"
  },
  {
      "CityCode": "ASJ",
      "ProvinceId": null,
      "CountryCode": "JP"
  },
  {
      "CityCode": "AKJ",
      "ProvinceId": null,
      "CountryCode": "JP"
  },
  {
      "CityCode": "ISG",
      "ProvinceId": null,
      "CountryCode": "JP"
  },
  {
      "CityCode": "HKD",
      "ProvinceId": null,
      "CountryCode": "JP"
  },
  {
      "CityCode": "HNA",
      "ProvinceId": null,
      "CountryCode": "JP"
  },
  {
      "CityCode": "HAC",
      "ProvinceId": null,
      "CountryCode": "JP"
  },
  {
      "CityCode": "FUJ",
      "ProvinceId": null,
      "CountryCode": "JP"
  },
  {
      "CityCode": "FUK",
      "ProvinceId": null,
      "CountryCode": "JP"
  },
  {
      "CityCode": "ONJ",
      "ProvinceId": null,
      "CountryCode": "JP"
  },
  {
      "CityCode": "OKE",
      "ProvinceId": null,
      "CountryCode": "JP"
  },
  {
      "CityCode": "OKJ",
      "ProvinceId": null,
      "CountryCode": "JP"
  },
  {
      "CityCode": "OIM",
      "ProvinceId": null,
      "CountryCode": "JP"
  },
  {
      "CityCode": "OIT",
      "ProvinceId": null,
      "CountryCode": "JP"
  },
  {
      "CityCode": "OKA",
      "ProvinceId": null,
      "CountryCode": "JP"
  },
  {
      "CityCode": "SHB",
      "ProvinceId": null,
      "CountryCode": "JP"
  },
  {
      "CityCode": "IWJ",
      "ProvinceId": null,
      "CountryCode": "JP"
  },
  {
      "CityCode": "IZO",
      "ProvinceId": null,
      "CountryCode": "JP"
  },
  {
      "CityCode": "KMI",
      "ProvinceId": null,
      "CountryCode": "JP"
  },
  {
      "CityCode": "KMJ",
      "ProvinceId": null,
      "CountryCode": "JP"
  },
  {
      "CityCode": "KMQ",
      "ProvinceId": null,
      "CountryCode": "JP"
  },
  {
      "CityCode": "KOJ",
      "ProvinceId": null,
      "CountryCode": "JP"
  },
  {
      "CityCode": "MMB",
      "ProvinceId": null,
      "CountryCode": "JP"
  },
  {
      "CityCode": "NGO",
      "ProvinceId": null,
      "CountryCode": "JP"
  },
  {
      "CityCode": "NGS",
      "ProvinceId": null,
      "CountryCode": "JP"
  },
  {
      "CityCode": "MMJ",
      "ProvinceId": null,
      "CountryCode": "JP"
  },
  {
      "CityCode": "MMY",
      "ProvinceId": null,
      "CountryCode": "JP"
  },
  {
      "CityCode": "TKS",
      "ProvinceId": null,
      "CountryCode": "JP"
  },
  {
      "CityCode": "TYO",
      "ProvinceId": null,
      "CountryCode": "JP"
  },
  {
      "CityCode": "UBJ",
      "ProvinceId": null,
      "CountryCode": "JP"
  },
  {
      "CityCode": "TNE",
      "ProvinceId": null,
      "CountryCode": "JP"
  },
  {
      "CityCode": "YGJ",
      "ProvinceId": null,
      "CountryCode": "JP"
  },
  {
      "CityCode": "AOJ",
      "ProvinceId": null,
      "CountryCode": "JP"
  },
  {
      "CityCode": "AXT",
      "ProvinceId": null,
      "CountryCode": "JP"
  },
  {
      "CityCode": "MSJ",
      "ProvinceId": null,
      "CountryCode": "JP"
  },
  {
      "CityCode": "KKJ",
      "ProvinceId": null,
      "CountryCode": "JP"
  },
  {
      "CityCode": "KIJ",
      "ProvinceId": null,
      "CountryCode": "JP"
  },
  {
      "CityCode": "KUH",
      "ProvinceId": null,
      "CountryCode": "JP"
  },
  {
      "CityCode": "FKS",
      "ProvinceId": null,
      "CountryCode": "JP"
  },
  {
      "CityCode": "GAJ",
      "ProvinceId": null,
      "CountryCode": "JP"
  },
  {
      "CityCode": "KCZ",
      "ProvinceId": null,
      "CountryCode": "JP"
  },
  {
      "CityCode": "HIJ",
      "ProvinceId": null,
      "CountryCode": "JP"
  },
  {
      "CityCode": "HSG",
      "ProvinceId": null,
      "CountryCode": "JP"
  },
  {
      "CityCode": "OBO",
      "ProvinceId": null,
      "CountryCode": "JP"
  },
  {
      "CityCode": "OSA",
      "ProvinceId": null,
      "CountryCode": "JP"
  },
  {
      "CityCode": "NRT",
      "ProvinceId": null,
      "CountryCode": "JP"
  },
  {
      "CityCode": "MYJ",
      "ProvinceId": null,
      "CountryCode": "JP"
  },
  {
      "CityCode": "TSJ",
      "ProvinceId": null,
      "CountryCode": "JP"
  },
  {
      "CityCode": "TTJ",
      "ProvinceId": null,
      "CountryCode": "JP"
  },
  {
      "CityCode": "TKN",
      "ProvinceId": null,
      "CountryCode": "JP"
  },
  {
      "CityCode": "TOY",
      "ProvinceId": null,
      "CountryCode": "JP"
  },
  {
      "CityCode": "SYO",
      "ProvinceId": null,
      "CountryCode": "JP"
  },
  {
      "CityCode": "TAK",
      "ProvinceId": null,
      "CountryCode": "JP"
  },
  {
      "CityCode": "SPK",
      "ProvinceId": null,
      "CountryCode": "JP"
  },
  {
      "CityCode": "SDJ",
      "ProvinceId": null,
      "CountryCode": "JP"
  },
  {
      "CityCode": "YOK",
      "ProvinceId": null,
      "CountryCode": "JP"
  },
  {
      "CityCode": "UEO",
      "ProvinceId": null,
      "CountryCode": "JP"
  },
  {
      "CityCode": "UKY",
      "ProvinceId": null,
      "CountryCode": "JP"
  },
  {
      "CityCode": "WKJ",
      "ProvinceId": null,
      "CountryCode": "JP"
  },
  {
      "CityCode": "MYD",
      "ProvinceId": null,
      "CountryCode": "KE"
  },
  {
      "CityCode": "NBO",
      "ProvinceId": null,
      "CountryCode": "KE"
  },
  {
      "CityCode": "NYE",
      "ProvinceId": null,
      "CountryCode": "KE"
  },
  {
      "CityCode": "NYK",
      "ProvinceId": null,
      "CountryCode": "KE"
  },
  {
      "CityCode": "KIS",
      "ProvinceId": null,
      "CountryCode": "KE"
  },
  {
      "CityCode": "MRE",
      "ProvinceId": null,
      "CountryCode": "KE"
  },
  {
      "CityCode": "MBA",
      "ProvinceId": null,
      "CountryCode": "KE"
  },
  {
      "CityCode": "UAS",
      "ProvinceId": null,
      "CountryCode": "KE"
  },
  {
      "CityCode": "LKG",
      "ProvinceId": null,
      "CountryCode": "KE"
  },
  {
      "CityCode": "EDL",
      "ProvinceId": null,
      "CountryCode": "KE"
  },
  {
      "CityCode": "FRU",
      "ProvinceId": null,
      "CountryCode": "KG"
  },
  {
      "CityCode": "PNH",
      "ProvinceId": null,
      "CountryCode": "KH"
  },
  {
      "CityCode": "REP",
      "ProvinceId": null,
      "CountryCode": "KH"
  },
  {
      "CityCode": "TRW",
      "ProvinceId": null,
      "CountryCode": "KI"
  },
  {
      "CityCode": "MNK",
      "ProvinceId": null,
      "CountryCode": "KI"
  },
  {
      "CityCode": "YVA",
      "ProvinceId": null,
      "CountryCode": "KM"
  },
  {
      "CityCode": "SKB",
      "ProvinceId": null,
      "CountryCode": "KN"
  },
  {
      "CityCode": "NEV",
      "ProvinceId": null,
      "CountryCode": "KN"
  },
  {
      "CityCode": "KPO",
      "ProvinceId": null,
      "CountryCode": "KR"
  },
  {
      "CityCode": "SHO",
      "ProvinceId": null,
      "CountryCode": "KR"
  },
  {
      "CityCode": "CJU",
      "ProvinceId": null,
      "CountryCode": "KR"
  },
  {
      "CityCode": "CJJ",
      "ProvinceId": null,
      "CountryCode": "KR"
  },
  {
      "CityCode": "USN",
      "ProvinceId": null,
      "CountryCode": "KR"
  },
  {
      "CityCode": "QTW",
      "ProvinceId": null,
      "CountryCode": "KR"
  },
  {
      "CityCode": "SEL",
      "ProvinceId": null,
      "CountryCode": "KR"
  },
  {
      "CityCode": "RSU",
      "ProvinceId": null,
      "CountryCode": "KR"
  },
  {
      "CityCode": "TAE",
      "ProvinceId": null,
      "CountryCode": "KR"
  },
  {
      "CityCode": "PUS",
      "ProvinceId": null,
      "CountryCode": "KR"
  },
  {
      "CityCode": "KUV",
      "ProvinceId": null,
      "CountryCode": "KR"
  },
  {
      "CityCode": "KWJ",
      "ProvinceId": null,
      "CountryCode": "KR"
  },
  {
      "CityCode": "HIN",
      "ProvinceId": null,
      "CountryCode": "KR"
  },
  {
      "CityCode": "KWI",
      "ProvinceId": null,
      "CountryCode": "KW"
  },
  {
      "CityCode": "GCM",
      "ProvinceId": null,
      "CountryCode": "KY"
  },
  {
      "CityCode": "CYB",
      "ProvinceId": null,
      "CountryCode": "KY"
  },
  {
      "CityCode": "LYB",
      "ProvinceId": null,
      "CountryCode": "KY"
  },
  {
      "CityCode": "ALA",
      "ProvinceId": null,
      "CountryCode": "KZ"
  },
  {
      "CityCode": "CIT",
      "ProvinceId": null,
      "CountryCode": "KZ"
  },
  {
      "CityCode": "TSE",
      "ProvinceId": null,
      "CountryCode": "KZ"
  },
  {
      "CityCode": "UKK",
      "ProvinceId": null,
      "CountryCode": "KZ"
  },
  {
      "CityCode": "VTE",
      "ProvinceId": null,
      "CountryCode": "LA"
  },
  {
      "CityCode": "BEY",
      "ProvinceId": null,
      "CountryCode": "LB"
  },
  {
      "CityCode": "UVF",
      "ProvinceId": null,
      "CountryCode": "LC"
  },
  {
      "CityCode": "GIU",
      "ProvinceId": null,
      "CountryCode": "LK"
  },
  {
      "CityCode": "CMB",
      "ProvinceId": null,
      "CountryCode": "LK"
  },
  {
      "CityCode": "MLW",
      "ProvinceId": null,
      "CountryCode": "LR"
  },
  {
      "CityCode": "SNI",
      "ProvinceId": null,
      "CountryCode": "LR"
  },
  {
      "CityCode": "MSU",
      "ProvinceId": null,
      "CountryCode": "LS"
  },
  {
      "CityCode": "LES",
      "ProvinceId": null,
      "CountryCode": "LS"
  },
  {
      "CityCode": "KUN",
      "ProvinceId": null,
      "CountryCode": "LT"
  },
  {
      "CityCode": "KLJ",
      "ProvinceId": null,
      "CountryCode": "LT"
  },
  {
      "CityCode": "VNO",
      "ProvinceId": null,
      "CountryCode": "LT"
  },
  {
      "CityCode": "PLQ",
      "ProvinceId": null,
      "CountryCode": "LT"
  },
  {
      "CityCode": "LUX",
      "ProvinceId": null,
      "CountryCode": "LU"
  },
  {
      "CityCode": "RIX",
      "ProvinceId": null,
      "CountryCode": "LV"
  },
  {
      "CityCode": "DGP",
      "ProvinceId": null,
      "CountryCode": "LV"
  },
  {
      "CityCode": "LPX",
      "ProvinceId": null,
      "CountryCode": "LV"
  },
  {
      "CityCode": "TIP",
      "ProvinceId": null,
      "CountryCode": "LY"
  },
  {
      "CityCode": "BEN",
      "ProvinceId": null,
      "CountryCode": "LY"
  },
  {
      "CityCode": "TOB",
      "ProvinceId": null,
      "CountryCode": "LY"
  },
  {
      "CityCode": "TNG",
      "ProvinceId": null,
      "CountryCode": "MA"
  },
  {
      "CityCode": "AHU",
      "ProvinceId": null,
      "CountryCode": "MA"
  },
  {
      "CityCode": "AGA",
      "ProvinceId": null,
      "CountryCode": "MA"
  },
  {
      "CityCode": "ESU",
      "ProvinceId": null,
      "CountryCode": "MA"
  },
  {
      "CityCode": "EUN",
      "ProvinceId": null,
      "CountryCode": "MA"
  },
  {
      "CityCode": "OZZ",
      "ProvinceId": null,
      "CountryCode": "MA"
  },
  {
      "CityCode": "RAK",
      "ProvinceId": null,
      "CountryCode": "MA"
  },
  {
      "CityCode": "RBA",
      "ProvinceId": null,
      "CountryCode": "MA"
  },
  {
      "CityCode": "NDR",
      "ProvinceId": null,
      "CountryCode": "MA"
  },
  {
      "CityCode": "OUD",
      "ProvinceId": null,
      "CountryCode": "MA"
  },
  {
      "CityCode": "VIL",
      "ProvinceId": null,
      "CountryCode": "MA"
  },
  {
      "CityCode": "FEZ",
      "ProvinceId": null,
      "CountryCode": "MA"
  },
  {
      "CityCode": "CAS",
      "ProvinceId": null,
      "CountryCode": "MA"
  },
  {
      "CityCode": "MCM",
      "ProvinceId": null,
      "CountryCode": "MC"
  },
  {
      "CityCode": "KIV",
      "ProvinceId": null,
      "CountryCode": "MD"
  },
  {
      "CityCode": "MV8",
      "ProvinceId": null,
      "CountryCode": "MD"
  },
  {
      "CityCode": "TMM",
      "ProvinceId": null,
      "CountryCode": "MG"
  },
  {
      "CityCode": "TNR",
      "ProvinceId": null,
      "CountryCode": "MG"
  },
  {
      "CityCode": "TLE",
      "ProvinceId": null,
      "CountryCode": "MG"
  },
  {
      "CityCode": "NOS",
      "ProvinceId": null,
      "CountryCode": "MG"
  },
  {
      "CityCode": "SMS",
      "ProvinceId": null,
      "CountryCode": "MG"
  },
  {
      "CityCode": "MOQ",
      "ProvinceId": null,
      "CountryCode": "MG"
  },
  {
      "CityCode": "MJN",
      "ProvinceId": null,
      "CountryCode": "MG"
  },
  {
      "CityCode": "MAJ",
      "ProvinceId": null,
      "CountryCode": "MH"
  },
  {
      "CityCode": "KWA",
      "ProvinceId": null,
      "CountryCode": "MH"
  },
  {
      "CityCode": "BII",
      "ProvinceId": null,
      "CountryCode": "MH"
  },
  {
      "CityCode": "SKP",
      "ProvinceId": null,
      "CountryCode": "MK"
  },
  {
      "CityCode": "OHD",
      "ProvinceId": null,
      "CountryCode": "MK"
  },
  {
      "CityCode": "MZI",
      "ProvinceId": null,
      "CountryCode": "ML"
  },
  {
      "CityCode": "BKO",
      "ProvinceId": null,
      "CountryCode": "ML"
  },
  {
      "CityCode": "MDL",
      "ProvinceId": null,
      "CountryCode": "MM"
  },
  {
      "CityCode": "HEH",
      "ProvinceId": null,
      "CountryCode": "MM"
  },
  {
      "CityCode": "NYU",
      "ProvinceId": null,
      "CountryCode": "MM"
  },
  {
      "CityCode": "RGN",
      "ProvinceId": null,
      "CountryCode": "MM"
  },
  {
      "CityCode": "ULN",
      "ProvinceId": null,
      "CountryCode": "MN"
  },
  {
      "CityCode": "MFM",
      "ProvinceId": null,
      "CountryCode": "MO"
  },
  {
      "CityCode": "SPN",
      "ProvinceId": null,
      "CountryCode": "MP"
  },
  {
      "CityCode": "ROP",
      "ProvinceId": null,
      "CountryCode": "MP"
  },
  {
      "CityCode": "TIQ",
      "ProvinceId": null,
      "CountryCode": "MP"
  },
  {
      "CityCode": "FDF",
      "ProvinceId": null,
      "CountryCode": "MQ"
  },
  {
      "CityCode": "NDB",
      "ProvinceId": null,
      "CountryCode": "MR"
  },
  {
      "CityCode": "NKC",
      "ProvinceId": null,
      "CountryCode": "MR"
  },
  {
      "CityCode": "GZM",
      "ProvinceId": null,
      "CountryCode": "MT"
  },
  {
      "CityCode": "MLA",
      "ProvinceId": null,
      "CountryCode": "MT"
  },
  {
      "CityCode": "MRU",
      "ProvinceId": null,
      "CountryCode": "MU"
  },
  {
      "CityCode": "RRG",
      "ProvinceId": null,
      "CountryCode": "MU"
  },
  {
      "CityCode": "MLE",
      "ProvinceId": null,
      "CountryCode": "MV"
  },
  {
      "CityCode": "LLW",
      "ProvinceId": null,
      "CountryCode": "MW"
  },
  {
      "CityCode": "CEH",
      "ProvinceId": null,
      "CountryCode": "MW"
  },
  {
      "CityCode": "BLZ",
      "ProvinceId": null,
      "CountryCode": "MW"
  },
  {
      "CityCode": "CEN",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "CME",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "CJS",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "CLQ",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "CUL",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "CUN",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "CTM",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "ACA",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "GYM",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "GMO",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "HMO",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "HUX",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "ISJ",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "IH1",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "DGO",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "CVJ",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "CUA",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "CV2",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "CUU",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "LMM",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "LAP",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "IZT",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "JAL",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "JV3",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "MMC",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "MLM",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "MEX",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "LZC",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "NLD",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "MXL",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "MTY",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "MTT",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "RH1",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "QRO",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "RM4",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "SLW",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "SNQ",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "SG2",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "SG3",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "SFH",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "PAZ",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "PBC",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "PDS",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "PC1",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "PCM",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "NOG",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "PQM",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "PXM",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "TM1",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "TLC",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "TCN",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "TAP",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "TZ9",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "UAC",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "VSA",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "XAL",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "XV1",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "CI1",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "SL1",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "CL1",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "IP1",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "PT2",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "AK5",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "M12",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "AGU",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "M01",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "M20",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "M02",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "M13",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "TE2",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "M21",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "M17",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "M15",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "M18",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "M04",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "M09",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "M03",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "CMJ",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "SCX",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "REX",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "RNA",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "SLP",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "SJD",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "TIJ",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "TGZ",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "TRC",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "TQ1",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "TPQ",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "TT1",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "SZT",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "TAM",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "TG1",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "TG4",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "SRL",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "SQ2",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "MZT",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "OAX",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "OT2",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "XH1",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "PT3",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "CV1",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "VL1",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "BC2",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "CR1",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "FR1",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "PB1",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "UA1",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "CH1",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "CM1",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "CC1",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "TJ1",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "SL2",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "PT4",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "UX1",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "QTZ",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "PV4",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "PVR",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "PPE",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "PNO",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "UPN",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "VER",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "VIB",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "VM2",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "ZIH",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "ZLO",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "ZCL",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "ZP3",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "MID",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "MAM",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "LTO",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "LOM",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "LOV",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "GDL",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "GG2",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "M22",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "M06",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "M07",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "TCT",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "HP2",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "HT2",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "BJX",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "BHL",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "M10",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "M19",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "AZG",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "BC1",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "M16",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "M14",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "NVR",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "PV3",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "CZ3",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "CZ2",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "CZ1",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "ESE",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "CTR",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "VA4",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "A06",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "EM1",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "M11",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "CZM",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "CZA",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "CY1",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "CVM",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "CP1",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "CO1",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "CPE",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "AOR",
      "ProvinceId": null,
      "CountryCode": "MY"
  },
  {
      "CityCode": "BKI",
      "ProvinceId": null,
      "CountryCode": "MY"
  },
  {
      "CityCode": "KCH",
      "ProvinceId": null,
      "CountryCode": "MY"
  },
  {
      "CityCode": "KBR",
      "ProvinceId": null,
      "CountryCode": "MY"
  },
  {
      "CityCode": "JHB",
      "ProvinceId": null,
      "CountryCode": "MY"
  },
  {
      "CityCode": "IPH",
      "ProvinceId": null,
      "CountryCode": "MY"
  },
  {
      "CityCode": "LGK",
      "ProvinceId": null,
      "CountryCode": "MY"
  },
  {
      "CityCode": "LDU",
      "ProvinceId": null,
      "CountryCode": "MY"
  },
  {
      "CityCode": "KUA",
      "ProvinceId": null,
      "CountryCode": "MY"
  },
  {
      "CityCode": "KUL",
      "ProvinceId": null,
      "CountryCode": "MY"
  },
  {
      "CityCode": "KTE",
      "ProvinceId": null,
      "CountryCode": "MY"
  },
  {
      "CityCode": "MKM",
      "ProvinceId": null,
      "CountryCode": "MY"
  },
  {
      "CityCode": "MKZ",
      "ProvinceId": null,
      "CountryCode": "MY"
  },
  {
      "CityCode": "PEN",
      "ProvinceId": null,
      "CountryCode": "MY"
  },
  {
      "CityCode": "MYY",
      "ProvinceId": null,
      "CountryCode": "MY"
  },
  {
      "CityCode": "TGG",
      "ProvinceId": null,
      "CountryCode": "MY"
  },
  {
      "CityCode": "SDK",
      "ProvinceId": null,
      "CountryCode": "MY"
  },
  {
      "CityCode": "TWU",
      "ProvinceId": null,
      "CountryCode": "MY"
  },
  {
      "CityCode": "TOD",
      "ProvinceId": null,
      "CountryCode": "MY"
  },
  {
      "CityCode": "PKG",
      "ProvinceId": null,
      "CountryCode": "MY"
  },
  {
      "CityCode": "SBW",
      "ProvinceId": null,
      "CountryCode": "MY"
  },
  {
      "CityCode": "MUR",
      "ProvinceId": null,
      "CountryCode": "MY"
  },
  {
      "CityCode": "LWY",
      "ProvinceId": null,
      "CountryCode": "MY"
  },
  {
      "CityCode": "LBU",
      "ProvinceId": null,
      "CountryCode": "MY"
  },
  {
      "CityCode": "LMN",
      "ProvinceId": null,
      "CountryCode": "MY"
  },
  {
      "CityCode": "LKH",
      "ProvinceId": null,
      "CountryCode": "MY"
  },
  {
      "CityCode": "BEW",
      "ProvinceId": null,
      "CountryCode": "MZ"
  },
  {
      "CityCode": "TET",
      "ProvinceId": null,
      "CountryCode": "MZ"
  },
  {
      "CityCode": "VNX",
      "ProvinceId": null,
      "CountryCode": "MZ"
  },
  {
      "CityCode": "MPM",
      "ProvinceId": null,
      "CountryCode": "MZ"
  },
  {
      "CityCode": "APL",
      "ProvinceId": null,
      "CountryCode": "MZ"
  },
  {
      "CityCode": "WDH",
      "ProvinceId": null,
      "CountryCode": "NA"
  },
  {
      "CityCode": "WVB",
      "ProvinceId": null,
      "CountryCode": "NA"
  },
  {
      "CityCode": "RHN",
      "ProvinceId": null,
      "CountryCode": "NA"
  },
  {
      "CityCode": "NOU",
      "ProvinceId": null,
      "CountryCode": "NC"
  },
  {
      "CityCode": "KOC",
      "ProvinceId": null,
      "CountryCode": "NC"
  },
  {
      "CityCode": "LIF",
      "ProvinceId": null,
      "CountryCode": "NC"
  },
  {
      "CityCode": "ILP",
      "ProvinceId": null,
      "CountryCode": "NC"
  },
  {
      "CityCode": "NIM",
      "ProvinceId": null,
      "CountryCode": "NE"
  },
  {
      "CityCode": "KAN",
      "ProvinceId": null,
      "CountryCode": "NG"
  },
  {
      "CityCode": "ABV",
      "ProvinceId": null,
      "CountryCode": "NG"
  },
  {
      "CityCode": "LOS",
      "ProvinceId": null,
      "CountryCode": "NG"
  },
  {
      "CityCode": "PHC",
      "ProvinceId": null,
      "CountryCode": "NG"
  },
  {
      "CityCode": "OA9",
      "ProvinceId": "BOC",
      "CountryCode": "NI"
  },
  {
      "CityCode": "SJN",
      "ProvinceId": "",
      "CountryCode": "NI"
  },
  {
      "CityCode": "CH9",
      "ProvinceId": "CHI",
      "CountryCode": "NI"
  },
  {
      "CityCode": "OCT",
      "ProvinceId": "NSG",
      "CountryCode": "NI"
  },
  {
      "CityCode": "GN9",
      "ProvinceId": "GRA",
      "CountryCode": "NI"
  },
  {
      "CityCode": "JGP",
      "ProvinceId": "CHO",
      "CountryCode": "NI"
  },
  {
      "CityCode": "JN9",
      "ProvinceId": "JIN",
      "CountryCode": "NI"
  },
  {
      "CityCode": "JI9",
      "ProvinceId": null,
      "CountryCode": "NI"
  },
  {
      "CityCode": "MGA",
      "ProvinceId": null,
      "CountryCode": "NI"
  },
  {
      "CityCode": "MY9",
      "ProvinceId": "MAS",
      "CountryCode": "NI"
  },
  {
      "CityCode": "MT9",
      "ProvinceId": "MAT",
      "CountryCode": "NI"
  },
  {
      "CityCode": "LN9",
      "ProvinceId": "LEO",
      "CountryCode": "NI"
  },
  {
      "CityCode": "PUZ",
      "ProvinceId": "RAA",
      "CountryCode": "NI"
  },
  {
      "CityCode": "NCR",
      "ProvinceId": "RSJ",
      "CountryCode": "NI"
  },
  {
      "CityCode": "ECI",
      "ProvinceId": "RIV",
      "CountryCode": "NI"
  },
  {
      "CityCode": "OM9",
      "ProvinceId": "MDR",
      "CountryCode": "NI"
  },
  {
      "CityCode": "BEF",
      "ProvinceId": "RAS",
      "CountryCode": "NI"
  },
  {
      "CityCode": "ET9",
      "ProvinceId": "EST",
      "CountryCode": "NI"
  },
  {
      "CityCode": "UTC",
      "ProvinceId": null,
      "CountryCode": "NL"
  },
  {
      "CityCode": "AMS",
      "ProvinceId": null,
      "CountryCode": "NL"
  },
  {
      "CityCode": "EIN",
      "ProvinceId": null,
      "CountryCode": "NL"
  },
  {
      "CityCode": "HAG",
      "ProvinceId": null,
      "CountryCode": "NL"
  },
  {
      "CityCode": "ENS",
      "ProvinceId": null,
      "CountryCode": "NL"
  },
  {
      "CityCode": "LID",
      "ProvinceId": null,
      "CountryCode": "NL"
  },
  {
      "CityCode": "LEY",
      "ProvinceId": null,
      "CountryCode": "NL"
  },
  {
      "CityCode": "GRQ",
      "ProvinceId": null,
      "CountryCode": "NL"
  },
  {
      "CityCode": "MST",
      "ProvinceId": null,
      "CountryCode": "NL"
  },
  {
      "CityCode": "RTM",
      "ProvinceId": null,
      "CountryCode": "NL"
  },
  {
      "CityCode": "UDE",
      "ProvinceId": null,
      "CountryCode": "NL"
  },
  {
      "CityCode": "TRD",
      "ProvinceId": null,
      "CountryCode": "NO"
  },
  {
      "CityCode": "SRP",
      "ProvinceId": null,
      "CountryCode": "NO"
  },
  {
      "CityCode": "SVJ",
      "ProvinceId": null,
      "CountryCode": "NO"
  },
  {
      "CityCode": "SSJ",
      "ProvinceId": null,
      "CountryCode": "NO"
  },
  {
      "CityCode": "RVK",
      "ProvinceId": null,
      "CountryCode": "NO"
  },
  {
      "CityCode": "RRS",
      "ProvinceId": null,
      "CountryCode": "NO"
  },
  {
      "CityCode": "SDN",
      "ProvinceId": null,
      "CountryCode": "NO"
  },
  {
      "CityCode": "SKE",
      "ProvinceId": null,
      "CountryCode": "NO"
  },
  {
      "CityCode": "SKN",
      "ProvinceId": null,
      "CountryCode": "NO"
  },
  {
      "CityCode": "NTB",
      "ProvinceId": null,
      "CountryCode": "NO"
  },
  {
      "CityCode": "NVK",
      "ProvinceId": null,
      "CountryCode": "NO"
  },
  {
      "CityCode": "OSL",
      "ProvinceId": null,
      "CountryCode": "NO"
  },
  {
      "CityCode": "OSY",
      "ProvinceId": null,
      "CountryCode": "NO"
  },
  {
      "CityCode": "VDS",
      "ProvinceId": null,
      "CountryCode": "NO"
  },
  {
      "CityCode": "HAU",
      "ProvinceId": null,
      "CountryCode": "NO"
  },
  {
      "CityCode": "HOV",
      "ProvinceId": null,
      "CountryCode": "NO"
  },
  {
      "CityCode": "HFT",
      "ProvinceId": null,
      "CountryCode": "NO"
  },
  {
      "CityCode": "KSU",
      "ProvinceId": null,
      "CountryCode": "NO"
  },
  {
      "CityCode": "KRS",
      "ProvinceId": null,
      "CountryCode": "NO"
  },
  {
      "CityCode": "KKN",
      "ProvinceId": null,
      "CountryCode": "NO"
  },
  {
      "CityCode": "MQN",
      "ProvinceId": null,
      "CountryCode": "NO"
  },
  {
      "CityCode": "MJF",
      "ProvinceId": null,
      "CountryCode": "NO"
  },
  {
      "CityCode": "FDE",
      "ProvinceId": null,
      "CountryCode": "NO"
  },
  {
      "CityCode": "ANX",
      "ProvinceId": null,
      "CountryCode": "NO"
  },
  {
      "CityCode": "GLL",
      "ProvinceId": null,
      "CountryCode": "NO"
  },
  {
      "CityCode": "HVG",
      "ProvinceId": null,
      "CountryCode": "NO"
  },
  {
      "CityCode": "HMR",
      "ProvinceId": null,
      "CountryCode": "NO"
  },
  {
      "CityCode": "EVE",
      "ProvinceId": null,
      "CountryCode": "NO"
  },
  {
      "CityCode": "FRO",
      "ProvinceId": null,
      "CountryCode": "NO"
  },
  {
      "CityCode": "DLD",
      "ProvinceId": null,
      "CountryCode": "NO"
  },
  {
      "CityCode": "ALF",
      "ProvinceId": null,
      "CountryCode": "NO"
  },
  {
      "CityCode": "BGO",
      "ProvinceId": null,
      "CountryCode": "NO"
  },
  {
      "CityCode": "BDU",
      "ProvinceId": null,
      "CountryCode": "NO"
  },
  {
      "CityCode": "BNN",
      "ProvinceId": null,
      "CountryCode": "NO"
  },
  {
      "CityCode": "BOO",
      "ProvinceId": null,
      "CountryCode": "NO"
  },
  {
      "CityCode": "LYR",
      "ProvinceId": null,
      "CountryCode": "NO"
  },
  {
      "CityCode": "MEH",
      "ProvinceId": null,
      "CountryCode": "NO"
  },
  {
      "CityCode": "MOL",
      "ProvinceId": null,
      "CountryCode": "NO"
  },
  {
      "CityCode": "LKL",
      "ProvinceId": null,
      "CountryCode": "NO"
  },
  {
      "CityCode": "LKN",
      "ProvinceId": null,
      "CountryCode": "NO"
  },
  {
      "CityCode": "QFQ",
      "ProvinceId": null,
      "CountryCode": "NO"
  },
  {
      "CityCode": "SOG",
      "ProvinceId": null,
      "CountryCode": "NO"
  },
  {
      "CityCode": "TOS",
      "ProvinceId": null,
      "CountryCode": "NO"
  },
  {
      "CityCode": "SVG",
      "ProvinceId": null,
      "CountryCode": "NO"
  },
  {
      "CityCode": "VAW",
      "ProvinceId": null,
      "CountryCode": "NO"
  },
  {
      "CityCode": "VDB",
      "ProvinceId": null,
      "CountryCode": "NO"
  },
  {
      "CityCode": "XKJ",
      "ProvinceId": null,
      "CountryCode": "NO"
  },
  {
      "CityCode": "ZXO",
      "ProvinceId": null,
      "CountryCode": "NO"
  },
  {
      "CityCode": "XXL",
      "ProvinceId": null,
      "CountryCode": "NO"
  },
  {
      "CityCode": "AES",
      "ProvinceId": null,
      "CountryCode": "NO"
  },
  {
      "CityCode": "PKR",
      "ProvinceId": null,
      "CountryCode": "NP"
  },
  {
      "CityCode": "PPL",
      "ProvinceId": null,
      "CountryCode": "NP"
  },
  {
      "CityCode": "KTM",
      "ProvinceId": null,
      "CountryCode": "NP"
  },
  {
      "CityCode": "INU",
      "ProvinceId": null,
      "CountryCode": "NR"
  },
  {
      "CityCode": "IUE",
      "ProvinceId": null,
      "CountryCode": "NU"
  },
  {
      "CityCode": "IVC",
      "ProvinceId": null,
      "CountryCode": "NZ"
  },
  {
      "CityCode": "HLZ",
      "ProvinceId": null,
      "CountryCode": "NZ"
  },
  {
      "CityCode": "GIS",
      "ProvinceId": null,
      "CountryCode": "NZ"
  },
  {
      "CityCode": "HKK",
      "ProvinceId": null,
      "CountryCode": "NZ"
  },
  {
      "CityCode": "CMV",
      "ProvinceId": null,
      "CountryCode": "NZ"
  },
  {
      "CityCode": "AKL",
      "ProvinceId": null,
      "CountryCode": "NZ"
  },
  {
      "CityCode": "PPQ",
      "ProvinceId": null,
      "CountryCode": "NZ"
  },
  {
      "CityCode": "NPE",
      "ProvinceId": null,
      "CountryCode": "NZ"
  },
  {
      "CityCode": "NPL",
      "ProvinceId": null,
      "CountryCode": "NZ"
  },
  {
      "CityCode": "PCN",
      "ProvinceId": null,
      "CountryCode": "NZ"
  },
  {
      "CityCode": "MON",
      "ProvinceId": null,
      "CountryCode": "NZ"
  },
  {
      "CityCode": "MFN",
      "ProvinceId": null,
      "CountryCode": "NZ"
  },
  {
      "CityCode": "ZQN",
      "ProvinceId": null,
      "CountryCode": "NZ"
  },
  {
      "CityCode": "WAG",
      "ProvinceId": null,
      "CountryCode": "NZ"
  },
  {
      "CityCode": "TEU",
      "ProvinceId": null,
      "CountryCode": "NZ"
  },
  {
      "CityCode": "TUO",
      "ProvinceId": null,
      "CountryCode": "NZ"
  },
  {
      "CityCode": "TMZ",
      "ProvinceId": null,
      "CountryCode": "NZ"
  },
  {
      "CityCode": "KAT",
      "ProvinceId": null,
      "CountryCode": "NZ"
  },
  {
      "CityCode": "GBZ",
      "ProvinceId": null,
      "CountryCode": "NZ"
  },
  {
      "CityCode": "KKE",
      "ProvinceId": null,
      "CountryCode": "NZ"
  },
  {
      "CityCode": "MRO",
      "ProvinceId": null,
      "CountryCode": "NZ"
  },
  {
      "CityCode": "BHE",
      "ProvinceId": null,
      "CountryCode": "NZ"
  },
  {
      "CityCode": "DUD",
      "ProvinceId": null,
      "CountryCode": "NZ"
  },
  {
      "CityCode": "CHC",
      "ProvinceId": null,
      "CountryCode": "NZ"
  },
  {
      "CityCode": "WSZ",
      "ProvinceId": null,
      "CountryCode": "NZ"
  },
  {
      "CityCode": "WKA",
      "ProvinceId": null,
      "CountryCode": "NZ"
  },
  {
      "CityCode": "WRE",
      "ProvinceId": null,
      "CountryCode": "NZ"
  },
  {
      "CityCode": "WLG",
      "ProvinceId": null,
      "CountryCode": "NZ"
  },
  {
      "CityCode": "WHK",
      "ProvinceId": null,
      "CountryCode": "NZ"
  },
  {
      "CityCode": "OAM",
      "ProvinceId": null,
      "CountryCode": "NZ"
  },
  {
      "CityCode": "NSN",
      "ProvinceId": null,
      "CountryCode": "NZ"
  },
  {
      "CityCode": "PMR",
      "ProvinceId": null,
      "CountryCode": "NZ"
  },
  {
      "CityCode": "ROT",
      "ProvinceId": null,
      "CountryCode": "NZ"
  },
  {
      "CityCode": "TRG",
      "ProvinceId": null,
      "CountryCode": "NZ"
  },
  {
      "CityCode": "TIU",
      "ProvinceId": null,
      "CountryCode": "NZ"
  },
  {
      "CityCode": "SLL",
      "ProvinceId": null,
      "CountryCode": "OM"
  },
  {
      "CityCode": "MCT",
      "ProvinceId": null,
      "CountryCode": "OM"
  },
  {
      "CityCode": "SUH",
      "ProvinceId": null,
      "CountryCode": "OM"
  },
  {
      "CityCode": "ONX",
      "ProvinceId": null,
      "CountryCode": "PA"
  },
  {
      "CityCode": "BOC",
      "ProvinceId": null,
      "CountryCode": "PA"
  },
  {
      "CityCode": "CHX",
      "ProvinceId": null,
      "CountryCode": "PA"
  },
  {
      "CityCode": "DAV",
      "ProvinceId": null,
      "CountryCode": "PA"
  },
  {
      "CityCode": "A07",
      "ProvinceId": null,
      "CountryCode": "PA"
  },
  {
      "CityCode": "AML",
      "ProvinceId": null,
      "CountryCode": "PA"
  },
  {
      "CityCode": "A02",
      "ProvinceId": null,
      "CountryCode": "PA"
  },
  {
      "CityCode": "PTY",
      "ProvinceId": null,
      "CountryCode": "PA"
  },
  {
      "CityCode": "PEM",
      "ProvinceId": null,
      "CountryCode": "PE"
  },
  {
      "CityCode": "ANS",
      "ProvinceId": null,
      "CountryCode": "PE"
  },
  {
      "CityCode": "ATA",
      "ProvinceId": null,
      "CountryCode": "PE"
  },
  {
      "CityCode": "CJA",
      "ProvinceId": null,
      "CountryCode": "PE"
  },
  {
      "CityCode": "CHH",
      "ProvinceId": null,
      "CountryCode": "PE"
  },
  {
      "CityCode": "PIO",
      "ProvinceId": null,
      "CountryCode": "PE"
  },
  {
      "CityCode": "AYP",
      "ProvinceId": null,
      "CountryCode": "PE"
  },
  {
      "CityCode": "TRU",
      "ProvinceId": null,
      "CountryCode": "PE"
  },
  {
      "CityCode": "TPP",
      "ProvinceId": null,
      "CountryCode": "PE"
  },
  {
      "CityCode": "AG1",
      "ProvinceId": null,
      "CountryCode": "PE"
  },
  {
      "CityCode": "A13",
      "ProvinceId": null,
      "CountryCode": "PE"
  },
  {
      "CityCode": "MCA",
      "ProvinceId": null,
      "CountryCode": "PE"
  },
  {
      "CityCode": "CIX",
      "ProvinceId": null,
      "CountryCode": "PE"
  },
  {
      "CityCode": "PR9",
      "ProvinceId": null,
      "CountryCode": "PE"
  },
  {
      "CityCode": "P2N",
      "ProvinceId": null,
      "CountryCode": "PE"
  },
  {
      "CityCode": "ALD",
      "ProvinceId": null,
      "CountryCode": "PE"
  },
  {
      "CityCode": "BLP",
      "ProvinceId": null,
      "CountryCode": "PE"
  },
  {
      "CityCode": "CHM",
      "ProvinceId": null,
      "CountryCode": "PE"
  },
  {
      "CityCode": "IBP",
      "ProvinceId": null,
      "CountryCode": "PE"
  },
  {
      "CityCode": "UMI",
      "ProvinceId": null,
      "CountryCode": "PE"
  },
  {
      "CityCode": "RIJ",
      "ProvinceId": null,
      "CountryCode": "PE"
  },
  {
      "CityCode": "RIM",
      "ProvinceId": null,
      "CountryCode": "PE"
  },
  {
      "CityCode": "SMG",
      "ProvinceId": null,
      "CountryCode": "PE"
  },
  {
      "CityCode": "SYC",
      "ProvinceId": null,
      "CountryCode": "PE"
  },
  {
      "CityCode": "TGI",
      "ProvinceId": null,
      "CountryCode": "PE"
  },
  {
      "CityCode": "SJA",
      "ProvinceId": null,
      "CountryCode": "PE"
  },
  {
      "CityCode": "AQP",
      "ProvinceId": null,
      "CountryCode": "PE"
  },
  {
      "CityCode": "ICA",
      "ProvinceId": null,
      "CountryCode": "PE"
  },
  {
      "CityCode": "P3N",
      "ProvinceId": null,
      "CountryCode": "PE"
  },
  {
      "CityCode": "VCH",
      "ProvinceId": null,
      "CountryCode": "PE"
  },
  {
      "CityCode": "VC2",
      "ProvinceId": null,
      "CountryCode": "PE"
  },
  {
      "CityCode": "AYX",
      "ProvinceId": null,
      "CountryCode": "PE"
  },
  {
      "CityCode": "NZC",
      "ProvinceId": null,
      "CountryCode": "PE"
  },
  {
      "CityCode": "SQU",
      "ProvinceId": null,
      "CountryCode": "PE"
  },
  {
      "CityCode": "IQT",
      "ProvinceId": null,
      "CountryCode": "PE"
  },
  {
      "CityCode": "HUU",
      "ProvinceId": null,
      "CountryCode": "PE"
  },
  {
      "CityCode": "CUZ",
      "ProvinceId": null,
      "CountryCode": "PE"
  },
  {
      "CityCode": "LIM",
      "ProvinceId": null,
      "CountryCode": "PE"
  },
  {
      "CityCode": "JUL",
      "ProvinceId": null,
      "CountryCode": "PE"
  },
  {
      "CityCode": "PCL",
      "ProvinceId": null,
      "CountryCode": "PE"
  },
  {
      "CityCode": "PIU",
      "ProvinceId": null,
      "CountryCode": "PE"
  },
  {
      "CityCode": "JAU",
      "ProvinceId": null,
      "CountryCode": "PE"
  },
  {
      "CityCode": "ILQ",
      "ProvinceId": null,
      "CountryCode": "PE"
  },
  {
      "CityCode": "MBP",
      "ProvinceId": null,
      "CountryCode": "PE"
  },
  {
      "CityCode": "TCQ",
      "ProvinceId": null,
      "CountryCode": "PE"
  },
  {
      "CityCode": "TYL",
      "ProvinceId": null,
      "CountryCode": "PE"
  },
  {
      "CityCode": "PA1",
      "ProvinceId": null,
      "CountryCode": "PE"
  },
  {
      "CityCode": "SA2",
      "ProvinceId": null,
      "CountryCode": "PE"
  },
  {
      "CityCode": "TBP",
      "ProvinceId": null,
      "CountryCode": "PE"
  },
  {
      "CityCode": "JJI",
      "ProvinceId": null,
      "CountryCode": "PE"
  },
  {
      "CityCode": "YMS",
      "ProvinceId": null,
      "CountryCode": "PE"
  },
  {
      "CityCode": "P1N",
      "ProvinceId": null,
      "CountryCode": "PE"
  },
  {
      "CityCode": "JAE",
      "ProvinceId": null,
      "CountryCode": "PE"
  },
  {
      "CityCode": "PPT",
      "ProvinceId": null,
      "CountryCode": "PF"
  },
  {
      "CityCode": "RFP",
      "ProvinceId": null,
      "CountryCode": "PF"
  },
  {
      "CityCode": "RGI",
      "ProvinceId": null,
      "CountryCode": "PF"
  },
  {
      "CityCode": "BOB",
      "ProvinceId": null,
      "CountryCode": "PF"
  },
  {
      "CityCode": "AUQ",
      "ProvinceId": null,
      "CountryCode": "PF"
  },
  {
      "CityCode": "HUH",
      "ProvinceId": null,
      "CountryCode": "PF"
  },
  {
      "CityCode": "MOZ",
      "ProvinceId": null,
      "CountryCode": "PF"
  },
  {
      "CityCode": "TIH",
      "ProvinceId": null,
      "CountryCode": "PF"
  },
  {
      "CityCode": "TIZ",
      "ProvinceId": null,
      "CountryCode": "PG"
  },
  {
      "CityCode": "POM",
      "ProvinceId": null,
      "CountryCode": "PG"
  },
  {
      "CityCode": "RAB",
      "ProvinceId": null,
      "CountryCode": "PG"
  },
  {
      "CityCode": "MDU",
      "ProvinceId": null,
      "CountryCode": "PG"
  },
  {
      "CityCode": "MAS",
      "ProvinceId": null,
      "CountryCode": "PG"
  },
  {
      "CityCode": "MAG",
      "ProvinceId": null,
      "CountryCode": "PG"
  },
  {
      "CityCode": "KVG",
      "ProvinceId": null,
      "CountryCode": "PG"
  },
  {
      "CityCode": "LNV",
      "ProvinceId": null,
      "CountryCode": "PG"
  },
  {
      "CityCode": "HGU",
      "ProvinceId": null,
      "CountryCode": "PG"
  },
  {
      "CityCode": "HKN",
      "ProvinceId": null,
      "CountryCode": "PG"
  },
  {
      "CityCode": "GKA",
      "ProvinceId": null,
      "CountryCode": "PG"
  },
  {
      "CityCode": "GUR",
      "ProvinceId": null,
      "CountryCode": "PG"
  },
  {
      "CityCode": "KOR",
      "ProvinceId": null,
      "CountryCode": "PG"
  },
  {
      "CityCode": "LAE",
      "ProvinceId": null,
      "CountryCode": "PG"
  },
  {
      "CityCode": "ARP",
      "ProvinceId": null,
      "CountryCode": "PG"
  },
  {
      "CityCode": "TBG",
      "ProvinceId": null,
      "CountryCode": "PG"
  },
  {
      "CityCode": "WWK",
      "ProvinceId": null,
      "CountryCode": "PG"
  },
  {
      "CityCode": "VAI",
      "ProvinceId": null,
      "CountryCode": "PG"
  },
  {
      "CityCode": "CRK",
      "ProvinceId": null,
      "CountryCode": "PH"
  },
  {
      "CityCode": "MNL",
      "ProvinceId": null,
      "CountryCode": "PH"
  },
  {
      "CityCode": "SFS",
      "ProvinceId": null,
      "CountryCode": "PH"
  },
  {
      "CityCode": "PPS",
      "ProvinceId": null,
      "CountryCode": "PH"
  },
  {
      "CityCode": "CEB",
      "ProvinceId": null,
      "CountryCode": "PH"
  },
  {
      "CityCode": "ILO",
      "ProvinceId": null,
      "CountryCode": "PH"
  },
  {
      "CityCode": "KLO",
      "ProvinceId": null,
      "CountryCode": "PH"
  },
  {
      "CityCode": "BAG",
      "ProvinceId": null,
      "CountryCode": "PH"
  },
  {
      "CityCode": "CGY",
      "ProvinceId": null,
      "CountryCode": "PH"
  },
  {
      "CityCode": "DVO",
      "ProvinceId": null,
      "CountryCode": "PH"
  },
  {
      "CityCode": "TAC",
      "ProvinceId": null,
      "CountryCode": "PH"
  },
  {
      "CityCode": "SFE",
      "ProvinceId": null,
      "CountryCode": "PH"
  },
  {
      "CityCode": "SKT",
      "ProvinceId": null,
      "CountryCode": "PK"
  },
  {
      "CityCode": "PEW",
      "ProvinceId": null,
      "CountryCode": "PK"
  },
  {
      "CityCode": "WNS",
      "ProvinceId": null,
      "CountryCode": "PK"
  },
  {
      "CityCode": "KHI",
      "ProvinceId": null,
      "CountryCode": "PK"
  },
  {
      "CityCode": "LHE",
      "ProvinceId": null,
      "CountryCode": "PK"
  },
  {
      "CityCode": "MJD",
      "ProvinceId": null,
      "CountryCode": "PK"
  },
  {
      "CityCode": "ISB",
      "ProvinceId": null,
      "CountryCode": "PK"
  },
  {
      "CityCode": "HDD",
      "ProvinceId": null,
      "CountryCode": "PK"
  },
  {
      "CityCode": "GIL",
      "ProvinceId": null,
      "CountryCode": "PK"
  },
  {
      "CityCode": "TUK",
      "ProvinceId": null,
      "CountryCode": "PK"
  },
  {
      "CityCode": "WAW",
      "ProvinceId": null,
      "CountryCode": "PL"
  },
  {
      "CityCode": "IEG",
      "ProvinceId": null,
      "CountryCode": "PL"
  },
  {
      "CityCode": "RZE",
      "ProvinceId": null,
      "CountryCode": "PL"
  },
  {
      "CityCode": "LLK",
      "ProvinceId": null,
      "CountryCode": "PL"
  },
  {
      "CityCode": "KRK",
      "ProvinceId": null,
      "CountryCode": "PL"
  },
  {
      "CityCode": "GDN",
      "ProvinceId": null,
      "CountryCode": "PL"
  },
  {
      "CityCode": "LCJ",
      "ProvinceId": null,
      "CountryCode": "PL"
  },
  {
      "CityCode": "KTW",
      "ProvinceId": null,
      "CountryCode": "PL"
  },
  {
      "CityCode": "BZG",
      "ProvinceId": null,
      "CountryCode": "PL"
  },
  {
      "CityCode": "WRO",
      "ProvinceId": null,
      "CountryCode": "PL"
  },
  {
      "CityCode": "QYO",
      "ProvinceId": null,
      "CountryCode": "PL"
  },
  {
      "CityCode": "POZ",
      "ProvinceId": null,
      "CountryCode": "PL"
  },
  {
      "CityCode": "SZZ",
      "ProvinceId": null,
      "CountryCode": "PL"
  },
  {
      "CityCode": "GZA",
      "ProvinceId": null,
      "CountryCode": "PS"
  },
  {
      "CityCode": "FAO",
      "ProvinceId": null,
      "CountryCode": "PT"
  },
  {
      "CityCode": "CBP",
      "ProvinceId": null,
      "CountryCode": "PT"
  },
  {
      "CityCode": "LIS",
      "ProvinceId": null,
      "CountryCode": "PT"
  },
  {
      "CityCode": "SMA",
      "ProvinceId": null,
      "CountryCode": "PT"
  },
  {
      "CityCode": "PIX",
      "ProvinceId": null,
      "CountryCode": "PT"
  },
  {
      "CityCode": "PRM",
      "ProvinceId": null,
      "CountryCode": "PT"
  },
  {
      "CityCode": "PXO",
      "ProvinceId": null,
      "CountryCode": "PT"
  },
  {
      "CityCode": "PDL",
      "ProvinceId": null,
      "CountryCode": "PT"
  },
  {
      "CityCode": "VRL",
      "ProvinceId": null,
      "CountryCode": "PT"
  },
  {
      "CityCode": "TER",
      "ProvinceId": null,
      "CountryCode": "PT"
  },
  {
      "CityCode": "EVO",
      "ProvinceId": null,
      "CountryCode": "PT"
  },
  {
      "CityCode": "AFE",
      "ProvinceId": null,
      "CountryCode": "PT"
  },
  {
      "CityCode": "CSC",
      "ProvinceId": null,
      "CountryCode": "PT"
  },
  {
      "CityCode": "CVR",
      "ProvinceId": null,
      "CountryCode": "PT"
  },
  {
      "CityCode": "OB5",
      "ProvinceId": null,
      "CountryCode": "PT"
  },
  {
      "CityCode": "NEJ",
      "ProvinceId": null,
      "CountryCode": "PT"
  },
  {
      "CityCode": "SI1",
      "ProvinceId": null,
      "CountryCode": "PT"
  },
  {
      "CityCode": "SJZ",
      "ProvinceId": null,
      "CountryCode": "PT"
  },
  {
      "CityCode": "OPO",
      "ProvinceId": null,
      "CountryCode": "PT"
  },
  {
      "CityCode": "OB1",
      "ProvinceId": null,
      "CountryCode": "PT"
  },
  {
      "CityCode": "CVU",
      "ProvinceId": null,
      "CountryCode": "PT"
  },
  {
      "CityCode": "FNC",
      "ProvinceId": null,
      "CountryCode": "PT"
  },
  {
      "CityCode": "FLW",
      "ProvinceId": null,
      "CountryCode": "PT"
  },
  {
      "CityCode": "GRW",
      "ProvinceId": null,
      "CountryCode": "PT"
  },
  {
      "CityCode": "VSE",
      "ProvinceId": null,
      "CountryCode": "PT"
  },
  {
      "CityCode": "HOR",
      "ProvinceId": null,
      "CountryCode": "PT"
  },
  {
      "CityCode": "ROR",
      "ProvinceId": null,
      "CountryCode": "PW"
  },
  {
      "CityCode": "VMI",
      "ProvinceId": null,
      "CountryCode": "PY"
  },
  {
      "CityCode": "CIO",
      "ProvinceId": null,
      "CountryCode": "PY"
  },
  {
      "CityCode": "AGT",
      "ProvinceId": null,
      "CountryCode": "PY"
  },
  {
      "CityCode": "PCJ",
      "ProvinceId": null,
      "CountryCode": "PY"
  },
  {
      "CityCode": "OLK",
      "ProvinceId": null,
      "CountryCode": "PY"
  },
  {
      "CityCode": "ASU",
      "ProvinceId": null,
      "CountryCode": "PY"
  },
  {
      "CityCode": "DOH",
      "ProvinceId": null,
      "CountryCode": "QA"
  },
  {
      "CityCode": "RUN",
      "ProvinceId": null,
      "CountryCode": "RE"
  },
  {
      "CityCode": "ZSE",
      "ProvinceId": null,
      "CountryCode": "RE"
  },
  {
      "CityCode": "TCE",
      "ProvinceId": null,
      "CountryCode": "RO"
  },
  {
      "CityCode": "XHV",
      "ProvinceId": null,
      "CountryCode": "RO"
  },
  {
      "CityCode": "BUH",
      "ProvinceId": null,
      "CountryCode": "RO"
  },
  {
      "CityCode": "IAS",
      "ProvinceId": null,
      "CountryCode": "RO"
  },
  {
      "CityCode": "OMR",
      "ProvinceId": null,
      "CountryCode": "RO"
  },
  {
      "CityCode": "SBZ",
      "ProvinceId": null,
      "CountryCode": "RO"
  },
  {
      "CityCode": "SCV",
      "ProvinceId": null,
      "CountryCode": "RO"
  },
  {
      "CityCode": "TGM",
      "ProvinceId": null,
      "CountryCode": "RO"
  },
  {
      "CityCode": "TSR",
      "ProvinceId": null,
      "CountryCode": "RO"
  },
  {
      "CityCode": "CND",
      "ProvinceId": null,
      "CountryCode": "RO"
  },
  {
      "CityCode": "BAY",
      "ProvinceId": null,
      "CountryCode": "RO"
  },
  {
      "CityCode": "ARW",
      "ProvinceId": null,
      "CountryCode": "RO"
  },
  {
      "CityCode": "ARH",
      "ProvinceId": null,
      "CountryCode": "RU"
  },
  {
      "CityCode": "BQS",
      "ProvinceId": null,
      "CountryCode": "RU"
  },
  {
      "CityCode": "ESL",
      "ProvinceId": null,
      "CountryCode": "RU"
  },
  {
      "CityCode": "IKT",
      "ProvinceId": null,
      "CountryCode": "RU"
  },
  {
      "CityCode": "HTA",
      "ProvinceId": null,
      "CountryCode": "RU"
  },
  {
      "CityCode": "GOJ",
      "ProvinceId": null,
      "CountryCode": "RU"
  },
  {
      "CityCode": "GDX",
      "ProvinceId": null,
      "CountryCode": "RU"
  },
  {
      "CityCode": "KUF",
      "ProvinceId": null,
      "CountryCode": "RU"
  },
  {
      "CityCode": "KRR",
      "ProvinceId": null,
      "CountryCode": "RU"
  },
  {
      "CityCode": "KJA",
      "ProvinceId": null,
      "CountryCode": "RU"
  },
  {
      "CityCode": "KHV",
      "ProvinceId": null,
      "CountryCode": "RU"
  },
  {
      "CityCode": "KGD",
      "ProvinceId": null,
      "CountryCode": "RU"
  },
  {
      "CityCode": "LED",
      "ProvinceId": null,
      "CountryCode": "RU"
  },
  {
      "CityCode": "MOW",
      "ProvinceId": null,
      "CountryCode": "RU"
  },
  {
      "CityCode": "MRV",
      "ProvinceId": null,
      "CountryCode": "RU"
  },
  {
      "CityCode": "TJM",
      "ProvinceId": null,
      "CountryCode": "RU"
  },
  {
      "CityCode": "TOX",
      "ProvinceId": null,
      "CountryCode": "RU"
  },
  {
      "CityCode": "SVX",
      "ProvinceId": null,
      "CountryCode": "RU"
  },
  {
      "CityCode": "SCW",
      "ProvinceId": null,
      "CountryCode": "RU"
  },
  {
      "CityCode": "ROV",
      "ProvinceId": null,
      "CountryCode": "RU"
  },
  {
      "CityCode": "RTW",
      "ProvinceId": null,
      "CountryCode": "RU"
  },
  {
      "CityCode": "OVB",
      "ProvinceId": null,
      "CountryCode": "RU"
  },
  {
      "CityCode": "NBC",
      "ProvinceId": null,
      "CountryCode": "RU"
  },
  {
      "CityCode": "PEZ",
      "ProvinceId": null,
      "CountryCode": "RU"
  },
  {
      "CityCode": "PEE",
      "ProvinceId": null,
      "CountryCode": "RU"
  },
  {
      "CityCode": "SKX",
      "ProvinceId": null,
      "CountryCode": "RU"
  },
  {
      "CityCode": "VGD",
      "ProvinceId": null,
      "CountryCode": "RU"
  },
  {
      "CityCode": "URS",
      "ProvinceId": null,
      "CountryCode": "RU"
  },
  {
      "CityCode": "OMS",
      "ProvinceId": null,
      "CountryCode": "RU"
  },
  {
      "CityCode": "PKV",
      "ProvinceId": null,
      "CountryCode": "RU"
  },
  {
      "CityCode": "KZN",
      "ProvinceId": null,
      "CountryCode": "RU"
  },
  {
      "CityCode": "KMW",
      "ProvinceId": null,
      "CountryCode": "RU"
  },
  {
      "CityCode": "MMK",
      "ProvinceId": null,
      "CountryCode": "RU"
  },
  {
      "CityCode": "NJC",
      "ProvinceId": null,
      "CountryCode": "RU"
  },
  {
      "CityCode": "IAR",
      "ProvinceId": null,
      "CountryCode": "RU"
  },
  {
      "CityCode": "IWA",
      "ProvinceId": null,
      "CountryCode": "RU"
  },
  {
      "CityCode": "EGO",
      "ProvinceId": null,
      "CountryCode": "RU"
  },
  {
      "CityCode": "CEK",
      "ProvinceId": null,
      "CountryCode": "RU"
  },
  {
      "CityCode": "AAQ",
      "ProvinceId": null,
      "CountryCode": "RU"
  },
  {
      "CityCode": "ASF",
      "ProvinceId": null,
      "CountryCode": "RU"
  },
  {
      "CityCode": "VOG",
      "ProvinceId": null,
      "CountryCode": "RU"
  },
  {
      "CityCode": "VVO",
      "ProvinceId": null,
      "CountryCode": "RU"
  },
  {
      "CityCode": "STW",
      "ProvinceId": null,
      "CountryCode": "RU"
  },
  {
      "CityCode": "TOF",
      "ProvinceId": null,
      "CountryCode": "RU"
  },
  {
      "CityCode": "UUD",
      "ProvinceId": null,
      "CountryCode": "RU"
  },
  {
      "CityCode": "UUS",
      "ProvinceId": null,
      "CountryCode": "RU"
  },
  {
      "CityCode": "AER",
      "ProvinceId": null,
      "CountryCode": "RU"
  },
  {
      "CityCode": "KGL",
      "ProvinceId": null,
      "CountryCode": "RW"
  },
  {
      "CityCode": "HBT",
      "ProvinceId": null,
      "CountryCode": "SA"
  },
  {
      "CityCode": "HAS",
      "ProvinceId": null,
      "CountryCode": "SA"
  },
  {
      "CityCode": "JED",
      "ProvinceId": null,
      "CountryCode": "SA"
  },
  {
      "CityCode": "ELQ",
      "ProvinceId": null,
      "CountryCode": "SA"
  },
  {
      "CityCode": "DMM",
      "ProvinceId": null,
      "CountryCode": "SA"
  },
  {
      "CityCode": "AQI",
      "ProvinceId": null,
      "CountryCode": "SA"
  },
  {
      "CityCode": "YNB",
      "ProvinceId": null,
      "CountryCode": "SA"
  },
  {
      "CityCode": "RUH",
      "ProvinceId": null,
      "CountryCode": "SA"
  },
  {
      "CityCode": "SHW",
      "ProvinceId": null,
      "CountryCode": "SA"
  },
  {
      "CityCode": "TIF",
      "ProvinceId": null,
      "CountryCode": "SA"
  },
  {
      "CityCode": "AHB",
      "ProvinceId": null,
      "CountryCode": "SA"
  },
  {
      "CityCode": "TUI",
      "ProvinceId": null,
      "CountryCode": "SA"
  },
  {
      "CityCode": "TUU",
      "ProvinceId": null,
      "CountryCode": "SA"
  },
  {
      "CityCode": "ABT",
      "ProvinceId": null,
      "CountryCode": "SA"
  },
  {
      "CityCode": "EAM",
      "ProvinceId": null,
      "CountryCode": "SA"
  },
  {
      "CityCode": "DHA",
      "ProvinceId": null,
      "CountryCode": "SA"
  },
  {
      "CityCode": "GIZ",
      "ProvinceId": null,
      "CountryCode": "SA"
  },
  {
      "CityCode": "MED",
      "ProvinceId": null,
      "CountryCode": "SA"
  },
  {
      "CityCode": "KMX",
      "ProvinceId": null,
      "CountryCode": "SA"
  },
  {
      "CityCode": "KMC",
      "ProvinceId": null,
      "CountryCode": "SA"
  },
  {
      "CityCode": "HIR",
      "ProvinceId": null,
      "CountryCode": "SB"
  },
  {
      "CityCode": "PRI",
      "ProvinceId": null,
      "CountryCode": "SC"
  },
  {
      "CityCode": "SEZ",
      "ProvinceId": null,
      "CountryCode": "SC"
  },
  {
      "CityCode": "KRT",
      "ProvinceId": null,
      "CountryCode": "SD"
  },
  {
      "CityCode": "KLR",
      "ProvinceId": null,
      "CountryCode": "SE"
  },
  {
      "CityCode": "KRN",
      "ProvinceId": null,
      "CountryCode": "SE"
  },
  {
      "CityCode": "KID",
      "ProvinceId": null,
      "CountryCode": "SE"
  },
  {
      "CityCode": "KVB",
      "ProvinceId": null,
      "CountryCode": "SE"
  },
  {
      "CityCode": "KSD",
      "ProvinceId": null,
      "CountryCode": "SE"
  },
  {
      "CityCode": "LDK",
      "ProvinceId": null,
      "CountryCode": "SE"
  },
  {
      "CityCode": "LPI",
      "ProvinceId": null,
      "CountryCode": "SE"
  },
  {
      "CityCode": "JHE",
      "ProvinceId": null,
      "CountryCode": "SE"
  },
  {
      "CityCode": "JKG",
      "ProvinceId": null,
      "CountryCode": "SE"
  },
  {
      "CityCode": "JLD",
      "ProvinceId": null,
      "CountryCode": "SE"
  },
  {
      "CityCode": "GOT",
      "ProvinceId": null,
      "CountryCode": "SE"
  },
  {
      "CityCode": "GEV",
      "ProvinceId": null,
      "CountryCode": "SE"
  },
  {
      "CityCode": "EKT",
      "ProvinceId": null,
      "CountryCode": "SE"
  },
  {
      "CityCode": "SDL",
      "ProvinceId": null,
      "CountryCode": "SE"
  },
  {
      "CityCode": "SOO",
      "ProvinceId": null,
      "CountryCode": "SE"
  },
  {
      "CityCode": "RNB",
      "ProvinceId": null,
      "CountryCode": "SE"
  },
  {
      "CityCode": "THN",
      "ProvinceId": null,
      "CountryCode": "SE"
  },
  {
      "CityCode": "SQO",
      "ProvinceId": null,
      "CountryCode": "SE"
  },
  {
      "CityCode": "NRK",
      "ProvinceId": null,
      "CountryCode": "SE"
  },
  {
      "CityCode": "MXX",
      "ProvinceId": null,
      "CountryCode": "SE"
  },
  {
      "CityCode": "ORB",
      "ProvinceId": null,
      "CountryCode": "SE"
  },
  {
      "CityCode": "OSD",
      "ProvinceId": null,
      "CountryCode": "SE"
  },
  {
      "CityCode": "OSK",
      "ProvinceId": null,
      "CountryCode": "SE"
  },
  {
      "CityCode": "UPS",
      "ProvinceId": null,
      "CountryCode": "SE"
  },
  {
      "CityCode": "UME",
      "ProvinceId": null,
      "CountryCode": "SE"
  },
  {
      "CityCode": "VHM",
      "ProvinceId": null,
      "CountryCode": "SE"
  },
  {
      "CityCode": "OER",
      "ProvinceId": null,
      "CountryCode": "SE"
  },
  {
      "CityCode": "SFT",
      "ProvinceId": null,
      "CountryCode": "SE"
  },
  {
      "CityCode": "KRF",
      "ProvinceId": null,
      "CountryCode": "SE"
  },
  {
      "CityCode": "JSO",
      "ProvinceId": null,
      "CountryCode": "SE"
  },
  {
      "CityCode": "LLA",
      "ProvinceId": null,
      "CountryCode": "SE"
  },
  {
      "CityCode": "LYC",
      "ProvinceId": null,
      "CountryCode": "SE"
  },
  {
      "CityCode": "MMA",
      "ProvinceId": null,
      "CountryCode": "SE"
  },
  {
      "CityCode": "HAD",
      "ProvinceId": null,
      "CountryCode": "SE"
  },
  {
      "CityCode": "GVX",
      "ProvinceId": null,
      "CountryCode": "SE"
  },
  {
      "CityCode": "HLF",
      "ProvinceId": null,
      "CountryCode": "SE"
  },
  {
      "CityCode": "HUV",
      "ProvinceId": null,
      "CountryCode": "SE"
  },
  {
      "CityCode": "EVG",
      "ProvinceId": null,
      "CountryCode": "SE"
  },
  {
      "CityCode": "AJR",
      "ProvinceId": null,
      "CountryCode": "SE"
  },
  {
      "CityCode": "BLE",
      "ProvinceId": null,
      "CountryCode": "SE"
  },
  {
      "CityCode": "STO",
      "ProvinceId": null,
      "CountryCode": "SE"
  },
  {
      "CityCode": "VST",
      "ProvinceId": null,
      "CountryCode": "SE"
  },
  {
      "CityCode": "VBY",
      "ProvinceId": null,
      "CountryCode": "SE"
  },
  {
      "CityCode": "VXO",
      "ProvinceId": null,
      "CountryCode": "SE"
  },
  {
      "CityCode": "XGC",
      "ProvinceId": null,
      "CountryCode": "SE"
  },
  {
      "CityCode": "AGH",
      "ProvinceId": null,
      "CountryCode": "SE"
  },
  {
      "CityCode": "SIN",
      "ProvinceId": null,
      "CountryCode": "SG"
  },
  {
      "CityCode": "POW",
      "ProvinceId": null,
      "CountryCode": "SI"
  },
  {
      "CityCode": "MBX",
      "ProvinceId": null,
      "CountryCode": "SI"
  },
  {
      "CityCode": "LJU",
      "ProvinceId": null,
      "CountryCode": "SI"
  },
  {
      "CityCode": "PZY",
      "ProvinceId": null,
      "CountryCode": "SK"
  },
  {
      "CityCode": "BTS",
      "ProvinceId": null,
      "CountryCode": "SK"
  },
  {
      "CityCode": "TAT",
      "ProvinceId": null,
      "CountryCode": "SK"
  },
  {
      "CityCode": "KSC",
      "ProvinceId": null,
      "CountryCode": "SK"
  },
  {
      "CityCode": "GBK",
      "ProvinceId": null,
      "CountryCode": "SL"
  },
  {
      "CityCode": "FNA",
      "ProvinceId": null,
      "CountryCode": "SL"
  },
  {
      "CityCode": "DKR",
      "ProvinceId": null,
      "CountryCode": "SN"
  },
  {
      "CityCode": "PBM",
      "ProvinceId": null,
      "CountryCode": "SR"
  },
  {
      "CityCode": "SAL",
      "ProvinceId": null,
      "CountryCode": "SV"
  },
  {
      "CityCode": "EV_001",
      "ProvinceId": null,
      "CountryCode": "SV"
  },
  {
      "CityCode": "EV_002",
      "ProvinceId": null,
      "CountryCode": "SV"
  },
  {
      "CityCode": "EV_003",
      "ProvinceId": null,
      "CountryCode": "SV"
  },
  {
      "CityCode": "EV_004",
      "ProvinceId": null,
      "CountryCode": "SV"
  },
  {
      "CityCode": "S39",
      "ProvinceId": null,
      "CountryCode": "SV"
  },
  {
      "CityCode": "DAM",
      "ProvinceId": null,
      "CountryCode": "SY"
  },
  {
      "CityCode": "LTK",
      "ProvinceId": null,
      "CountryCode": "SY"
  },
  {
      "CityCode": "ALP",
      "ProvinceId": null,
      "CountryCode": "SY"
  },
  {
      "CityCode": "MTS",
      "ProvinceId": null,
      "CountryCode": "SZ"
  },
  {
      "CityCode": "PLS",
      "ProvinceId": null,
      "CountryCode": "TC"
  },
  {
      "CityCode": "XSC",
      "ProvinceId": null,
      "CountryCode": "TC"
  },
  {
      "CityCode": "GDT",
      "ProvinceId": null,
      "CountryCode": "TC"
  },
  {
      "CityCode": "PIC",
      "ProvinceId": null,
      "CountryCode": "TC"
  },
  {
      "CityCode": "NCA",
      "ProvinceId": null,
      "CountryCode": "TC"
  },
  {
      "CityCode": "NDJ",
      "ProvinceId": null,
      "CountryCode": "TD"
  },
  {
      "CityCode": "LFW",
      "ProvinceId": null,
      "CountryCode": "TG"
  },
  {
      "CityCode": "LPT",
      "ProvinceId": null,
      "CountryCode": "TH"
  },
  {
      "CityCode": "KKC",
      "ProvinceId": null,
      "CountryCode": "TH"
  },
  {
      "CityCode": "MAQ",
      "ProvinceId": null,
      "CountryCode": "TH"
  },
  {
      "CityCode": "KBV",
      "ProvinceId": null,
      "CountryCode": "TH"
  },
  {
      "CityCode": "HHQ",
      "ProvinceId": null,
      "CountryCode": "TH"
  },
  {
      "CityCode": "HGN",
      "ProvinceId": null,
      "CountryCode": "TH"
  },
  {
      "CityCode": "HDY",
      "ProvinceId": null,
      "CountryCode": "TH"
  },
  {
      "CityCode": "CNX",
      "ProvinceId": null,
      "CountryCode": "TH"
  },
  {
      "CityCode": "BKK",
      "ProvinceId": null,
      "CountryCode": "TH"
  },
  {
      "CityCode": "NAW",
      "ProvinceId": null,
      "CountryCode": "TH"
  },
  {
      "CityCode": "NST",
      "ProvinceId": null,
      "CountryCode": "TH"
  },
  {
      "CityCode": "NAK",
      "ProvinceId": null,
      "CountryCode": "TH"
  },
  {
      "CityCode": "PHS",
      "ProvinceId": null,
      "CountryCode": "TH"
  },
  {
      "CityCode": "PHZ",
      "ProvinceId": null,
      "CountryCode": "TH"
  },
  {
      "CityCode": "THS",
      "ProvinceId": null,
      "CountryCode": "TH"
  },
  {
      "CityCode": "TST",
      "ProvinceId": null,
      "CountryCode": "TH"
  },
  {
      "CityCode": "UNN",
      "ProvinceId": null,
      "CountryCode": "TH"
  },
  {
      "CityCode": "USM",
      "ProvinceId": null,
      "CountryCode": "TH"
  },
  {
      "CityCode": "URT",
      "ProvinceId": null,
      "CountryCode": "TH"
  },
  {
      "CityCode": "TDX",
      "ProvinceId": null,
      "CountryCode": "TH"
  },
  {
      "CityCode": "UTP",
      "ProvinceId": null,
      "CountryCode": "TH"
  },
  {
      "CityCode": "UTH",
      "ProvinceId": null,
      "CountryCode": "TH"
  },
  {
      "CityCode": "UBP",
      "ProvinceId": null,
      "CountryCode": "TH"
  },
  {
      "CityCode": "PYX",
      "ProvinceId": null,
      "CountryCode": "TH"
  },
  {
      "CityCode": "PRH",
      "ProvinceId": null,
      "CountryCode": "TH"
  },
  {
      "CityCode": "SNO",
      "ProvinceId": null,
      "CountryCode": "TH"
  },
  {
      "CityCode": "NNT",
      "ProvinceId": null,
      "CountryCode": "TH"
  },
  {
      "CityCode": "KOP",
      "ProvinceId": null,
      "CountryCode": "TH"
  },
  {
      "CityCode": "BFV",
      "ProvinceId": null,
      "CountryCode": "TH"
  },
  {
      "CityCode": "CEI",
      "ProvinceId": null,
      "CountryCode": "TH"
  },
  {
      "CityCode": "CJM",
      "ProvinceId": null,
      "CountryCode": "TH"
  },
  {
      "CityCode": "HKT",
      "ProvinceId": null,
      "CountryCode": "TH"
  },
  {
      "CityCode": "DYU",
      "ProvinceId": null,
      "CountryCode": "TJ"
  },
  {
      "CityCode": "CRZ",
      "ProvinceId": null,
      "CountryCode": "TM"
  },
  {
      "CityCode": "TAZ",
      "ProvinceId": null,
      "CountryCode": "TM"
  },
  {
      "CityCode": "MYP",
      "ProvinceId": null,
      "CountryCode": "TM"
  },
  {
      "CityCode": "ASB",
      "ProvinceId": null,
      "CountryCode": "TM"
  },
  {
      "CityCode": "KRW",
      "ProvinceId": null,
      "CountryCode": "TM"
  },
  {
      "CityCode": "MIR",
      "ProvinceId": null,
      "CountryCode": "TN"
  },
  {
      "CityCode": "SFA",
      "ProvinceId": null,
      "CountryCode": "TN"
  },
  {
      "CityCode": "TBJ",
      "ProvinceId": null,
      "CountryCode": "TN"
  },
  {
      "CityCode": "TUN",
      "ProvinceId": null,
      "CountryCode": "TN"
  },
  {
      "CityCode": "TOE",
      "ProvinceId": null,
      "CountryCode": "TN"
  },
  {
      "CityCode": "DJE",
      "ProvinceId": null,
      "CountryCode": "TN"
  },
  {
      "CityCode": "TBU",
      "ProvinceId": null,
      "CountryCode": "TO"
  },
  {
      "CityCode": "VAV",
      "ProvinceId": null,
      "CountryCode": "TO"
  },
  {
      "CityCode": "HPA",
      "ProvinceId": null,
      "CountryCode": "TO"
  },
  {
      "CityCode": "BCH",
      "ProvinceId": null,
      "CountryCode": "TP"
  },
  {
      "CityCode": "DIL",
      "ProvinceId": null,
      "CountryCode": "TP"
  },
  {
      "CityCode": "DIY",
      "ProvinceId": null,
      "CountryCode": "TR"
  },
  {
      "CityCode": "DLM",
      "ProvinceId": null,
      "CountryCode": "TR"
  },
  {
      "CityCode": "EZS",
      "ProvinceId": null,
      "CountryCode": "TR"
  },
  {
      "CityCode": "GZT",
      "ProvinceId": null,
      "CountryCode": "TR"
  },
  {
      "CityCode": "IST",
      "ProvinceId": null,
      "CountryCode": "TR"
  },
  {
      "CityCode": "CKZ",
      "ProvinceId": null,
      "CountryCode": "TR"
  },
  {
      "CityCode": "BTZ",
      "ProvinceId": null,
      "CountryCode": "TR"
  },
  {
      "CityCode": "ASR",
      "ProvinceId": null,
      "CountryCode": "TR"
  },
  {
      "CityCode": "4AN ",
      "ProvinceId": null,
      "CountryCode": "TR"
  },
  {
      "CityCode": "4CD",
      "ProvinceId": null,
      "CountryCode": "TR"
  },
  {
      "CityCode": "4KS",
      "ProvinceId": null,
      "CountryCode": "TR"
  },
  {
      "CityCode": "4KT",
      "ProvinceId": null,
      "CountryCode": "TR"
  },
  {
      "CityCode": "4MN",
      "ProvinceId": null,
      "CountryCode": "TR"
  },
  {
      "CityCode": "4PK",
      "ProvinceId": null,
      "CountryCode": "TR"
  },
  {
      "CityCode": "IZM",
      "ProvinceId": null,
      "CountryCode": "TR"
  },
  {
      "CityCode": "SAW",
      "ProvinceId": null,
      "CountryCode": "TR"
  },
  {
      "CityCode": "SSX",
      "ProvinceId": null,
      "CountryCode": "TR"
  },
  {
      "CityCode": "TZX",
      "ProvinceId": null,
      "CountryCode": "TR"
  },
  {
      "CityCode": "ADA",
      "ProvinceId": null,
      "CountryCode": "TR"
  },
  {
      "CityCode": "FE1",
      "ProvinceId": null,
      "CountryCode": "TR"
  },
  {
      "CityCode": "AYT",
      "ProvinceId": null,
      "CountryCode": "TR"
  },
  {
      "CityCode": "ANK",
      "ProvinceId": null,
      "CountryCode": "TR"
  },
  {
      "CityCode": "BXN",
      "ProvinceId": null,
      "CountryCode": "TR"
  },
  {
      "CityCode": "BZI",
      "ProvinceId": null,
      "CountryCode": "TR"
  },
  {
      "CityCode": "ERZ",
      "ProvinceId": null,
      "CountryCode": "TR"
  },
  {
      "CityCode": "DNZ",
      "ProvinceId": null,
      "CountryCode": "TR"
  },
  {
      "CityCode": "GNY",
      "ProvinceId": null,
      "CountryCode": "TR"
  },
  {
      "CityCode": "KYA",
      "ProvinceId": null,
      "CountryCode": "TR"
  },
  {
      "CityCode": "NAV",
      "ProvinceId": null,
      "CountryCode": "TR"
  },
  {
      "CityCode": "MSR",
      "ProvinceId": null,
      "CountryCode": "TR"
  },
  {
      "CityCode": "POS",
      "ProvinceId": null,
      "CountryCode": "TT"
  },
  {
      "CityCode": "TAB",
      "ProvinceId": null,
      "CountryCode": "TT"
  },
  {
      "CityCode": "TB1",
      "ProvinceId": null,
      "CountryCode": "TT"
  },
  {
      "CityCode": "TB2",
      "ProvinceId": null,
      "CountryCode": "TT"
  },
  {
      "CityCode": "FUN",
      "ProvinceId": null,
      "CountryCode": "TV"
  },
  {
      "CityCode": "KNH",
      "ProvinceId": null,
      "CountryCode": "TW"
  },
  {
      "CityCode": "MFK",
      "ProvinceId": null,
      "CountryCode": "TW"
  },
  {
      "CityCode": "TXG",
      "ProvinceId": null,
      "CountryCode": "TW"
  },
  {
      "CityCode": "TNN",
      "ProvinceId": null,
      "CountryCode": "TW"
  },
  {
      "CityCode": "TTT",
      "ProvinceId": null,
      "CountryCode": "TW"
  },
  {
      "CityCode": "TPE",
      "ProvinceId": null,
      "CountryCode": "TW"
  },
  {
      "CityCode": "MZG",
      "ProvinceId": null,
      "CountryCode": "TW"
  },
  {
      "CityCode": "KHH",
      "ProvinceId": null,
      "CountryCode": "TW"
  },
  {
      "CityCode": "HCN",
      "ProvinceId": null,
      "CountryCode": "TW"
  },
  {
      "CityCode": "HSZ",
      "ProvinceId": null,
      "CountryCode": "TW"
  },
  {
      "CityCode": "HUN",
      "ProvinceId": null,
      "CountryCode": "TW"
  },
  {
      "CityCode": "DAR",
      "ProvinceId": null,
      "CountryCode": "TZ"
  },
  {
      "CityCode": "ARK",
      "ProvinceId": null,
      "CountryCode": "TZ"
  },
  {
      "CityCode": "MYW",
      "ProvinceId": null,
      "CountryCode": "TZ"
  },
  {
      "CityCode": "TGT",
      "ProvinceId": null,
      "CountryCode": "TZ"
  },
  {
      "CityCode": "ZNZ",
      "ProvinceId": null,
      "CountryCode": "TZ"
  },
  {
      "CityCode": "MWZ",
      "ProvinceId": null,
      "CountryCode": "TZ"
  },
  {
      "CityCode": "JRO",
      "ProvinceId": null,
      "CountryCode": "TZ"
  },
  {
      "CityCode": "LWO",
      "ProvinceId": null,
      "CountryCode": "UA"
  },
  {
      "CityCode": "ODS",
      "ProvinceId": null,
      "CountryCode": "UA"
  },
  {
      "CityCode": "IEV",
      "ProvinceId": null,
      "CountryCode": "UA"
  },
  {
      "CityCode": "IFO",
      "ProvinceId": null,
      "CountryCode": "UA"
  },
  {
      "CityCode": "UCK",
      "ProvinceId": null,
      "CountryCode": "UA"
  },
  {
      "CityCode": "VSG",
      "ProvinceId": null,
      "CountryCode": "UA"
  },
  {
      "CityCode": "UMY",
      "ProvinceId": null,
      "CountryCode": "UA"
  },
  {
      "CityCode": "VIN",
      "ProvinceId": null,
      "CountryCode": "UA"
  },
  {
      "CityCode": "SIP",
      "ProvinceId": null,
      "CountryCode": "UA"
  },
  {
      "CityCode": "OZH",
      "ProvinceId": null,
      "CountryCode": "UA"
  },
  {
      "CityCode": "DOK",
      "ProvinceId": null,
      "CountryCode": "UA"
  },
  {
      "CityCode": "DNK",
      "ProvinceId": null,
      "CountryCode": "UA"
  },
  {
      "CityCode": "HRK",
      "ProvinceId": null,
      "CountryCode": "UA"
  },
  {
      "CityCode": "EBB",
      "ProvinceId": null,
      "CountryCode": "UG"
  },
  {
      "CityCode": "MDY",
      "ProvinceId": null,
      "CountryCode": "UM"
  },
  {
      "CityCode": "LYU",
      "ProvinceId": "MN",
      "CountryCode": "US"
  },
  {
      "CityCode": "MEI",
      "ProvinceId": "MS",
      "CountryCode": "US"
  },
  {
      "CityCode": "MEM",
      "ProvinceId": "TN",
      "CountryCode": "US"
  },
  {
      "CityCode": "LWS",
      "ProvinceId": "ID",
      "CountryCode": "US"
  },
  {
      "CityCode": "LWT",
      "ProvinceId": "MT",
      "CountryCode": "US"
  },
  {
      "CityCode": "LXN",
      "ProvinceId": "NE",
      "CountryCode": "US"
  },
  {
      "CityCode": "LWB",
      "ProvinceId": "WV",
      "CountryCode": "US"
  },
  {
      "CityCode": "LWC",
      "ProvinceId": "KS",
      "CountryCode": "US"
  },
  {
      "CityCode": "LWM",
      "ProvinceId": "MA",
      "CountryCode": "US"
  },
  {
      "CityCode": "LYH",
      "ProvinceId": "VA",
      "CountryCode": "US"
  },
  {
      "CityCode": "MLI",
      "ProvinceId": "IL",
      "CountryCode": "US"
  },
  {
      "CityCode": "MLC",
      "ProvinceId": "OK",
      "CountryCode": "US"
  },
  {
      "CityCode": "MGW",
      "ProvinceId": "WV",
      "CountryCode": "US"
  },
  {
      "CityCode": "MLS",
      "ProvinceId": "MT",
      "CountryCode": "US"
  },
  {
      "CityCode": "MLU",
      "ProvinceId": "LA",
      "CountryCode": "US"
  },
  {
      "CityCode": "MFR",
      "ProvinceId": "OR",
      "CountryCode": "US"
  },
  {
      "CityCode": "MEV",
      "ProvinceId": "NV",
      "CountryCode": "US"
  },
  {
      "CityCode": "MFD",
      "ProvinceId": "OH",
      "CountryCode": "US"
  },
  {
      "CityCode": "MFE",
      "ProvinceId": "TX",
      "CountryCode": "US"
  },
  {
      "CityCode": "MFH",
      "ProvinceId": "NV",
      "CountryCode": "US"
  },
  {
      "CityCode": "MFI",
      "ProvinceId": "WI",
      "CountryCode": "US"
  },
  {
      "CityCode": "MGC",
      "ProvinceId": "IN",
      "CountryCode": "US"
  },
  {
      "CityCode": "MGE",
      "ProvinceId": "GA",
      "CountryCode": "US"
  },
  {
      "CityCode": "MGM",
      "ProvinceId": "AL",
      "CountryCode": "US"
  },
  {
      "CityCode": "MGR",
      "ProvinceId": "GA",
      "CountryCode": "US"
  },
  {
      "CityCode": "MWA",
      "ProvinceId": "IL",
      "CountryCode": "US"
  },
  {
      "CityCode": "MWH",
      "ProvinceId": "WA",
      "CountryCode": "US"
  },
  {
      "CityCode": "MWO",
      "ProvinceId": "OH",
      "CountryCode": "US"
  },
  {
      "CityCode": "NFL",
      "ProvinceId": "NV",
      "CountryCode": "US"
  },
  {
      "CityCode": "MVC",
      "ProvinceId": "AL",
      "CountryCode": "US"
  },
  {
      "CityCode": "MVN",
      "ProvinceId": "IL",
      "CountryCode": "US"
  },
  {
      "CityCode": "MVY",
      "ProvinceId": "MA",
      "CountryCode": "US"
  },
  {
      "CityCode": "NHZ",
      "ProvinceId": "ME",
      "CountryCode": "US"
  },
  {
      "CityCode": "MTO",
      "ProvinceId": "IL",
      "CountryCode": "US"
  },
  {
      "CityCode": "MTP",
      "ProvinceId": "NY",
      "CountryCode": "US"
  },
  {
      "CityCode": "MSV",
      "ProvinceId": "NY",
      "CountryCode": "US"
  },
  {
      "CityCode": "MSY",
      "ProvinceId": "LA",
      "CountryCode": "US"
  },
  {
      "CityCode": "MTH",
      "ProvinceId": "FL",
      "CountryCode": "US"
  },
  {
      "CityCode": "MTJ",
      "ProvinceId": "CO",
      "CountryCode": "US"
  },
  {
      "CityCode": "MTW",
      "ProvinceId": "WI",
      "CountryCode": "US"
  },
  {
      "CityCode": "MUE",
      "ProvinceId": "HI",
      "CountryCode": "US"
  },
  {
      "CityCode": "MML",
      "ProvinceId": "MN",
      "CountryCode": "US"
  },
  {
      "CityCode": "MMH",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "MNM",
      "ProvinceId": "MI",
      "CountryCode": "US"
  },
  {
      "CityCode": "MOD",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "MMU",
      "ProvinceId": "NJ",
      "CountryCode": "US"
  },
  {
      "CityCode": "MOB",
      "ProvinceId": "AL",
      "CountryCode": "US"
  },
  {
      "CityCode": "JST",
      "ProvinceId": "PA",
      "CountryCode": "US"
  },
  {
      "CityCode": "JPD",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "JVL",
      "ProvinceId": "WI",
      "CountryCode": "US"
  },
  {
      "CityCode": "JXN",
      "ProvinceId": "MI",
      "CountryCode": "US"
  },
  {
      "CityCode": "JNU",
      "ProvinceId": "AK",
      "CountryCode": "US"
  },
  {
      "CityCode": "JAC",
      "ProvinceId": "WY",
      "CountryCode": "US"
  },
  {
      "CityCode": "IYK",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "KAE",
      "ProvinceId": "AK",
      "CountryCode": "US"
  },
  {
      "CityCode": "KLW",
      "ProvinceId": "AK",
      "CountryCode": "US"
  },
  {
      "CityCode": "KPD",
      "ProvinceId": "PA",
      "CountryCode": "US"
  },
  {
      "CityCode": "LAA",
      "ProvinceId": "CO",
      "CountryCode": "US"
  },
  {
      "CityCode": "KOA",
      "ProvinceId": "HI",
      "CountryCode": "US"
  },
  {
      "CityCode": "KNT",
      "ProvinceId": "MO",
      "CountryCode": "US"
  },
  {
      "CityCode": "LJN",
      "ProvinceId": "TX",
      "CountryCode": "US"
  },
  {
      "CityCode": "LIT",
      "ProvinceId": "AR",
      "CountryCode": "US"
  },
  {
      "CityCode": "LMT",
      "ProvinceId": "OR",
      "CountryCode": "US"
  },
  {
      "CityCode": "LNK",
      "ProvinceId": "NE",
      "CountryCode": "US"
  },
  {
      "CityCode": "LUL",
      "ProvinceId": "MS",
      "CountryCode": "US"
  },
  {
      "CityCode": "LLY",
      "ProvinceId": "NJ",
      "CountryCode": "US"
  },
  {
      "CityCode": "LUP",
      "ProvinceId": "HI",
      "CountryCode": "US"
  },
  {
      "CityCode": "LVK",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "LVM",
      "ProvinceId": "MT",
      "CountryCode": "US"
  },
  {
      "CityCode": "LAF",
      "ProvinceId": "IN",
      "CountryCode": "US"
  },
  {
      "CityCode": "LAL",
      "ProvinceId": "FL",
      "CountryCode": "US"
  },
  {
      "CityCode": "LAM",
      "ProvinceId": "NM",
      "CountryCode": "US"
  },
  {
      "CityCode": "LAN",
      "ProvinceId": "MI",
      "CountryCode": "US"
  },
  {
      "CityCode": "LAR",
      "ProvinceId": "WY",
      "CountryCode": "US"
  },
  {
      "CityCode": "LAS",
      "ProvinceId": "NV",
      "CountryCode": "US"
  },
  {
      "CityCode": "LAW",
      "ProvinceId": "OK",
      "CountryCode": "US"
  },
  {
      "CityCode": "LAX",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "LBB",
      "ProvinceId": "TX",
      "CountryCode": "US"
  },
  {
      "CityCode": "LBE",
      "ProvinceId": "PA",
      "CountryCode": "US"
  },
  {
      "CityCode": "LBF",
      "ProvinceId": "NE",
      "CountryCode": "US"
  },
  {
      "CityCode": "LIH",
      "ProvinceId": "HI",
      "CountryCode": "US"
  },
  {
      "CityCode": "LCH",
      "ProvinceId": "LA",
      "CountryCode": "US"
  },
  {
      "CityCode": "LCI",
      "ProvinceId": "NH",
      "CountryCode": "US"
  },
  {
      "CityCode": "LBL",
      "ProvinceId": "KS",
      "CountryCode": "US"
  },
  {
      "CityCode": "LBT",
      "ProvinceId": "NC",
      "CountryCode": "US"
  },
  {
      "CityCode": "ODW",
      "ProvinceId": "WA",
      "CountryCode": "US"
  },
  {
      "CityCode": "OEA",
      "ProvinceId": "IN",
      "CountryCode": "US"
  },
  {
      "CityCode": "OFK",
      "ProvinceId": "NE",
      "CountryCode": "US"
  },
  {
      "CityCode": "OGA",
      "ProvinceId": "NE",
      "CountryCode": "US"
  },
  {
      "CityCode": "OGD",
      "ProvinceId": "UT",
      "CountryCode": "US"
  },
  {
      "CityCode": "OGG",
      "ProvinceId": "HI",
      "CountryCode": "US"
  },
  {
      "CityCode": "OGS",
      "ProvinceId": "NY",
      "CountryCode": "US"
  },
  {
      "CityCode": "NPT",
      "ProvinceId": "RI",
      "CountryCode": "US"
  },
  {
      "CityCode": "NQI",
      "ProvinceId": "TX",
      "CountryCode": "US"
  },
  {
      "CityCode": "ONH",
      "ProvinceId": "NY",
      "CountryCode": "US"
  },
  {
      "CityCode": "OLS",
      "ProvinceId": "AZ",
      "CountryCode": "US"
  },
  {
      "CityCode": "OLU",
      "ProvinceId": "NE",
      "CountryCode": "US"
  },
  {
      "CityCode": "OMA",
      "ProvinceId": "NE",
      "CountryCode": "US"
  },
  {
      "CityCode": "OME",
      "ProvinceId": "AK",
      "CountryCode": "US"
  },
  {
      "CityCode": "OKC",
      "ProvinceId": "OK",
      "CountryCode": "US"
  },
  {
      "CityCode": "OKK",
      "ProvinceId": "IN",
      "CountryCode": "US"
  },
  {
      "CityCode": "PDT",
      "ProvinceId": "OR",
      "CountryCode": "US"
  },
  {
      "CityCode": "PDX",
      "ProvinceId": "OR",
      "CountryCode": "US"
  },
  {
      "CityCode": "PIT",
      "ProvinceId": "PA",
      "CountryCode": "US"
  },
  {
      "CityCode": "OLM",
      "ProvinceId": "WA",
      "CountryCode": "US"
  },
  {
      "CityCode": "ONP",
      "ProvinceId": "OR",
      "CountryCode": "US"
  },
  {
      "CityCode": "ONT",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "PAE",
      "ProvinceId": "WA",
      "CountryCode": "US"
  },
  {
      "CityCode": "PAH",
      "ProvinceId": "KY",
      "CountryCode": "US"
  },
  {
      "CityCode": "PBF",
      "ProvinceId": "AR",
      "CountryCode": "US"
  },
  {
      "CityCode": "PBI",
      "ProvinceId": "FL",
      "CountryCode": "US"
  },
  {
      "CityCode": "PAO",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "PRB",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "PRC",
      "ProvinceId": "AZ",
      "CountryCode": "US"
  },
  {
      "CityCode": "PQI",
      "ProvinceId": "ME",
      "CountryCode": "US"
  },
  {
      "CityCode": "PSB",
      "ProvinceId": "PA",
      "CountryCode": "US"
  },
  {
      "CityCode": "PSC",
      "ProvinceId": "WA",
      "CountryCode": "US"
  },
  {
      "CityCode": "PSM",
      "ProvinceId": "NH",
      "CountryCode": "US"
  },
  {
      "CityCode": "PWM",
      "ProvinceId": "ME",
      "CountryCode": "US"
  },
  {
      "CityCode": "PWT",
      "ProvinceId": "WA",
      "CountryCode": "US"
  },
  {
      "CityCode": "PRX",
      "ProvinceId": "TX",
      "CountryCode": "US"
  },
  {
      "CityCode": "PSF",
      "ProvinceId": "MA",
      "CountryCode": "US"
  },
  {
      "CityCode": "PSG",
      "ProvinceId": "AK",
      "CountryCode": "US"
  },
  {
      "CityCode": "PSK",
      "ProvinceId": "VA",
      "CountryCode": "US"
  },
  {
      "CityCode": "PLY",
      "ProvinceId": "IN",
      "CountryCode": "US"
  },
  {
      "CityCode": "PLN",
      "ProvinceId": "MI",
      "CountryCode": "US"
  },
  {
      "CityCode": "PMD",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "PPM",
      "ProvinceId": "FL",
      "CountryCode": "US"
  },
  {
      "CityCode": "PLB",
      "ProvinceId": "NY",
      "CountryCode": "US"
  },
  {
      "CityCode": "PLK",
      "ProvinceId": "MO",
      "CountryCode": "US"
  },
  {
      "CityCode": "PJB",
      "ProvinceId": "AZ",
      "CountryCode": "US"
  },
  {
      "CityCode": "PKB",
      "ProvinceId": "WV",
      "CountryCode": "US"
  },
  {
      "CityCode": "SAN",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "SAR",
      "ProvinceId": "IL",
      "CountryCode": "US"
  },
  {
      "CityCode": "SAT",
      "ProvinceId": "TX",
      "CountryCode": "US"
  },
  {
      "CityCode": "SAV",
      "ProvinceId": "GA",
      "CountryCode": "US"
  },
  {
      "CityCode": "RZZ",
      "ProvinceId": "NC",
      "CountryCode": "US"
  },
  {
      "CityCode": "SMF",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "SAF",
      "ProvinceId": "NM",
      "CountryCode": "US"
  },
  {
      "CityCode": "RIW",
      "ProvinceId": "WY",
      "CountryCode": "US"
  },
  {
      "CityCode": "RIL",
      "ProvinceId": "CO",
      "CountryCode": "US"
  },
  {
      "CityCode": "RIC",
      "ProvinceId": "VA",
      "CountryCode": "US"
  },
  {
      "CityCode": "RIF",
      "ProvinceId": "UT",
      "CountryCode": "US"
  },
  {
      "CityCode": "RKD",
      "ProvinceId": "ME",
      "CountryCode": "US"
  },
  {
      "CityCode": "RKP",
      "ProvinceId": "TX",
      "CountryCode": "US"
  },
  {
      "CityCode": "RKS",
      "ProvinceId": "WY",
      "CountryCode": "US"
  },
  {
      "CityCode": "RMG",
      "ProvinceId": "GA",
      "CountryCode": "US"
  },
  {
      "CityCode": "RVR",
      "ProvinceId": "UT",
      "CountryCode": "US"
  },
  {
      "CityCode": "RWI",
      "ProvinceId": "NC",
      "CountryCode": "US"
  },
  {
      "CityCode": "RWL",
      "ProvinceId": "WY",
      "CountryCode": "US"
  },
  {
      "CityCode": "RFD",
      "ProvinceId": "IL",
      "CountryCode": "US"
  },
  {
      "CityCode": "RHI",
      "ProvinceId": "WI",
      "CountryCode": "US"
  },
  {
      "CityCode": "RGR",
      "ProvinceId": "TX",
      "CountryCode": "US"
  },
  {
      "CityCode": "QCE",
      "ProvinceId": "CO",
      "CountryCode": "US"
  },
  {
      "CityCode": "QKB",
      "ProvinceId": "CO",
      "CountryCode": "US"
  },
  {
      "CityCode": "QKS",
      "ProvinceId": "CO",
      "CountryCode": "US"
  },
  {
      "CityCode": "SNL",
      "ProvinceId": "OK",
      "CountryCode": "US"
  },
  {
      "CityCode": "SNS",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "SNY",
      "ProvinceId": "NE",
      "CountryCode": "US"
  },
  {
      "CityCode": "SME",
      "ProvinceId": "KY",
      "CountryCode": "US"
  },
  {
      "CityCode": "SHR",
      "ProvinceId": "WY",
      "CountryCode": "US"
  },
  {
      "CityCode": "SMX",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "SNA",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "SBY",
      "ProvinceId": "MD",
      "CountryCode": "US"
  },
  {
      "CityCode": "SBA",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "SBM",
      "ProvinceId": "WI",
      "CountryCode": "US"
  },
  {
      "CityCode": "SBN",
      "ProvinceId": "IN",
      "CountryCode": "US"
  },
  {
      "CityCode": "SBS",
      "ProvinceId": "CO",
      "CountryCode": "US"
  },
  {
      "CityCode": "SFY",
      "ProvinceId": "MA",
      "CountryCode": "US"
  },
  {
      "CityCode": "SFZ",
      "ProvinceId": "RI",
      "CountryCode": "US"
  },
  {
      "CityCode": "SFO",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "SGF",
      "ProvinceId": "MO",
      "CountryCode": "US"
  },
  {
      "CityCode": "SHD",
      "ProvinceId": "VA",
      "CountryCode": "US"
  },
  {
      "CityCode": "SGR",
      "ProvinceId": "TX",
      "CountryCode": "US"
  },
  {
      "CityCode": "SGT",
      "ProvinceId": "AR",
      "CountryCode": "US"
  },
  {
      "CityCode": "SGU",
      "ProvinceId": "UT",
      "CountryCode": "US"
  },
  {
      "CityCode": "SGY",
      "ProvinceId": "AK",
      "CountryCode": "US"
  },
  {
      "CityCode": "ECG",
      "ProvinceId": "NC",
      "CountryCode": "US"
  },
  {
      "CityCode": "EGV",
      "ProvinceId": "WI",
      "CountryCode": "US"
  },
  {
      "CityCode": "EHT",
      "ProvinceId": "CT",
      "CountryCode": "US"
  },
  {
      "CityCode": "EGE",
      "ProvinceId": "CO",
      "CountryCode": "US"
  },
  {
      "CityCode": "EED",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "EEN",
      "ProvinceId": "NH",
      "CountryCode": "US"
  },
  {
      "CityCode": "DLL",
      "ProvinceId": "SC",
      "CountryCode": "US"
  },
  {
      "CityCode": "DYL",
      "ProvinceId": "PA",
      "CountryCode": "US"
  },
  {
      "CityCode": "DLG",
      "ProvinceId": "AK",
      "CountryCode": "US"
  },
  {
      "CityCode": "DLH",
      "ProvinceId": "MN",
      "CountryCode": "US"
  },
  {
      "CityCode": "EAA",
      "ProvinceId": "AK",
      "CountryCode": "US"
  },
  {
      "CityCode": "EAR",
      "ProvinceId": "NE",
      "CountryCode": "US"
  },
  {
      "CityCode": "EAT",
      "ProvinceId": "WA",
      "CountryCode": "US"
  },
  {
      "CityCode": "EAU",
      "ProvinceId": "WI",
      "CountryCode": "US"
  },
  {
      "CityCode": "DIK",
      "ProvinceId": "ND",
      "CountryCode": "US"
  },
  {
      "CityCode": "DHN",
      "ProvinceId": "AL",
      "CountryCode": "US"
  },
  {
      "CityCode": "CUS",
      "ProvinceId": "NM",
      "CountryCode": "US"
  },
  {
      "CityCode": "CVG",
      "ProvinceId": "OH",
      "CountryCode": "US"
  },
  {
      "CityCode": "DEN",
      "ProvinceId": "CO",
      "CountryCode": "US"
  },
  {
      "CityCode": "DFI",
      "ProvinceId": "OH",
      "CountryCode": "US"
  },
  {
      "CityCode": "DFW",
      "ProvinceId": "TX",
      "CountryCode": "US"
  },
  {
      "CityCode": "DCU",
      "ProvinceId": "AL",
      "CountryCode": "US"
  },
  {
      "CityCode": "DDC",
      "ProvinceId": "KS",
      "CountryCode": "US"
  },
  {
      "CityCode": "DEC",
      "ProvinceId": "IL",
      "CountryCode": "US"
  },
  {
      "CityCode": "DEH",
      "ProvinceId": "IA",
      "CountryCode": "US"
  },
  {
      "CityCode": "FWA",
      "ProvinceId": "IN",
      "CountryCode": "US"
  },
  {
      "CityCode": "FYV",
      "ProvinceId": "AR",
      "CountryCode": "US"
  },
  {
      "CityCode": "FTW",
      "ProvinceId": "TX",
      "CountryCode": "US"
  },
  {
      "CityCode": "GGW",
      "ProvinceId": "MT",
      "CountryCode": "US"
  },
  {
      "CityCode": "FST",
      "ProvinceId": "TX",
      "CountryCode": "US"
  },
  {
      "CityCode": "FUL",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "FRR",
      "ProvinceId": "VA",
      "CountryCode": "US"
  },
  {
      "CityCode": "FRM",
      "ProvinceId": "MN",
      "CountryCode": "US"
  },
  {
      "CityCode": "FSD",
      "ProvinceId": "SD",
      "CountryCode": "US"
  },
  {
      "CityCode": "FSM",
      "ProvinceId": "AR",
      "CountryCode": "US"
  },
  {
      "CityCode": "FCY",
      "ProvinceId": "AR",
      "CountryCode": "US"
  },
  {
      "CityCode": "FOD",
      "ProvinceId": "IA",
      "CountryCode": "US"
  },
  {
      "CityCode": "FRD",
      "ProvinceId": "WA",
      "CountryCode": "US"
  },
  {
      "CityCode": "FRG",
      "ProvinceId": "NY",
      "CountryCode": "US"
  },
  {
      "CityCode": "FPR",
      "ProvinceId": "FL",
      "CountryCode": "US"
  },
  {
      "CityCode": "EYW",
      "ProvinceId": "FL",
      "CountryCode": "US"
  },
  {
      "CityCode": "EVV",
      "ProvinceId": "IN",
      "CountryCode": "US"
  },
  {
      "CityCode": "FAR",
      "ProvinceId": "ND",
      "CountryCode": "US"
  },
  {
      "CityCode": "FAT",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "FAY",
      "ProvinceId": "NC",
      "CountryCode": "US"
  },
  {
      "CityCode": "FAI",
      "ProvinceId": "AK",
      "CountryCode": "US"
  },
  {
      "CityCode": "FAJ",
      "ProvinceId": "PR",
      "CountryCode": "US"
  },
  {
      "CityCode": "FCA",
      "ProvinceId": "MT",
      "CountryCode": "US"
  },
  {
      "CityCode": "EVM",
      "ProvinceId": "MN",
      "CountryCode": "US"
  },
  {
      "CityCode": "EWB",
      "ProvinceId": "MA",
      "CountryCode": "US"
  },
  {
      "CityCode": "EWK",
      "ProvinceId": "KS",
      "CountryCode": "US"
  },
  {
      "CityCode": "EWN",
      "ProvinceId": "NC",
      "CountryCode": "US"
  },
  {
      "CityCode": "EXI",
      "ProvinceId": "AK",
      "CountryCode": "US"
  },
  {
      "CityCode": "ETB",
      "ProvinceId": "WI",
      "CountryCode": "US"
  },
  {
      "CityCode": "ETS",
      "ProvinceId": "AL",
      "CountryCode": "US"
  },
  {
      "CityCode": "EUF",
      "ProvinceId": "AL",
      "CountryCode": "US"
  },
  {
      "CityCode": "EUG",
      "ProvinceId": "OR",
      "CountryCode": "US"
  },
  {
      "CityCode": "IFP",
      "ProvinceId": "AZ",
      "CountryCode": "US"
  },
  {
      "CityCode": "IGM",
      "ProvinceId": "AZ",
      "CountryCode": "US"
  },
  {
      "CityCode": "ICT",
      "ProvinceId": "KS",
      "CountryCode": "US"
  },
  {
      "CityCode": "IDA",
      "ProvinceId": "ID",
      "CountryCode": "US"
  },
  {
      "CityCode": "IDI",
      "ProvinceId": "PA",
      "CountryCode": "US"
  },
  {
      "CityCode": "ITH",
      "ProvinceId": "NY",
      "CountryCode": "US"
  },
  {
      "CityCode": "ITO",
      "ProvinceId": "HI",
      "CountryCode": "US"
  },
  {
      "CityCode": "IWD",
      "ProvinceId": "MI",
      "CountryCode": "US"
  },
  {
      "CityCode": "ISM",
      "ProvinceId": "FL",
      "CountryCode": "US"
  },
  {
      "CityCode": "ISN",
      "ProvinceId": "ND",
      "CountryCode": "US"
  },
  {
      "CityCode": "ISO",
      "ProvinceId": "NC",
      "CountryCode": "US"
  },
  {
      "CityCode": "ISP",
      "ProvinceId": "NY",
      "CountryCode": "US"
  },
  {
      "CityCode": "ISQ",
      "ProvinceId": "MI",
      "CountryCode": "US"
  },
  {
      "CityCode": "ISS",
      "ProvinceId": "ME",
      "CountryCode": "US"
  },
  {
      "CityCode": "HYA",
      "ProvinceId": "MA",
      "CountryCode": "US"
  },
  {
      "CityCode": "HYR",
      "ProvinceId": "WI",
      "CountryCode": "US"
  },
  {
      "CityCode": "HYS",
      "ProvinceId": "KS",
      "CountryCode": "US"
  },
  {
      "CityCode": "IAG",
      "ProvinceId": "NY",
      "CountryCode": "US"
  },
  {
      "CityCode": "HOU",
      "ProvinceId": "TX",
      "CountryCode": "US"
  },
  {
      "CityCode": "HVN",
      "ProvinceId": "CT",
      "CountryCode": "US"
  },
  {
      "CityCode": "HVR",
      "ProvinceId": "MT",
      "CountryCode": "US"
  },
  {
      "CityCode": "HWD",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "HOM",
      "ProvinceId": "AK",
      "CountryCode": "US"
  },
  {
      "CityCode": "HON",
      "ProvinceId": "SD",
      "CountryCode": "US"
  },
  {
      "CityCode": "HOP",
      "ProvinceId": "KY",
      "CountryCode": "US"
  },
  {
      "CityCode": "HLM",
      "ProvinceId": "MI",
      "CountryCode": "US"
  },
  {
      "CityCode": "HLN",
      "ProvinceId": "MT",
      "CountryCode": "US"
  },
  {
      "CityCode": "HLB",
      "ProvinceId": "IN",
      "CountryCode": "US"
  },
  {
      "CityCode": "HOB",
      "ProvinceId": "NM",
      "CountryCode": "US"
  },
  {
      "CityCode": "HNB",
      "ProvinceId": "IN",
      "CountryCode": "US"
  },
  {
      "CityCode": "HNH",
      "ProvinceId": "AK",
      "CountryCode": "US"
  },
  {
      "CityCode": "HNL",
      "ProvinceId": "HI",
      "CountryCode": "US"
  },
  {
      "CityCode": "HNM",
      "ProvinceId": "HI",
      "CountryCode": "US"
  },
  {
      "CityCode": "HNS",
      "ProvinceId": "AK",
      "CountryCode": "US"
  },
  {
      "CityCode": "GYY",
      "ProvinceId": "IN",
      "CountryCode": "US"
  },
  {
      "CityCode": "GYR",
      "ProvinceId": "AZ",
      "CountryCode": "US"
  },
  {
      "CityCode": "GWO",
      "ProvinceId": "MS",
      "CountryCode": "US"
  },
  {
      "CityCode": "GWS",
      "ProvinceId": "CO",
      "CountryCode": "US"
  },
  {
      "CityCode": "HKY",
      "ProvinceId": "NC",
      "CountryCode": "US"
  },
  {
      "CityCode": "HKA",
      "ProvinceId": "AR",
      "CountryCode": "US"
  },
  {
      "CityCode": "HKB",
      "ProvinceId": "AK",
      "CountryCode": "US"
  },
  {
      "CityCode": "HAR",
      "ProvinceId": "PA",
      "CountryCode": "US"
  },
  {
      "CityCode": "HIO",
      "ProvinceId": "OR",
      "CountryCode": "US"
  },
  {
      "CityCode": "GUP",
      "ProvinceId": "NM",
      "CountryCode": "US"
  },
  {
      "CityCode": "GMV",
      "ProvinceId": null,
      "CountryCode": "US"
  },
  {
      "CityCode": "GUF",
      "ProvinceId": "AL",
      "CountryCode": "US"
  },
  {
      "CityCode": "GIF",
      "ProvinceId": "FL",
      "CountryCode": "US"
  },
  {
      "CityCode": "GKT",
      "ProvinceId": "TN",
      "CountryCode": "US"
  },
  {
      "CityCode": "GJT",
      "ProvinceId": "CO",
      "CountryCode": "US"
  },
  {
      "CityCode": "GLR",
      "ProvinceId": "MI",
      "CountryCode": "US"
  },
  {
      "CityCode": "GLS",
      "ProvinceId": "TX",
      "CountryCode": "US"
  },
  {
      "CityCode": "GLD",
      "ProvinceId": "KS",
      "CountryCode": "US"
  },
  {
      "CityCode": "GLE",
      "ProvinceId": "TX",
      "CountryCode": "US"
  },
  {
      "CityCode": "GLH",
      "ProvinceId": "MS",
      "CountryCode": "US"
  },
  {
      "CityCode": "ABE",
      "ProvinceId": "PA",
      "CountryCode": "US"
  },
  {
      "CityCode": "ABI",
      "ProvinceId": "TX",
      "CountryCode": "US"
  },
  {
      "CityCode": "ABQ",
      "ProvinceId": "NM",
      "CountryCode": "US"
  },
  {
      "CityCode": "ABR",
      "ProvinceId": "SD",
      "CountryCode": "US"
  },
  {
      "CityCode": "AKN",
      "ProvinceId": "AK",
      "CountryCode": "US"
  },
  {
      "CityCode": "ACK",
      "ProvinceId": "MA",
      "CountryCode": "US"
  },
  {
      "CityCode": "ACT",
      "ProvinceId": "TX",
      "CountryCode": "US"
  },
  {
      "CityCode": "ACV",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "AIY",
      "ProvinceId": "NJ",
      "CountryCode": "US"
  },
  {
      "CityCode": "AIZ",
      "ProvinceId": "MO",
      "CountryCode": "US"
  },
  {
      "CityCode": "ASH",
      "ProvinceId": "NH",
      "CountryCode": "US"
  },
  {
      "CityCode": "ASL",
      "ProvinceId": "TX",
      "CountryCode": "US"
  },
  {
      "CityCode": "AMW",
      "ProvinceId": "IA",
      "CountryCode": "US"
  },
  {
      "CityCode": "ANA",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "ANB",
      "ProvinceId": "AL",
      "CountryCode": "US"
  },
  {
      "CityCode": "AMA",
      "ProvinceId": "TX",
      "CountryCode": "US"
  },
  {
      "CityCode": "ALS",
      "ProvinceId": "CO",
      "CountryCode": "US"
  },
  {
      "CityCode": "ALW",
      "ProvinceId": "WA",
      "CountryCode": "US"
  },
  {
      "CityCode": "ALX",
      "ProvinceId": "AL",
      "CountryCode": "US"
  },
  {
      "CityCode": "ALM",
      "ProvinceId": "NM",
      "CountryCode": "US"
  },
  {
      "CityCode": "ALO",
      "ProvinceId": "IA",
      "CountryCode": "US"
  },
  {
      "CityCode": "ALB",
      "ProvinceId": "NY",
      "CountryCode": "US"
  },
  {
      "CityCode": "ALE",
      "ProvinceId": "TX",
      "CountryCode": "US"
  },
  {
      "CityCode": "BFT",
      "ProvinceId": "SC",
      "CountryCode": "US"
  },
  {
      "CityCode": "BFL",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "BFP",
      "ProvinceId": "PA",
      "CountryCode": "US"
  },
  {
      "CityCode": "BFR",
      "ProvinceId": "IN",
      "CountryCode": "US"
  },
  {
      "CityCode": "BFD",
      "ProvinceId": "PA",
      "CountryCode": "US"
  },
  {
      "CityCode": "BFF",
      "ProvinceId": "NE",
      "CountryCode": "US"
  },
  {
      "CityCode": "BFG",
      "ProvinceId": "UT",
      "CountryCode": "US"
  },
  {
      "CityCode": "BEH",
      "ProvinceId": "MI",
      "CountryCode": "US"
  },
  {
      "CityCode": "BET",
      "ProvinceId": "AK",
      "CountryCode": "US"
  },
  {
      "CityCode": "BLF",
      "ProvinceId": "WV",
      "CountryCode": "US"
  },
  {
      "CityCode": "BLH",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "BLI",
      "ProvinceId": "WA",
      "CountryCode": "US"
  },
  {
      "CityCode": "BGM",
      "ProvinceId": "NY",
      "CountryCode": "US"
  },
  {
      "CityCode": "BLV",
      "ProvinceId": "IL",
      "CountryCode": "US"
  },
  {
      "CityCode": "ATL",
      "ProvinceId": "GA",
      "CountryCode": "US"
  },
  {
      "CityCode": "ATO",
      "ProvinceId": "OH",
      "CountryCode": "US"
  },
  {
      "CityCode": "AUG",
      "ProvinceId": "ME",
      "CountryCode": "US"
  },
  {
      "CityCode": "AUO",
      "ProvinceId": "AL",
      "CountryCode": "US"
  },
  {
      "CityCode": "ATW",
      "ProvinceId": "WI",
      "CountryCode": "US"
  },
  {
      "CityCode": "ATY",
      "ProvinceId": "SD",
      "CountryCode": "US"
  },
  {
      "CityCode": "BDR",
      "ProvinceId": "CT",
      "CountryCode": "US"
  },
  {
      "CityCode": "BED",
      "ProvinceId": "MA",
      "CountryCode": "US"
  },
  {
      "CityCode": "AUS",
      "ProvinceId": "TX",
      "CountryCode": "US"
  },
  {
      "CityCode": "AUW",
      "ProvinceId": "WI",
      "CountryCode": "US"
  },
  {
      "CityCode": "AUZ",
      "ProvinceId": "IL",
      "CountryCode": "US"
  },
  {
      "CityCode": "AVP",
      "ProvinceId": "PA",
      "CountryCode": "US"
  },
  {
      "CityCode": "AVL",
      "ProvinceId": "NC",
      "CountryCode": "US"
  },
  {
      "CityCode": "BUF",
      "ProvinceId": "NY",
      "CountryCode": "US"
  },
  {
      "CityCode": "BTV",
      "ProvinceId": "VT",
      "CountryCode": "US"
  },
  {
      "CityCode": "BTL",
      "ProvinceId": "MI",
      "CountryCode": "US"
  },
  {
      "CityCode": "BTM",
      "ProvinceId": "MT",
      "CountryCode": "US"
  },
  {
      "CityCode": "BTR",
      "ProvinceId": "LA",
      "CountryCode": "US"
  },
  {
      "CityCode": "BOI",
      "ProvinceId": "ID",
      "CountryCode": "US"
  },
  {
      "CityCode": "BMG",
      "ProvinceId": "IN",
      "CountryCode": "US"
  },
  {
      "CityCode": "BMI",
      "ProvinceId": "IL",
      "CountryCode": "US"
  },
  {
      "CityCode": "BNA",
      "ProvinceId": "TN",
      "CountryCode": "US"
  },
  {
      "CityCode": "CCR",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "BUR",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "BVO",
      "ProvinceId": "OK",
      "CountryCode": "US"
  },
  {
      "CityCode": "BWG",
      "ProvinceId": "KY",
      "CountryCode": "US"
  },
  {
      "CityCode": "BWI",
      "ProvinceId": "MD",
      "CountryCode": "US"
  },
  {
      "CityCode": "BVX",
      "ProvinceId": "AR",
      "CountryCode": "US"
  },
  {
      "CityCode": "BWC",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "BWD",
      "ProvinceId": "TX",
      "CountryCode": "US"
  },
  {
      "CityCode": "CLC",
      "ProvinceId": "TX",
      "CountryCode": "US"
  },
  {
      "CityCode": "CLD",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "CLE",
      "ProvinceId": "OH",
      "CountryCode": "US"
  },
  {
      "CityCode": "CLL",
      "ProvinceId": "TX",
      "CountryCode": "US"
  },
  {
      "CityCode": "CLM",
      "ProvinceId": "WA",
      "CountryCode": "US"
  },
  {
      "CityCode": "CKM",
      "ProvinceId": "MS",
      "CountryCode": "US"
  },
  {
      "CityCode": "CKV",
      "ProvinceId": "TN",
      "CountryCode": "US"
  },
  {
      "CityCode": "CJN",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "CKB",
      "ProvinceId": "WV",
      "CountryCode": "US"
  },
  {
      "CityCode": "CEC",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "CDH",
      "ProvinceId": "AR",
      "CountryCode": "US"
  },
  {
      "CityCode": "CDC",
      "ProvinceId": "UT",
      "CountryCode": "US"
  },
  {
      "CityCode": "CDR",
      "ProvinceId": "NE",
      "CountryCode": "US"
  },
  {
      "CityCode": "CDV",
      "ProvinceId": "AK",
      "CountryCode": "US"
  },
  {
      "CityCode": "CDW",
      "ProvinceId": "NJ",
      "CountryCode": "US"
  },
  {
      "CityCode": "CSL",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "CSM",
      "ProvinceId": "OK",
      "CountryCode": "US"
  },
  {
      "CityCode": "CSN",
      "ProvinceId": "NV",
      "CountryCode": "US"
  },
  {
      "CityCode": "CTW",
      "ProvinceId": "AZ",
      "CountryCode": "US"
  },
  {
      "CityCode": "CMH",
      "ProvinceId": "OH",
      "CountryCode": "US"
  },
  {
      "CityCode": "CMI",
      "ProvinceId": "IL",
      "CountryCode": "US"
  },
  {
      "CityCode": "CSG",
      "ProvinceId": "GA",
      "CountryCode": "US"
  },
  {
      "CityCode": "CMX",
      "ProvinceId": "MI",
      "CountryCode": "US"
  },
  {
      "CityCode": "CRX",
      "ProvinceId": "MS",
      "CountryCode": "US"
  },
  {
      "CityCode": "CLT",
      "ProvinceId": "NC",
      "CountryCode": "US"
  },
  {
      "CityCode": "CLU",
      "ProvinceId": "IN",
      "CountryCode": "US"
  },
  {
      "CityCode": "VPS",
      "ProvinceId": "FL",
      "CountryCode": "US"
  },
  {
      "CityCode": "VRB",
      "ProvinceId": "FL",
      "CountryCode": "US"
  },
  {
      "CityCode": "VCT",
      "ProvinceId": "TX",
      "CountryCode": "US"
  },
  {
      "CityCode": "VCV",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "VDI",
      "ProvinceId": "GA",
      "CountryCode": "US"
  },
  {
      "CityCode": "VYS",
      "ProvinceId": "IL",
      "CountryCode": "US"
  },
  {
      "CityCode": "WAL",
      "ProvinceId": "VA",
      "CountryCode": "US"
  },
  {
      "CityCode": "WAS",
      "ProvinceId": "DC",
      "CountryCode": "US"
  },
  {
      "CityCode": "WYS",
      "ProvinceId": "MT",
      "CountryCode": "US"
  },
  {
      "CityCode": "WWD",
      "ProvinceId": "NJ",
      "CountryCode": "US"
  },
  {
      "CityCode": "WBU",
      "ProvinceId": "CO",
      "CountryCode": "US"
  },
  {
      "CityCode": "WDG",
      "ProvinceId": "OK",
      "CountryCode": "US"
  },
  {
      "CityCode": "YKM",
      "ProvinceId": "WA",
      "CountryCode": "US"
  },
  {
      "CityCode": "YKN",
      "ProvinceId": "SD",
      "CountryCode": "US"
  },
  {
      "CityCode": "XMR",
      "ProvinceId": "FL",
      "CountryCode": "US"
  },
  {
      "CityCode": "UST",
      "ProvinceId": "FL",
      "CountryCode": "US"
  },
  {
      "CityCode": "TXK",
      "ProvinceId": "AR",
      "CountryCode": "US"
  },
  {
      "CityCode": "TYR",
      "ProvinceId": "TX",
      "CountryCode": "US"
  },
  {
      "CityCode": "TYS",
      "ProvinceId": "TN",
      "CountryCode": "US"
  },
  {
      "CityCode": "TWF",
      "ProvinceId": "ID",
      "CountryCode": "US"
  },
  {
      "CityCode": "UCA",
      "ProvinceId": "NY",
      "CountryCode": "US"
  },
  {
      "CityCode": "TVC",
      "ProvinceId": "MI",
      "CountryCode": "US"
  },
  {
      "CityCode": "TVF",
      "ProvinceId": "MN",
      "CountryCode": "US"
  },
  {
      "CityCode": "TVL",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "TUP",
      "ProvinceId": "MS",
      "CountryCode": "US"
  },
  {
      "CityCode": "TUS",
      "ProvinceId": "AZ",
      "CountryCode": "US"
  },
  {
      "CityCode": "TUL",
      "ProvinceId": "OK",
      "CountryCode": "US"
  },
  {
      "CityCode": "TOL",
      "ProvinceId": "OH",
      "CountryCode": "US"
  },
  {
      "CityCode": "TOP",
      "ProvinceId": "KS",
      "CountryCode": "US"
  },
  {
      "CityCode": "TOR",
      "ProvinceId": "WY",
      "CountryCode": "US"
  },
  {
      "CityCode": "STC",
      "ProvinceId": "MN",
      "CountryCode": "US"
  },
  {
      "CityCode": "STP",
      "ProvinceId": "MN",
      "CountryCode": "US"
  },
  {
      "CityCode": "STL",
      "ProvinceId": "MO",
      "CountryCode": "US"
  },
  {
      "CityCode": "STX",
      "ProvinceId": "VI",
      "CountryCode": "US"
  },
  {
      "CityCode": "STS",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "STT",
      "ProvinceId": "VI",
      "CountryCode": "US"
  },
  {
      "CityCode": "SUE",
      "ProvinceId": "WI",
      "CountryCode": "US"
  },
  {
      "CityCode": "STE",
      "ProvinceId": "WI",
      "CountryCode": "US"
  },
  {
      "CityCode": "SUA",
      "ProvinceId": "FL",
      "CountryCode": "US"
  },
  {
      "CityCode": "SVH",
      "ProvinceId": "NC",
      "CountryCode": "US"
  },
  {
      "CityCode": "SUM",
      "ProvinceId": "SC",
      "CountryCode": "US"
  },
  {
      "CityCode": "SUN",
      "ProvinceId": "ID",
      "CountryCode": "US"
  },
  {
      "CityCode": "SUU",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "SUW",
      "ProvinceId": "WI",
      "CountryCode": "US"
  },
  {
      "CityCode": "SUX",
      "ProvinceId": "IA",
      "CountryCode": "US"
  },
  {
      "CityCode": "SVC",
      "ProvinceId": "NM",
      "CountryCode": "US"
  },
  {
      "CityCode": "TBN",
      "ProvinceId": "MO",
      "CountryCode": "US"
  },
  {
      "CityCode": "TCL",
      "ProvinceId": "AL",
      "CountryCode": "US"
  },
  {
      "CityCode": "TMA",
      "ProvinceId": "GA",
      "CountryCode": "US"
  },
  {
      "CityCode": "TLH",
      "ProvinceId": "FL",
      "CountryCode": "US"
  },
  {
      "CityCode": "TLR",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "YAK",
      "ProvinceId": "AK",
      "CountryCode": "US"
  },
  {
      "CityCode": "ZZV",
      "ProvinceId": "OH",
      "CountryCode": "US"
  },
  {
      "CityCode": "JMH",
      "ProvinceId": null,
      "CountryCode": "US"
  },
  {
      "CityCode": "LE1",
      "ProvinceId": "TX",
      "CountryCode": "US"
  },
  {
      "CityCode": "VC3",
      "ProvinceId": "CO",
      "CountryCode": "US"
  },
  {
      "CityCode": "AEX",
      "ProvinceId": "LA",
      "CountryCode": "US"
  },
  {
      "CityCode": "AEL",
      "ProvinceId": "MN",
      "CountryCode": "US"
  },
  {
      "CityCode": "ADG",
      "ProvinceId": "MI",
      "CountryCode": "US"
  },
  {
      "CityCode": "ADK",
      "ProvinceId": "AK",
      "CountryCode": "US"
  },
  {
      "CityCode": "ADM",
      "ProvinceId": "OK",
      "CountryCode": "US"
  },
  {
      "CityCode": "ADQ",
      "ProvinceId": "AK",
      "CountryCode": "US"
  },
  {
      "CityCode": "ADT",
      "ProvinceId": "OK",
      "CountryCode": "US"
  },
  {
      "CityCode": "ADW",
      "ProvinceId": "MD",
      "CountryCode": "US"
  },
  {
      "CityCode": "AIA",
      "ProvinceId": "NE",
      "CountryCode": "US"
  },
  {
      "CityCode": "AID",
      "ProvinceId": "IN",
      "CountryCode": "US"
  },
  {
      "CityCode": "AIK",
      "ProvinceId": "SC",
      "CountryCode": "US"
  },
  {
      "CityCode": "AGO",
      "ProvinceId": "AR",
      "CountryCode": "US"
  },
  {
      "CityCode": "AGS",
      "ProvinceId": "GA",
      "CountryCode": "US"
  },
  {
      "CityCode": "AHN",
      "ProvinceId": "GA",
      "CountryCode": "US"
  },
  {
      "CityCode": "C33",
      "ProvinceId": null,
      "CountryCode": "US"
  },
  {
      "CityCode": "CTY",
      "ProvinceId": null,
      "CountryCode": "US"
  },
  {
      "CityCode": "BA9",
      "ProvinceId": "FL",
      "CountryCode": "US"
  },
  {
      "CityCode": "EST",
      "ProvinceId": null,
      "CountryCode": "US"
  },
  {
      "CityCode": "ZSM",
      "ProvinceId": null,
      "CountryCode": "US"
  },
  {
      "CityCode": "HRL",
      "ProvinceId": "TX",
      "CountryCode": "US"
  },
  {
      "CityCode": "HRO",
      "ProvinceId": "AR",
      "CountryCode": "US"
  },
  {
      "CityCode": "HSI",
      "ProvinceId": "NE",
      "CountryCode": "US"
  },
  {
      "CityCode": "HSP",
      "ProvinceId": "VA",
      "CountryCode": "US"
  },
  {
      "CityCode": "HST",
      "ProvinceId": "FL",
      "CountryCode": "US"
  },
  {
      "CityCode": "HSV",
      "ProvinceId": "AL",
      "CountryCode": "US"
  },
  {
      "CityCode": "HTO",
      "ProvinceId": "NY",
      "CountryCode": "US"
  },
  {
      "CityCode": "HTS",
      "ProvinceId": "WV",
      "CountryCode": "US"
  },
  {
      "CityCode": "HTV",
      "ProvinceId": "TX",
      "CountryCode": "US"
  },
  {
      "CityCode": "HUC",
      "ProvinceId": "PR",
      "CountryCode": "US"
  },
  {
      "CityCode": "HUF",
      "ProvinceId": "IN",
      "CountryCode": "US"
  },
  {
      "CityCode": "HUT",
      "ProvinceId": "KS",
      "CountryCode": "US"
  },
  {
      "CityCode": "IJX",
      "ProvinceId": "IL",
      "CountryCode": "US"
  },
  {
      "CityCode": "IKK",
      "ProvinceId": "IL",
      "CountryCode": "US"
  },
  {
      "CityCode": "ILE",
      "ProvinceId": "TX",
      "CountryCode": "US"
  },
  {
      "CityCode": "ILG",
      "ProvinceId": "DE",
      "CountryCode": "US"
  },
  {
      "CityCode": "ILM",
      "ProvinceId": "NC",
      "CountryCode": "US"
  },
  {
      "CityCode": "HUM",
      "ProvinceId": "LA",
      "CountryCode": "US"
  },
  {
      "CityCode": "HOT",
      "ProvinceId": "AR",
      "CountryCode": "US"
  },
  {
      "CityCode": "HPN",
      "ProvinceId": "NY",
      "CountryCode": "US"
  },
  {
      "CityCode": "HPV",
      "ProvinceId": "HI",
      "CountryCode": "US"
  },
  {
      "CityCode": "HHR",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "HIB",
      "ProvinceId": "MN",
      "CountryCode": "US"
  },
  {
      "CityCode": "HHH",
      "ProvinceId": "SC",
      "CountryCode": "US"
  },
  {
      "CityCode": "HII",
      "ProvinceId": "AZ",
      "CountryCode": "US"
  },
  {
      "CityCode": "HFD",
      "ProvinceId": "CT",
      "CountryCode": "US"
  },
  {
      "CityCode": "HEZ",
      "ProvinceId": "MS",
      "CountryCode": "US"
  },
  {
      "CityCode": "HGR",
      "ProvinceId": "MD",
      "CountryCode": "US"
  },
  {
      "CityCode": "KCK",
      "ProvinceId": "KS",
      "CountryCode": "US"
  },
  {
      "CityCode": "JLN",
      "ProvinceId": "MO",
      "CountryCode": "US"
  },
  {
      "CityCode": "JMC",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "JMS",
      "ProvinceId": "ND",
      "CountryCode": "US"
  },
  {
      "CityCode": "JKV",
      "ProvinceId": "TX",
      "CountryCode": "US"
  },
  {
      "CityCode": "JEF",
      "ProvinceId": "MO",
      "CountryCode": "US"
  },
  {
      "CityCode": "JHW",
      "ProvinceId": "NY",
      "CountryCode": "US"
  },
  {
      "CityCode": "JHM",
      "ProvinceId": "HI",
      "CountryCode": "US"
  },
  {
      "CityCode": "IRK",
      "ProvinceId": "MO",
      "CountryCode": "US"
  },
  {
      "CityCode": "IRS",
      "ProvinceId": "MI",
      "CountryCode": "US"
  },
  {
      "CityCode": "IPT",
      "ProvinceId": "PA",
      "CountryCode": "US"
  },
  {
      "CityCode": "JAN",
      "ProvinceId": "MS",
      "CountryCode": "US"
  },
  {
      "CityCode": "JAX",
      "ProvinceId": "FL",
      "CountryCode": "US"
  },
  {
      "CityCode": "JBR",
      "ProvinceId": "AR",
      "CountryCode": "US"
  },
  {
      "CityCode": "JBS",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "INL",
      "ProvinceId": "MN",
      "CountryCode": "US"
  },
  {
      "CityCode": "INT",
      "ProvinceId": "NC",
      "CountryCode": "US"
  },
  {
      "CityCode": "IMT",
      "ProvinceId": "MI",
      "CountryCode": "US"
  },
  {
      "CityCode": "IND",
      "ProvinceId": "IN",
      "CountryCode": "US"
  },
  {
      "CityCode": "IPL",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "INW",
      "ProvinceId": "AZ",
      "CountryCode": "US"
  },
  {
      "CityCode": "HBG",
      "ProvinceId": "MS",
      "CountryCode": "US"
  },
  {
      "CityCode": "HDN",
      "ProvinceId": "CO",
      "CountryCode": "US"
  },
  {
      "CityCode": "GUC",
      "ProvinceId": "CO",
      "CountryCode": "US"
  },
  {
      "CityCode": "GTR",
      "ProvinceId": "MS",
      "CountryCode": "US"
  },
  {
      "CityCode": "GTY",
      "ProvinceId": "PA",
      "CountryCode": "US"
  },
  {
      "CityCode": "GTF",
      "ProvinceId": "MT",
      "CountryCode": "US"
  },
  {
      "CityCode": "GSB",
      "ProvinceId": "NC",
      "CountryCode": "US"
  },
  {
      "CityCode": "GSO",
      "ProvinceId": "NC",
      "CountryCode": "US"
  },
  {
      "CityCode": "GSP",
      "ProvinceId": "SC",
      "CountryCode": "US"
  },
  {
      "CityCode": "GST",
      "ProvinceId": "AK",
      "CountryCode": "US"
  },
  {
      "CityCode": "GRR",
      "ProvinceId": "MI",
      "CountryCode": "US"
  },
  {
      "CityCode": "GRK",
      "ProvinceId": "TX",
      "CountryCode": "US"
  },
  {
      "CityCode": "GPT",
      "ProvinceId": "MS",
      "CountryCode": "US"
  },
  {
      "CityCode": "GPZ",
      "ProvinceId": "MN",
      "CountryCode": "US"
  },
  {
      "CityCode": "GQQ",
      "ProvinceId": "OH",
      "CountryCode": "US"
  },
  {
      "CityCode": "GRB",
      "ProvinceId": "WI",
      "CountryCode": "US"
  },
  {
      "CityCode": "GRI",
      "ProvinceId": "NE",
      "CountryCode": "US"
  },
  {
      "CityCode": "GNV",
      "ProvinceId": "FL",
      "CountryCode": "US"
  },
  {
      "CityCode": "GON",
      "ProvinceId": "CT",
      "CountryCode": "US"
  },
  {
      "CityCode": "GCY",
      "ProvinceId": "TN",
      "CountryCode": "US"
  },
  {
      "CityCode": "GED",
      "ProvinceId": "DE",
      "CountryCode": "US"
  },
  {
      "CityCode": "GEG",
      "ProvinceId": "WA",
      "CountryCode": "US"
  },
  {
      "CityCode": "GCC",
      "ProvinceId": "WY",
      "CountryCode": "US"
  },
  {
      "CityCode": "GCN",
      "ProvinceId": "AZ",
      "CountryCode": "US"
  },
  {
      "CityCode": "GCK",
      "ProvinceId": "KS",
      "CountryCode": "US"
  },
  {
      "CityCode": "GFD",
      "ProvinceId": "IN",
      "CountryCode": "US"
  },
  {
      "CityCode": "GGG",
      "ProvinceId": "TX",
      "CountryCode": "US"
  },
  {
      "CityCode": "GFK",
      "ProvinceId": "ND",
      "CountryCode": "US"
  },
  {
      "CityCode": "GFL",
      "ProvinceId": "NY",
      "CountryCode": "US"
  },
  {
      "CityCode": "FNL",
      "ProvinceId": "CO",
      "CountryCode": "US"
  },
  {
      "CityCode": "FNT",
      "ProvinceId": "MI",
      "CountryCode": "US"
  },
  {
      "CityCode": "FMS",
      "ProvinceId": "IA",
      "CountryCode": "US"
  },
  {
      "CityCode": "FMY",
      "ProvinceId": "FL",
      "CountryCode": "US"
  },
  {
      "CityCode": "FMH",
      "ProvinceId": "MA",
      "CountryCode": "US"
  },
  {
      "CityCode": "FMN",
      "ProvinceId": "NM",
      "CountryCode": "US"
  },
  {
      "CityCode": "GAL",
      "ProvinceId": "AK",
      "CountryCode": "US"
  },
  {
      "CityCode": "GAD",
      "ProvinceId": "AL",
      "CountryCode": "US"
  },
  {
      "CityCode": "GAI",
      "ProvinceId": "MD",
      "CountryCode": "US"
  },
  {
      "CityCode": "GBD",
      "ProvinceId": "KS",
      "CountryCode": "US"
  },
  {
      "CityCode": "GBG",
      "ProvinceId": "IL",
      "CountryCode": "US"
  },
  {
      "CityCode": "FLO",
      "ProvinceId": "SC",
      "CountryCode": "US"
  },
  {
      "CityCode": "FLG",
      "ProvinceId": "AZ",
      "CountryCode": "US"
  },
  {
      "CityCode": "FLL",
      "ProvinceId": "FL",
      "CountryCode": "US"
  },
  {
      "CityCode": "FDK",
      "ProvinceId": "MD",
      "CountryCode": "US"
  },
  {
      "CityCode": "FKL",
      "ProvinceId": "PA",
      "CountryCode": "US"
  },
  {
      "CityCode": "KKT",
      "ProvinceId": "IN",
      "CountryCode": "US"
  },
  {
      "CityCode": "KLG",
      "ProvinceId": "AK",
      "CountryCode": "US"
  },
  {
      "CityCode": "KYL",
      "ProvinceId": "FL",
      "CountryCode": "US"
  },
  {
      "CityCode": "KTS",
      "ProvinceId": "AK",
      "CountryCode": "US"
  },
  {
      "CityCode": "KTN",
      "ProvinceId": "AK",
      "CountryCode": "US"
  },
  {
      "CityCode": "LRD",
      "ProvinceId": "TX",
      "CountryCode": "US"
  },
  {
      "CityCode": "LPO",
      "ProvinceId": "IN",
      "CountryCode": "US"
  },
  {
      "CityCode": "LPS",
      "ProvinceId": "WA",
      "CountryCode": "US"
  },
  {
      "CityCode": "LRU",
      "ProvinceId": "NM",
      "CountryCode": "US"
  },
  {
      "CityCode": "LSE",
      "ProvinceId": "WI",
      "CountryCode": "US"
  },
  {
      "CityCode": "LGU",
      "ProvinceId": "UT",
      "CountryCode": "US"
  },
  {
      "CityCode": "LOZ",
      "ProvinceId": "KY",
      "CountryCode": "US"
  },
  {
      "CityCode": "LNY",
      "ProvinceId": "HI",
      "CountryCode": "US"
  },
  {
      "CityCode": "LNS",
      "ProvinceId": "PA",
      "CountryCode": "US"
  },
  {
      "CityCode": "LGB",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "LFT",
      "ProvinceId": "LA",
      "CountryCode": "US"
  },
  {
      "CityCode": "LFK",
      "ProvinceId": "TX",
      "CountryCode": "US"
  },
  {
      "CityCode": "LEW",
      "ProvinceId": "ME",
      "CountryCode": "US"
  },
  {
      "CityCode": "LEX",
      "ProvinceId": "KY",
      "CountryCode": "US"
  },
  {
      "CityCode": "LEB",
      "ProvinceId": "NH",
      "CountryCode": "US"
  },
  {
      "CityCode": "LEE",
      "ProvinceId": "FL",
      "CountryCode": "US"
  },
  {
      "CityCode": "LDJ",
      "ProvinceId": "NJ",
      "CountryCode": "US"
  },
  {
      "CityCode": "MIV",
      "ProvinceId": "NJ",
      "CountryCode": "US"
  },
  {
      "CityCode": "MIW",
      "ProvinceId": "IA",
      "CountryCode": "US"
  },
  {
      "CityCode": "MIE",
      "ProvinceId": "IN",
      "CountryCode": "US"
  },
  {
      "CityCode": "MIA",
      "ProvinceId": "FL",
      "CountryCode": "US"
  },
  {
      "CityCode": "MHV",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "MHT",
      "ProvinceId": "NH",
      "CountryCode": "US"
  },
  {
      "CityCode": "MHK",
      "ProvinceId": "KS",
      "CountryCode": "US"
  },
  {
      "CityCode": "MDW",
      "ProvinceId": "IL",
      "CountryCode": "US"
  },
  {
      "CityCode": "MHE",
      "ProvinceId": "SD",
      "CountryCode": "US"
  },
  {
      "CityCode": "MDH",
      "ProvinceId": "IL",
      "CountryCode": "US"
  },
  {
      "CityCode": "MCN",
      "ProvinceId": "GA",
      "CountryCode": "US"
  },
  {
      "CityCode": "ORL",
      "ProvinceId": "FL",
      "CountryCode": "US"
  },
  {
      "CityCode": "MCW",
      "ProvinceId": "IA",
      "CountryCode": "US"
  },
  {
      "CityCode": "MAZ",
      "ProvinceId": "PR",
      "CountryCode": "US"
  },
  {
      "CityCode": "MCE",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "MCK",
      "ProvinceId": "NE",
      "CountryCode": "US"
  },
  {
      "CityCode": "MBL",
      "ProvinceId": "MI",
      "CountryCode": "US"
  },
  {
      "CityCode": "MBS",
      "ProvinceId": "MI",
      "CountryCode": "US"
  },
  {
      "CityCode": "LTS",
      "ProvinceId": "OK",
      "CountryCode": "US"
  },
  {
      "CityCode": "MAE",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "MAF",
      "ProvinceId": "TX",
      "CountryCode": "US"
  },
  {
      "CityCode": "MRY",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "MSL",
      "ProvinceId": "AL",
      "CountryCode": "US"
  },
  {
      "CityCode": "MSN",
      "ProvinceId": "WI",
      "CountryCode": "US"
  },
  {
      "CityCode": "MSO",
      "ProvinceId": "MT",
      "CountryCode": "US"
  },
  {
      "CityCode": "MSP",
      "ProvinceId": "MN",
      "CountryCode": "US"
  },
  {
      "CityCode": "MRB",
      "ProvinceId": "WV",
      "CountryCode": "US"
  },
  {
      "CityCode": "MRC",
      "ProvinceId": "TN",
      "CountryCode": "US"
  },
  {
      "CityCode": "MOT",
      "ProvinceId": "ND",
      "CountryCode": "US"
  },
  {
      "CityCode": "MOU",
      "ProvinceId": "AK",
      "CountryCode": "US"
  },
  {
      "CityCode": "MOP",
      "ProvinceId": "MI",
      "CountryCode": "US"
  },
  {
      "CityCode": "MQT",
      "ProvinceId": "MI",
      "CountryCode": "US"
  },
  {
      "CityCode": "MQY",
      "ProvinceId": "TN",
      "CountryCode": "US"
  },
  {
      "CityCode": "MPR",
      "ProvinceId": "KS",
      "CountryCode": "US"
  },
  {
      "CityCode": "MPV",
      "ProvinceId": "VT",
      "CountryCode": "US"
  },
  {
      "CityCode": "MKC",
      "ProvinceId": "MO",
      "CountryCode": "US"
  },
  {
      "CityCode": "MKE",
      "ProvinceId": "WI",
      "CountryCode": "US"
  },
  {
      "CityCode": "MKG",
      "ProvinceId": "MI",
      "CountryCode": "US"
  },
  {
      "CityCode": "MKK",
      "ProvinceId": "HI",
      "CountryCode": "US"
  },
  {
      "CityCode": "MKL",
      "ProvinceId": "TN",
      "CountryCode": "US"
  },
  {
      "CityCode": "MKT",
      "ProvinceId": "MN",
      "CountryCode": "US"
  },
  {
      "CityCode": "MKO",
      "ProvinceId": "OK",
      "CountryCode": "US"
  },
  {
      "CityCode": "MLB",
      "ProvinceId": "FL",
      "CountryCode": "US"
  },
  {
      "CityCode": "DNV",
      "ProvinceId": "IL",
      "CountryCode": "US"
  },
  {
      "CityCode": "DRO",
      "ProvinceId": "CO",
      "CountryCode": "US"
  },
  {
      "CityCode": "DOV",
      "ProvinceId": "DE",
      "CountryCode": "US"
  },
  {
      "CityCode": "DUG",
      "ProvinceId": "AZ",
      "CountryCode": "US"
  },
  {
      "CityCode": "DUJ",
      "ProvinceId": "PA",
      "CountryCode": "US"
  },
  {
      "CityCode": "DUT",
      "ProvinceId": "AK",
      "CountryCode": "US"
  },
  {
      "CityCode": "DVL",
      "ProvinceId": "ND",
      "CountryCode": "US"
  },
  {
      "CityCode": "DVN",
      "ProvinceId": "IA",
      "CountryCode": "US"
  },
  {
      "CityCode": "DSI",
      "ProvinceId": "FL",
      "CountryCode": "US"
  },
  {
      "CityCode": "DSM",
      "ProvinceId": "IA",
      "CountryCode": "US"
  },
  {
      "CityCode": "DTW",
      "ProvinceId": "MI",
      "CountryCode": "US"
  },
  {
      "CityCode": "DRT",
      "ProvinceId": "TX",
      "CountryCode": "US"
  },
  {
      "CityCode": "EKX",
      "ProvinceId": "KY",
      "CountryCode": "US"
  },
  {
      "CityCode": "ELD",
      "ProvinceId": "AR",
      "CountryCode": "US"
  },
  {
      "CityCode": "DXR",
      "ProvinceId": "CT",
      "CountryCode": "US"
  },
  {
      "CityCode": "ELK",
      "ProvinceId": "OK",
      "CountryCode": "US"
  },
  {
      "CityCode": "ELM",
      "ProvinceId": "NY",
      "CountryCode": "US"
  },
  {
      "CityCode": "ELP",
      "ProvinceId": "TX",
      "CountryCode": "US"
  },
  {
      "CityCode": "EKI",
      "ProvinceId": "IN",
      "CountryCode": "US"
  },
  {
      "CityCode": "EKN",
      "ProvinceId": "WV",
      "CountryCode": "US"
  },
  {
      "CityCode": "EKO",
      "ProvinceId": "NV",
      "CountryCode": "US"
  },
  {
      "CityCode": "ELY",
      "ProvinceId": "NV",
      "CountryCode": "US"
  },
  {
      "CityCode": "ENL",
      "ProvinceId": "IL",
      "CountryCode": "US"
  },
  {
      "CityCode": "EMT",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "ENA",
      "ProvinceId": "AK",
      "CountryCode": "US"
  },
  {
      "CityCode": "ENW",
      "ProvinceId": "WI",
      "CountryCode": "US"
  },
  {
      "CityCode": "EOK",
      "ProvinceId": "IA",
      "CountryCode": "US"
  },
  {
      "CityCode": "ERI",
      "ProvinceId": "PA",
      "CountryCode": "US"
  },
  {
      "CityCode": "ESC",
      "ProvinceId": "MI",
      "CountryCode": "US"
  },
  {
      "CityCode": "ESD",
      "ProvinceId": "WA",
      "CountryCode": "US"
  },
  {
      "CityCode": "ESN",
      "ProvinceId": "MD",
      "CountryCode": "US"
  },
  {
      "CityCode": "ESP",
      "ProvinceId": "PA",
      "CountryCode": "US"
  },
  {
      "CityCode": "FFM",
      "ProvinceId": "MN",
      "CountryCode": "US"
  },
  {
      "CityCode": "FHU",
      "ProvinceId": "AZ",
      "CountryCode": "US"
  },
  {
      "CityCode": "BIR",
      "ProvinceId": null,
      "CountryCode": "US"
  },
  {
      "CityCode": "CYS",
      "ProvinceId": "WY",
      "CountryCode": "US"
  },
  {
      "CityCode": "DAN",
      "ProvinceId": "VA",
      "CountryCode": "US"
  },
  {
      "CityCode": "DAB",
      "ProvinceId": "FL",
      "CountryCode": "US"
  },
  {
      "CityCode": "DMO",
      "ProvinceId": "MO",
      "CountryCode": "US"
  },
  {
      "CityCode": "DLS",
      "ProvinceId": "OR",
      "CountryCode": "US"
  },
  {
      "CityCode": "DAY",
      "ProvinceId": "OH",
      "CountryCode": "US"
  },
  {
      "CityCode": "DBN",
      "ProvinceId": "GA",
      "CountryCode": "US"
  },
  {
      "CityCode": "DBQ",
      "ProvinceId": "IA",
      "CountryCode": "US"
  },
  {
      "CityCode": "CWI",
      "ProvinceId": "IA",
      "CountryCode": "US"
  },
  {
      "CityCode": "CXL",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "CXO",
      "ProvinceId": "TX",
      "CountryCode": "US"
  },
  {
      "CityCode": "CNY",
      "ProvinceId": "UT",
      "CountryCode": "US"
  },
  {
      "CityCode": "COD",
      "ProvinceId": "WY",
      "CountryCode": "US"
  },
  {
      "CityCode": "COE",
      "ProvinceId": "ID",
      "CountryCode": "US"
  },
  {
      "CityCode": "COI",
      "ProvinceId": "FL",
      "CountryCode": "US"
  },
  {
      "CityCode": "COS",
      "ProvinceId": "CO",
      "CountryCode": "US"
  },
  {
      "CityCode": "COU",
      "ProvinceId": "MO",
      "CountryCode": "US"
  },
  {
      "CityCode": "CVN",
      "ProvinceId": "NM",
      "CountryCode": "US"
  },
  {
      "CityCode": "CVO",
      "ProvinceId": "OR",
      "CountryCode": "US"
  },
  {
      "CityCode": "CRW",
      "ProvinceId": "WV",
      "CountryCode": "US"
  },
  {
      "CityCode": "CRP",
      "ProvinceId": "TX",
      "CountryCode": "US"
  },
  {
      "CityCode": "CPR",
      "ProvinceId": "WY",
      "CountryCode": "US"
  },
  {
      "CityCode": "CEU",
      "ProvinceId": "SC",
      "CountryCode": "US"
  },
  {
      "CityCode": "CEY",
      "ProvinceId": "KY",
      "CountryCode": "US"
  },
  {
      "CityCode": "CEZ",
      "ProvinceId": "CO",
      "CountryCode": "US"
  },
  {
      "CityCode": "CMY",
      "ProvinceId": "WI",
      "CountryCode": "US"
  },
  {
      "CityCode": "CNM",
      "ProvinceId": "NM",
      "CountryCode": "US"
  },
  {
      "CityCode": "CIC",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "CID",
      "ProvinceId": "IA",
      "CountryCode": "US"
  },
  {
      "CityCode": "CIG",
      "ProvinceId": "CO",
      "CountryCode": "US"
  },
  {
      "CityCode": "CHA",
      "ProvinceId": "TN",
      "CountryCode": "US"
  },
  {
      "CityCode": "CHD",
      "ProvinceId": "AZ",
      "CountryCode": "US"
  },
  {
      "CityCode": "CHO",
      "ProvinceId": "VA",
      "CountryCode": "US"
  },
  {
      "CityCode": "CHS",
      "ProvinceId": "SC",
      "CountryCode": "US"
  },
  {
      "CityCode": "CGA",
      "ProvinceId": "AK",
      "CountryCode": "US"
  },
  {
      "CityCode": "CGI",
      "ProvinceId": "MO",
      "CountryCode": "US"
  },
  {
      "CityCode": "ARB",
      "ProvinceId": "MI",
      "CountryCode": "US"
  },
  {
      "CityCode": "ASE",
      "ProvinceId": "CO",
      "CountryCode": "US"
  },
  {
      "CityCode": "ARV",
      "ProvinceId": "WI",
      "CountryCode": "US"
  },
  {
      "CityCode": "ART",
      "ProvinceId": "NY",
      "CountryCode": "US"
  },
  {
      "CityCode": "ANP",
      "ProvinceId": "MD",
      "CountryCode": "US"
  },
  {
      "CityCode": "ANI",
      "ProvinceId": "AK",
      "CountryCode": "US"
  },
  {
      "CityCode": "ANC",
      "ProvinceId": "AK",
      "CountryCode": "US"
  },
  {
      "CityCode": "AND",
      "ProvinceId": "SC",
      "CountryCode": "US"
  },
  {
      "CityCode": "APN",
      "ProvinceId": "MI",
      "CountryCode": "US"
  },
  {
      "CityCode": "APC",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "APF",
      "ProvinceId": "FL",
      "CountryCode": "US"
  },
  {
      "CityCode": "AOO",
      "ProvinceId": "PA",
      "CountryCode": "US"
  },
  {
      "CityCode": "AOH",
      "ProvinceId": "OH",
      "CountryCode": "US"
  },
  {
      "CityCode": "ANW",
      "ProvinceId": "NE",
      "CountryCode": "US"
  },
  {
      "CityCode": "BBC",
      "ProvinceId": "TX",
      "CountryCode": "US"
  },
  {
      "CityCode": "BCB",
      "ProvinceId": "VA",
      "CountryCode": "US"
  },
  {
      "CityCode": "BCE",
      "ProvinceId": "UT",
      "CountryCode": "US"
  },
  {
      "CityCode": "BBW",
      "ProvinceId": "NE",
      "CountryCode": "US"
  },
  {
      "CityCode": "AZO",
      "ProvinceId": "MI",
      "CountryCode": "US"
  },
  {
      "CityCode": "AXV",
      "ProvinceId": "OH",
      "CountryCode": "US"
  },
  {
      "CityCode": "AYS",
      "ProvinceId": "GA",
      "CountryCode": "US"
  },
  {
      "CityCode": "AXN",
      "ProvinceId": "MN",
      "CountryCode": "US"
  },
  {
      "CityCode": "ECP",
      "ProvinceId": null,
      "CountryCode": "US"
  },
  {
      "CityCode": "AVX",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "BZN",
      "ProvinceId": "MT",
      "CountryCode": "US"
  },
  {
      "CityCode": "BYW",
      "ProvinceId": "WA",
      "CountryCode": "US"
  },
  {
      "CityCode": "BZT",
      "ProvinceId": "TX",
      "CountryCode": "US"
  },
  {
      "CityCode": "BXS",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "BYI",
      "ProvinceId": "ID",
      "CountryCode": "US"
  },
  {
      "CityCode": "BSQ",
      "ProvinceId": "AZ",
      "CountryCode": "US"
  },
  {
      "CityCode": "BSI",
      "ProvinceId": "PA",
      "CountryCode": "US"
  },
  {
      "CityCode": "BRW",
      "ProvinceId": "AK",
      "CountryCode": "US"
  },
  {
      "CityCode": "CBK",
      "ProvinceId": "KS",
      "CountryCode": "US"
  },
  {
      "CityCode": "CBE",
      "ProvinceId": "MD",
      "CountryCode": "US"
  },
  {
      "CityCode": "CBF",
      "ProvinceId": "IA",
      "CountryCode": "US"
  },
  {
      "CityCode": "CAK",
      "ProvinceId": "OH",
      "CountryCode": "US"
  },
  {
      "CityCode": "CAD",
      "ProvinceId": "MI",
      "CountryCode": "US"
  },
  {
      "CityCode": "CAE",
      "ProvinceId": "SC",
      "CountryCode": "US"
  },
  {
      "CityCode": "BKW",
      "ProvinceId": "WV",
      "CountryCode": "US"
  },
  {
      "CityCode": "BKX",
      "ProvinceId": "SD",
      "CountryCode": "US"
  },
  {
      "CityCode": "BOS",
      "ProvinceId": "MA",
      "CountryCode": "US"
  },
  {
      "CityCode": "BJC",
      "ProvinceId": "CO",
      "CountryCode": "US"
  },
  {
      "CityCode": "BJI",
      "ProvinceId": "MN",
      "CountryCode": "US"
  },
  {
      "CityCode": "BIS",
      "ProvinceId": "ND",
      "CountryCode": "US"
  },
  {
      "CityCode": "BPT",
      "ProvinceId": "TX",
      "CountryCode": "US"
  },
  {
      "CityCode": "BQK",
      "ProvinceId": "GA",
      "CountryCode": "US"
  },
  {
      "CityCode": "BRD",
      "ProvinceId": "MN",
      "CountryCode": "US"
  },
  {
      "CityCode": "BRO",
      "ProvinceId": "TX",
      "CountryCode": "US"
  },
  {
      "CityCode": "BRL",
      "ProvinceId": "IA",
      "CountryCode": "US"
  },
  {
      "CityCode": "BHB",
      "ProvinceId": "ME",
      "CountryCode": "US"
  },
  {
      "CityCode": "BHM",
      "ProvinceId": "AL",
      "CountryCode": "US"
  },
  {
      "CityCode": "BGR",
      "ProvinceId": "ME",
      "CountryCode": "US"
  },
  {
      "CityCode": "BIL",
      "ProvinceId": "MT",
      "CountryCode": "US"
  },
  {
      "CityCode": "BID",
      "ProvinceId": "RI",
      "CountryCode": "US"
  },
  {
      "CityCode": "BIH",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "OXR",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "JHY",
      "ProvinceId": null,
      "CountryCode": "US"
  },
  {
      "CityCode": "SMT",
      "ProvinceId": null,
      "CountryCode": "US"
  },
  {
      "CityCode": "PGA",
      "ProvinceId": "AZ",
      "CountryCode": "US"
  },
  {
      "CityCode": "PGD",
      "ProvinceId": "FL",
      "CountryCode": "US"
  },
  {
      "CityCode": "PFN",
      "ProvinceId": "FL",
      "CountryCode": "US"
  },
  {
      "CityCode": "PIA",
      "ProvinceId": "IL",
      "CountryCode": "US"
  },
  {
      "CityCode": "PIE",
      "ProvinceId": "FL",
      "CountryCode": "US"
  },
  {
      "CityCode": "PIH",
      "ProvinceId": "ID",
      "CountryCode": "US"
  },
  {
      "CityCode": "PIR",
      "ProvinceId": "SD",
      "CountryCode": "US"
  },
  {
      "CityCode": "PHF",
      "ProvinceId": "VA",
      "CountryCode": "US"
  },
  {
      "CityCode": "PHL",
      "ProvinceId": "PA",
      "CountryCode": "US"
  },
  {
      "CityCode": "PHN",
      "ProvinceId": "MI",
      "CountryCode": "US"
  },
  {
      "CityCode": "PGL",
      "ProvinceId": "MS",
      "CountryCode": "US"
  },
  {
      "CityCode": "PGO",
      "ProvinceId": "CO",
      "CountryCode": "US"
  },
  {
      "CityCode": "PGV",
      "ProvinceId": "NC",
      "CountryCode": "US"
  },
  {
      "CityCode": "PHT",
      "ProvinceId": "TN",
      "CountryCode": "US"
  },
  {
      "CityCode": "PNC",
      "ProvinceId": "OK",
      "CountryCode": "US"
  },
  {
      "CityCode": "PHX",
      "ProvinceId": "AZ",
      "CountryCode": "US"
  },
  {
      "CityCode": "PNS",
      "ProvinceId": "FL",
      "CountryCode": "US"
  },
  {
      "CityCode": "POU",
      "ProvinceId": "NY",
      "CountryCode": "US"
  },
  {
      "CityCode": "PNX",
      "ProvinceId": "TX",
      "CountryCode": "US"
  },
  {
      "CityCode": "POC",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "POE",
      "ProvinceId": "LA",
      "CountryCode": "US"
  },
  {
      "CityCode": "POF",
      "ProvinceId": "MO",
      "CountryCode": "US"
  },
  {
      "CityCode": "PUB",
      "ProvinceId": "CO",
      "CountryCode": "US"
  },
  {
      "CityCode": "PUC",
      "ProvinceId": "UT",
      "CountryCode": "US"
  },
  {
      "CityCode": "PTW",
      "ProvinceId": "PA",
      "CountryCode": "US"
  },
  {
      "CityCode": "PTS",
      "ProvinceId": "KS",
      "CountryCode": "US"
  },
  {
      "CityCode": "PTK",
      "ProvinceId": "MI",
      "CountryCode": "US"
  },
  {
      "CityCode": "PSP",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "PTB",
      "ProvinceId": "VA",
      "CountryCode": "US"
  },
  {
      "CityCode": "PUW",
      "ProvinceId": "WA",
      "CountryCode": "US"
  },
  {
      "CityCode": "PVU",
      "ProvinceId": "UT",
      "CountryCode": "US"
  },
  {
      "CityCode": "PVW",
      "ProvinceId": "TX",
      "CountryCode": "US"
  },
  {
      "CityCode": "PVZ",
      "ProvinceId": "OH",
      "CountryCode": "US"
  },
  {
      "CityCode": "PVC",
      "ProvinceId": "MA",
      "CountryCode": "US"
  },
  {
      "CityCode": "PVD",
      "ProvinceId": "RI",
      "CountryCode": "US"
  },
  {
      "CityCode": "RAC",
      "ProvinceId": "WI",
      "CountryCode": "US"
  },
  {
      "CityCode": "RBF",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "RBG",
      "ProvinceId": "OR",
      "CountryCode": "US"
  },
  {
      "CityCode": "RAL",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "RAP",
      "ProvinceId": "SD",
      "CountryCode": "US"
  },
  {
      "CityCode": "MSS",
      "ProvinceId": "NY",
      "CountryCode": "US"
  },
  {
      "CityCode": "MSC",
      "ProvinceId": "AZ",
      "CountryCode": "US"
  },
  {
      "CityCode": "MYL",
      "ProvinceId": "ID",
      "CountryCode": "US"
  },
  {
      "CityCode": "MYR",
      "ProvinceId": "SC",
      "CountryCode": "US"
  },
  {
      "CityCode": "MYV",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "NUL",
      "ProvinceId": "AK",
      "CountryCode": "US"
  },
  {
      "CityCode": "NUQ",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "NYC",
      "ProvinceId": "NY",
      "CountryCode": "US"
  },
  {
      "CityCode": "NSE",
      "ProvinceId": "FL",
      "CountryCode": "US"
  },
  {
      "CityCode": "ORQ",
      "ProvinceId": "CT",
      "CountryCode": "US"
  },
  {
      "CityCode": "OSH",
      "ProvinceId": "WI",
      "CountryCode": "US"
  },
  {
      "CityCode": "OCA",
      "ProvinceId": "FL",
      "CountryCode": "US"
  },
  {
      "CityCode": "OCE",
      "ProvinceId": "MD",
      "CountryCode": "US"
  },
  {
      "CityCode": "OCF",
      "ProvinceId": "FL",
      "CountryCode": "US"
  },
  {
      "CityCode": "OCN",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "ORD",
      "ProvinceId": "IL",
      "CountryCode": "US"
  },
  {
      "CityCode": "ORF",
      "ProvinceId": "VA",
      "CountryCode": "US"
  },
  {
      "CityCode": "ORH",
      "ProvinceId": "MA",
      "CountryCode": "US"
  },
  {
      "CityCode": "OBE",
      "ProvinceId": "FL",
      "CountryCode": "US"
  },
  {
      "CityCode": "OAJ",
      "ProvinceId": "NC",
      "CountryCode": "US"
  },
  {
      "CityCode": "OAK",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "OWA",
      "ProvinceId": "MN",
      "CountryCode": "US"
  },
  {
      "CityCode": "OWB",
      "ProvinceId": "KY",
      "CountryCode": "US"
  },
  {
      "CityCode": "OWD",
      "ProvinceId": "MA",
      "CountryCode": "US"
  },
  {
      "CityCode": "OTG",
      "ProvinceId": "MN",
      "CountryCode": "US"
  },
  {
      "CityCode": "OTH",
      "ProvinceId": "OR",
      "CountryCode": "US"
  },
  {
      "CityCode": "OTM",
      "ProvinceId": "IA",
      "CountryCode": "US"
  },
  {
      "CityCode": "OTS",
      "ProvinceId": "WA",
      "CountryCode": "US"
  },
  {
      "CityCode": "OTZ",
      "ProvinceId": "AK",
      "CountryCode": "US"
  },
  {
      "CityCode": "SHV",
      "ProvinceId": "LA",
      "CountryCode": "US"
  },
  {
      "CityCode": "SEP",
      "ProvinceId": "TX",
      "CountryCode": "US"
  },
  {
      "CityCode": "SIT",
      "ProvinceId": "AK",
      "CountryCode": "US"
  },
  {
      "CityCode": "SJC",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "SFB",
      "ProvinceId": "FL",
      "CountryCode": "US"
  },
  {
      "CityCode": "SDF",
      "ProvinceId": "KY",
      "CountryCode": "US"
  },
  {
      "CityCode": "SEA",
      "ProvinceId": "WA",
      "CountryCode": "US"
  },
  {
      "CityCode": "SEF",
      "ProvinceId": "FL",
      "CountryCode": "US"
  },
  {
      "CityCode": "SDX",
      "ProvinceId": "AZ",
      "CountryCode": "US"
  },
  {
      "CityCode": "SDY",
      "ProvinceId": "MT",
      "CountryCode": "US"
  },
  {
      "CityCode": "SOP",
      "ProvinceId": "NC",
      "CountryCode": "US"
  },
  {
      "CityCode": "SOV",
      "ProvinceId": "AK",
      "CountryCode": "US"
  },
  {
      "CityCode": "SOW",
      "ProvinceId": "AZ",
      "CountryCode": "US"
  },
  {
      "CityCode": "SLN",
      "ProvinceId": "KS",
      "CountryCode": "US"
  },
  {
      "CityCode": "SLC",
      "ProvinceId": "UT",
      "CountryCode": "US"
  },
  {
      "CityCode": "SLE",
      "ProvinceId": "OR",
      "CountryCode": "US"
  },
  {
      "CityCode": "SLK",
      "ProvinceId": "NY",
      "CountryCode": "US"
  },
  {
      "CityCode": "SPF",
      "ProvinceId": "SD",
      "CountryCode": "US"
  },
  {
      "CityCode": "SPI",
      "ProvinceId": "IL",
      "CountryCode": "US"
  },
  {
      "CityCode": "SJT",
      "ProvinceId": "TX",
      "CountryCode": "US"
  },
  {
      "CityCode": "SKY",
      "ProvinceId": "OH",
      "CountryCode": "US"
  },
  {
      "CityCode": "ROA",
      "ProvinceId": "VA",
      "CountryCode": "US"
  },
  {
      "CityCode": "ROC",
      "ProvinceId": "NY",
      "CountryCode": "US"
  },
  {
      "CityCode": "RNH",
      "ProvinceId": "WI",
      "CountryCode": "US"
  },
  {
      "CityCode": "RNO",
      "ProvinceId": "NV",
      "CountryCode": "US"
  },
  {
      "CityCode": "RBW",
      "ProvinceId": "SC",
      "CountryCode": "US"
  },
  {
      "CityCode": "RDD",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "RDG",
      "ProvinceId": "PA",
      "CountryCode": "US"
  },
  {
      "CityCode": "RDM",
      "ProvinceId": "OR",
      "CountryCode": "US"
  },
  {
      "CityCode": "RDU",
      "ProvinceId": "NC",
      "CountryCode": "US"
  },
  {
      "CityCode": "RCE",
      "ProvinceId": "WA",
      "CountryCode": "US"
  },
  {
      "CityCode": "RUI",
      "ProvinceId": "NM",
      "CountryCode": "US"
  },
  {
      "CityCode": "RSN",
      "ProvinceId": "LA",
      "CountryCode": "US"
  },
  {
      "CityCode": "RST",
      "ProvinceId": "MN",
      "CountryCode": "US"
  },
  {
      "CityCode": "ROW",
      "ProvinceId": "NM",
      "CountryCode": "US"
  },
  {
      "CityCode": "SCK",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "RUT",
      "ProvinceId": "VT",
      "CountryCode": "US"
  },
  {
      "CityCode": "RTN",
      "ProvinceId": "NM",
      "CountryCode": "US"
  },
  {
      "CityCode": "SCC",
      "ProvinceId": "AK",
      "CountryCode": "US"
  },
  {
      "CityCode": "SCE",
      "ProvinceId": "PA",
      "CountryCode": "US"
  },
  {
      "CityCode": "SCF",
      "ProvinceId": "AZ",
      "CountryCode": "US"
  },
  {
      "CityCode": "SCH",
      "ProvinceId": "NY",
      "CountryCode": "US"
  },
  {
      "CityCode": "TEX",
      "ProvinceId": "CO",
      "CountryCode": "US"
  },
  {
      "CityCode": "TAL",
      "ProvinceId": "AK",
      "CountryCode": "US"
  },
  {
      "CityCode": "SYR",
      "ProvinceId": "NY",
      "CountryCode": "US"
  },
  {
      "CityCode": "SWD",
      "ProvinceId": "AK",
      "CountryCode": "US"
  },
  {
      "CityCode": "SWF",
      "ProvinceId": "NY",
      "CountryCode": "US"
  },
  {
      "CityCode": "SWO",
      "ProvinceId": "OK",
      "CountryCode": "US"
  },
  {
      "CityCode": "SSM",
      "ProvinceId": "MI",
      "CountryCode": "US"
  },
  {
      "CityCode": "SRQ",
      "ProvinceId": "FL",
      "CountryCode": "US"
  },
  {
      "CityCode": "SRU",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "SSI",
      "ProvinceId": "GA",
      "CountryCode": "US"
  },
  {
      "CityCode": "SQA",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "SQI",
      "ProvinceId": "IL",
      "CountryCode": "US"
  },
  {
      "CityCode": "SPW",
      "ProvinceId": "IA",
      "CountryCode": "US"
  },
  {
      "CityCode": "SPZ",
      "ProvinceId": "AR",
      "CountryCode": "US"
  },
  {
      "CityCode": "SPS",
      "ProvinceId": "TX",
      "CountryCode": "US"
  },
  {
      "CityCode": "TPL",
      "ProvinceId": "TX",
      "CountryCode": "US"
  },
  {
      "CityCode": "TRI",
      "ProvinceId": "TN",
      "CountryCode": "US"
  },
  {
      "CityCode": "TRL",
      "ProvinceId": "TX",
      "CountryCode": "US"
  },
  {
      "CityCode": "TTN",
      "ProvinceId": "NJ",
      "CountryCode": "US"
  },
  {
      "CityCode": "UDD",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "TSM",
      "ProvinceId": "NM",
      "CountryCode": "US"
  },
  {
      "CityCode": "TTD",
      "ProvinceId": "OR",
      "CountryCode": "US"
  },
  {
      "CityCode": "THV",
      "ProvinceId": "PA",
      "CountryCode": "US"
  },
  {
      "CityCode": "THP",
      "ProvinceId": "WY",
      "CountryCode": "US"
  },
  {
      "CityCode": "TPA",
      "ProvinceId": "FL",
      "CountryCode": "US"
  },
  {
      "CityCode": "TKJ",
      "ProvinceId": "AK",
      "CountryCode": "US"
  },
  {
      "CityCode": "TIW",
      "ProvinceId": "WA",
      "CountryCode": "US"
  },
  {
      "CityCode": "TIX",
      "ProvinceId": "FL",
      "CountryCode": "US"
  },
  {
      "CityCode": "VIS",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "VLD",
      "ProvinceId": "GA",
      "CountryCode": "US"
  },
  {
      "CityCode": "VJI",
      "ProvinceId": "VA",
      "CountryCode": "US"
  },
  {
      "CityCode": "VKS",
      "ProvinceId": "MS",
      "CountryCode": "US"
  },
  {
      "CityCode": "VDZ",
      "ProvinceId": "AK",
      "CountryCode": "US"
  },
  {
      "CityCode": "VEL",
      "ProvinceId": "UT",
      "CountryCode": "US"
  },
  {
      "CityCode": "VHN",
      "ProvinceId": "TX",
      "CountryCode": "US"
  },
  {
      "CityCode": "UNK",
      "ProvinceId": "AK",
      "CountryCode": "US"
  },
  {
      "CityCode": "UOX",
      "ProvinceId": "MS",
      "CountryCode": "US"
  },
  {
      "CityCode": "UKT",
      "ProvinceId": "PA",
      "CountryCode": "US"
  },
  {
      "CityCode": "ULM",
      "ProvinceId": "MN",
      "CountryCode": "US"
  },
  {
      "CityCode": "UKI",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "UGN",
      "ProvinceId": "IL",
      "CountryCode": "US"
  },
  {
      "CityCode": "UIN",
      "ProvinceId": "IL",
      "CountryCode": "US"
  },
  {
      "CityCode": "VLO",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "WEA",
      "ProvinceId": "TX",
      "CountryCode": "US"
  },
  {
      "CityCode": "BCT",
      "ProvinceId": "FL",
      "CountryCode": "US"
  },
  {
      "CityCode": "CC2",
      "ProvinceId": null,
      "CountryCode": "US"
  },
  {
      "CityCode": "WRG",
      "ProvinceId": "AK",
      "CountryCode": "US"
  },
  {
      "CityCode": "WRL",
      "ProvinceId": "WY",
      "CountryCode": "US"
  },
  {
      "CityCode": "WST",
      "ProvinceId": "RI",
      "CountryCode": "US"
  },
  {
      "CityCode": "WVI",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "WVL",
      "ProvinceId": "ME",
      "CountryCode": "US"
  },
  {
      "CityCode": "WGO",
      "ProvinceId": "VA",
      "CountryCode": "US"
  },
  {
      "CityCode": "WLK",
      "ProvinceId": "AK",
      "CountryCode": "US"
  },
  {
      "CityCode": "WMC",
      "ProvinceId": "NV",
      "CountryCode": "US"
  },
  {
      "CityCode": "WMH",
      "ProvinceId": "AR",
      "CountryCode": "US"
  },
  {
      "CityCode": "WLD",
      "ProvinceId": "KS",
      "CountryCode": "US"
  },
  {
      "CityCode": "WJF",
      "ProvinceId": "CA",
      "CountryCode": "US"
  },
  {
      "CityCode": "YNG",
      "ProvinceId": "OH",
      "CountryCode": "US"
  },
  {
      "CityCode": "YUM",
      "ProvinceId": "AZ",
      "CountryCode": "US"
  },
  {
      "CityCode": "CYR",
      "ProvinceId": null,
      "CountryCode": "UY"
  },
  {
      "CityCode": "STY",
      "ProvinceId": null,
      "CountryCode": "UY"
  },
  {
      "CityCode": "PDP",
      "ProvinceId": null,
      "CountryCode": "UY"
  },
  {
      "CityCode": "MVD",
      "ProvinceId": null,
      "CountryCode": "UY"
  },
  {
      "CityCode": "TAS",
      "ProvinceId": null,
      "CountryCode": "UZ"
  },
  {
      "CityCode": "BHK",
      "ProvinceId": null,
      "CountryCode": "UZ"
  },
  {
      "CityCode": "UGC",
      "ProvinceId": null,
      "CountryCode": "UZ"
  },
  {
      "CityCode": "SKD",
      "ProvinceId": null,
      "CountryCode": "UZ"
  },
  {
      "CityCode": "UNI",
      "ProvinceId": null,
      "CountryCode": "VC"
  },
  {
      "CityCode": "SVD",
      "ProvinceId": null,
      "CountryCode": "VC"
  },
  {
      "CityCode": "STD",
      "ProvinceId": null,
      "CountryCode": "VE"
  },
  {
      "CityCode": "STB",
      "ProvinceId": null,
      "CountryCode": "VE"
  },
  {
      "CityCode": "AR3",
      "ProvinceId": null,
      "CountryCode": "VE"
  },
  {
      "CityCode": "MUN",
      "ProvinceId": null,
      "CountryCode": "VE"
  },
  {
      "CityCode": "PYH",
      "ProvinceId": null,
      "CountryCode": "VE"
  },
  {
      "CityCode": "PZO",
      "ProvinceId": null,
      "CountryCode": "VE"
  },
  {
      "CityCode": "SFX",
      "ProvinceId": null,
      "CountryCode": "VE"
  },
  {
      "CityCode": "SNF",
      "ProvinceId": null,
      "CountryCode": "VE"
  },
  {
      "CityCode": "SOM",
      "ProvinceId": null,
      "CountryCode": "VE"
  },
  {
      "CityCode": "CCS",
      "ProvinceId": null,
      "CountryCode": "VE"
  },
  {
      "CityCode": "CBS",
      "ProvinceId": null,
      "CountryCode": "VE"
  },
  {
      "CityCode": "BNS",
      "ProvinceId": null,
      "CountryCode": "VE"
  },
  {
      "CityCode": "BLA",
      "ProvinceId": null,
      "CountryCode": "VE"
  },
  {
      "CityCode": "VLN",
      "ProvinceId": null,
      "CountryCode": "VE"
  },
  {
      "CityCode": "VIG",
      "ProvinceId": null,
      "CountryCode": "VE"
  },
  {
      "CityCode": "VLV",
      "ProvinceId": null,
      "CountryCode": "VE"
  },
  {
      "CityCode": "SFD",
      "ProvinceId": null,
      "CountryCode": "VE"
  },
  {
      "CityCode": "SCI",
      "ProvinceId": null,
      "CountryCode": "VE"
  },
  {
      "CityCode": "SVZ",
      "ProvinceId": null,
      "CountryCode": "VE"
  },
  {
      "CityCode": "MYC",
      "ProvinceId": null,
      "CountryCode": "VE"
  },
  {
      "CityCode": "PMV",
      "ProvinceId": null,
      "CountryCode": "VE"
  },
  {
      "CityCode": "BRM",
      "ProvinceId": null,
      "CountryCode": "VE"
  },
  {
      "CityCode": "CBL",
      "ProvinceId": null,
      "CountryCode": "VE"
  },
  {
      "CityCode": "CZE",
      "ProvinceId": null,
      "CountryCode": "VE"
  },
  {
      "CityCode": "MRD",
      "ProvinceId": null,
      "CountryCode": "VE"
  },
  {
      "CityCode": "LSP",
      "ProvinceId": null,
      "CountryCode": "VE"
  },
  {
      "CityCode": "MAR",
      "ProvinceId": null,
      "CountryCode": "VE"
  },
  {
      "CityCode": "LFR",
      "ProvinceId": null,
      "CountryCode": "VE"
  },
  {
      "CityCode": "TOV",
      "ProvinceId": null,
      "CountryCode": "VG"
  },
  {
      "CityCode": "VIJ",
      "ProvinceId": null,
      "CountryCode": "VG"
  },
  {
      "CityCode": "EIS",
      "ProvinceId": null,
      "CountryCode": "VG"
  },
  {
      "CityCode": "DLI",
      "ProvinceId": null,
      "CountryCode": "VN"
  },
  {
      "CityCode": "HAN",
      "ProvinceId": null,
      "CountryCode": "VN"
  },
  {
      "CityCode": "SGN",
      "ProvinceId": null,
      "CountryCode": "VN"
  },
  {
      "CityCode": "NHA",
      "ProvinceId": null,
      "CountryCode": "VN"
  },
  {
      "CityCode": "PHH",
      "ProvinceId": null,
      "CountryCode": "VN"
  },
  {
      "CityCode": "HPH",
      "ProvinceId": null,
      "CountryCode": "VN"
  },
  {
      "CityCode": "HUI",
      "ProvinceId": null,
      "CountryCode": "VN"
  },
  {
      "CityCode": "DAD",
      "ProvinceId": null,
      "CountryCode": "VN"
  },
  {
      "CityCode": "VLI",
      "ProvinceId": null,
      "CountryCode": "VU"
  },
  {
      "CityCode": "SON",
      "ProvinceId": null,
      "CountryCode": "VU"
  },
  {
      "CityCode": "MXS",
      "ProvinceId": null,
      "CountryCode": "WS"
  },
  {
      "CityCode": "APW",
      "ProvinceId": null,
      "CountryCode": "WS"
  },
  {
      "CityCode": "SAH",
      "ProvinceId": null,
      "CountryCode": "YE"
  },
  {
      "CityCode": "ADE",
      "ProvinceId": null,
      "CountryCode": "YE"
  },
  {
      "CityCode": "DZA",
      "ProvinceId": null,
      "CountryCode": "YT"
  },
  {
      "CityCode": "BEG",
      "ProvinceId": null,
      "CountryCode": "RS"
  },
  {
      "CityCode": "PRN",
      "ProvinceId": null,
      "CountryCode": "RS"
  },
  {
      "CityCode": "INI",
      "ProvinceId": null,
      "CountryCode": "RS"
  },
  {
      "CityCode": "TIV",
      "ProvinceId": null,
      "CountryCode": "RS"
  },
  {
      "CityCode": "TGD",
      "ProvinceId": null,
      "CountryCode": "RS"
  },
  {
      "CityCode": "SZK",
      "ProvinceId": null,
      "CountryCode": "ZA"
  },
  {
      "CityCode": "RCB",
      "ProvinceId": null,
      "CountryCode": "ZA"
  },
  {
      "CityCode": "SDB",
      "ProvinceId": null,
      "CountryCode": "ZA"
  },
  {
      "CityCode": "NCS",
      "ProvinceId": null,
      "CountryCode": "ZA"
  },
  {
      "CityCode": "NTY",
      "ProvinceId": null,
      "CountryCode": "ZA"
  },
  {
      "CityCode": "OUH",
      "ProvinceId": null,
      "CountryCode": "ZA"
  },
  {
      "CityCode": "PHW",
      "ProvinceId": null,
      "CountryCode": "ZA"
  },
  {
      "CityCode": "PTG",
      "ProvinceId": null,
      "CountryCode": "ZA"
  },
  {
      "CityCode": "WEL",
      "ProvinceId": null,
      "CountryCode": "ZA"
  },
  {
      "CityCode": "ZEC",
      "ProvinceId": null,
      "CountryCode": "ZA"
  },
  {
      "CityCode": "HRS",
      "ProvinceId": null,
      "CountryCode": "ZA"
  },
  {
      "CityCode": "GRJ",
      "ProvinceId": null,
      "CountryCode": "ZA"
  },
  {
      "CityCode": "HDS",
      "ProvinceId": null,
      "CountryCode": "ZA"
  },
  {
      "CityCode": "KIM",
      "ProvinceId": null,
      "CountryCode": "ZA"
  },
  {
      "CityCode": "MBD",
      "ProvinceId": null,
      "CountryCode": "ZA"
  },
  {
      "CityCode": "LTA",
      "ProvinceId": null,
      "CountryCode": "ZA"
  },
  {
      "CityCode": "BIY",
      "ProvinceId": null,
      "CountryCode": "ZA"
  },
  {
      "CityCode": "CPT",
      "ProvinceId": null,
      "CountryCode": "ZA"
  },
  {
      "CityCode": "ELS",
      "ProvinceId": null,
      "CountryCode": "ZA"
  },
  {
      "CityCode": "DUR",
      "ProvinceId": null,
      "CountryCode": "ZA"
  },
  {
      "CityCode": "PZB",
      "ProvinceId": null,
      "CountryCode": "ZA"
  },
  {
      "CityCode": "PRY",
      "ProvinceId": null,
      "CountryCode": "ZA"
  },
  {
      "CityCode": "PLZ",
      "ProvinceId": null,
      "CountryCode": "ZA"
  },
  {
      "CityCode": "PBZ",
      "ProvinceId": null,
      "CountryCode": "ZA"
  },
  {
      "CityCode": "SBU",
      "ProvinceId": null,
      "CountryCode": "ZA"
  },
  {
      "CityCode": "NLP",
      "ProvinceId": null,
      "CountryCode": "ZA"
  },
  {
      "CityCode": "MGH",
      "ProvinceId": null,
      "CountryCode": "ZA"
  },
  {
      "CityCode": "LAY",
      "ProvinceId": null,
      "CountryCode": "ZA"
  },
  {
      "CityCode": "LLE",
      "ProvinceId": null,
      "CountryCode": "ZA"
  },
  {
      "CityCode": "JNB",
      "ProvinceId": null,
      "CountryCode": "ZA"
  },
  {
      "CityCode": "BFN",
      "ProvinceId": null,
      "CountryCode": "ZA"
  },
  {
      "CityCode": "ALJ",
      "ProvinceId": null,
      "CountryCode": "ZA"
  },
  {
      "CityCode": "FCB",
      "ProvinceId": null,
      "CountryCode": "ZA"
  },
  {
      "CityCode": "HLA",
      "ProvinceId": null,
      "CountryCode": "ZA"
  },
  {
      "CityCode": "HLW",
      "ProvinceId": null,
      "CountryCode": "ZA"
  },
  {
      "CityCode": "TCU",
      "ProvinceId": null,
      "CountryCode": "ZA"
  },
  {
      "CityCode": "UTT",
      "ProvinceId": null,
      "CountryCode": "ZA"
  },
  {
      "CityCode": "UTW",
      "ProvinceId": null,
      "CountryCode": "ZA"
  },
  {
      "CityCode": "UTN",
      "ProvinceId": null,
      "CountryCode": "ZA"
  },
  {
      "CityCode": "VYD",
      "ProvinceId": null,
      "CountryCode": "ZA"
  },
  {
      "CityCode": "LVI",
      "ProvinceId": null,
      "CountryCode": "ZM"
  },
  {
      "CityCode": "LUN",
      "ProvinceId": null,
      "CountryCode": "ZM"
  },
  {
      "CityCode": "NLA",
      "ProvinceId": null,
      "CountryCode": "ZM"
  },
  {
      "CityCode": "MVZ",
      "ProvinceId": null,
      "CountryCode": "ZW"
  },
  {
      "CityCode": "KAB",
      "ProvinceId": null,
      "CountryCode": "ZW"
  },
  {
      "CityCode": "HWN",
      "ProvinceId": null,
      "CountryCode": "ZW"
  },
  {
      "CityCode": "GWE",
      "ProvinceId": null,
      "CountryCode": "ZW"
  },
  {
      "CityCode": "BUQ",
      "ProvinceId": null,
      "CountryCode": "ZW"
  },
  {
      "CityCode": "UTA",
      "ProvinceId": null,
      "CountryCode": "ZW"
  },
  {
      "CityCode": "BZH",
      "ProvinceId": null,
      "CountryCode": "ZW"
  },
  {
      "CityCode": "MJW",
      "ProvinceId": null,
      "CountryCode": "ZW"
  },
  {
      "CityCode": "HRE",
      "ProvinceId": null,
      "CountryCode": "ZW"
  },
  {
      "CityCode": "VFA",
      "ProvinceId": null,
      "CountryCode": "ZW"
  },
  {
      "CityCode": "SJU",
      "ProvinceId": null,
      "CountryCode": "PR"
  },
  {
      "CityCode": "BQN",
      "ProvinceId": "PR",
      "CountryCode": "PR"
  },
  {
      "CityCode": "PSE",
      "ProvinceId": null,
      "CountryCode": "PR"
  },
  {
      "CityCode": "NQN",
      "ProvinceId": "ARQ",
      "CountryCode": "AR"
  },
  {
      "CityCode": "SFN",
      "ProvinceId": "ARS",
      "CountryCode": "AR"
  },
  {
      "CityCode": "RGL",
      "ProvinceId": "ARZ",
      "CountryCode": "AR"
  },
  {
      "CityCode": "RGA",
      "ProvinceId": "ARV",
      "CountryCode": "AR"
  },
  {
      "CityCode": "JUJ",
      "ProvinceId": "ARY",
      "CountryCode": "AR"
  },
  {
      "CityCode": "LUQ",
      "ProvinceId": "ARD",
      "CountryCode": "AR"
  },
  {
      "CityCode": "MDZ",
      "ProvinceId": "ARM",
      "CountryCode": "AR"
  },
  {
      "CityCode": "BUE",
      "ProvinceId": "ARC",
      "CountryCode": "AR"
  },
  {
      "CityCode": "CTC",
      "ProvinceId": "ARK",
      "CountryCode": "AR"
  },
  {
      "CityCode": "IGR",
      "ProvinceId": "ARN",
      "CountryCode": "AR"
  },
  {
      "CityCode": "FTE",
      "ProvinceId": "ARZ",
      "CountryCode": "AR"
  },
  {
      "CityCode": "UAQ",
      "ProvinceId": "ARJ",
      "CountryCode": "AR"
  },
  {
      "CityCode": "PRA",
      "ProvinceId": "ARE",
      "CountryCode": "AR"
  },
  {
      "CityCode": "RHD",
      "ProvinceId": "ARG",
      "CountryCode": "AR"
  },
  {
      "CityCode": "RCU",
      "ProvinceId": "ARX",
      "CountryCode": "AR"
  },
  {
      "CityCode": "VME",
      "ProvinceId": "ARD",
      "CountryCode": "AR"
  },
  {
      "CityCode": "VGL",
      "ProvinceId": "ARB",
      "CountryCode": "AR"
  },
  {
      "CityCode": "AFA",
      "ProvinceId": "ARM",
      "CountryCode": "AR"
  },
  {
      "CityCode": "86A",
      "ProvinceId": "ARM",
      "CountryCode": "AR"
  },
  {
      "CityCode": "85A",
      "ProvinceId": "ARB",
      "CountryCode": "AR"
  },
  {
      "CityCode": "96A",
      "ProvinceId": null,
      "CountryCode": "AR"
  },
  {
      "CityCode": "46A",
      "ProvinceId": "ARM",
      "CountryCode": "AR"
  },
  {
      "CityCode": "LL9",
      "ProvinceId": "ARM",
      "CountryCode": "AR"
  },
  {
      "CityCode": "47A",
      "ProvinceId": "ARB",
      "CountryCode": "AR"
  },
  {
      "CityCode": "48A",
      "ProvinceId": "ARB",
      "CountryCode": "AR"
  },
  {
      "CityCode": "49A",
      "ProvinceId": "ARM",
      "CountryCode": "AR"
  },
  {
      "CityCode": "52A",
      "ProvinceId": "ARX",
      "CountryCode": "AR"
  },
  {
      "CityCode": "RLO",
      "ProvinceId": "ARD",
      "CountryCode": "AR"
  },
  {
      "CityCode": "50A",
      "ProvinceId": "ARB",
      "CountryCode": "AR"
  },
  {
      "CityCode": "63A",
      "ProvinceId": "ARZ",
      "CountryCode": "AR"
  },
  {
      "CityCode": "95A",
      "ProvinceId": null,
      "CountryCode": "AR"
  },
  {
      "CityCode": "64A",
      "ProvinceId": "ARB",
      "CountryCode": "AR"
  },
  {
      "CityCode": "65A",
      "ProvinceId": "ARB",
      "CountryCode": "AR"
  },
  {
      "CityCode": "AR_40",
      "ProvinceId": "ART",
      "CountryCode": "AR"
  },
  {
      "CityCode": "70A",
      "ProvinceId": "ARH",
      "CountryCode": "AR"
  },
  {
      "CityCode": "69A",
      "ProvinceId": "ARB",
      "CountryCode": "AR"
  },
  {
      "CityCode": "66A",
      "ProvinceId": "ARS",
      "CountryCode": "AR"
  },
  {
      "CityCode": "68A",
      "ProvinceId": "ARX",
      "CountryCode": "AR"
  },
  {
      "CityCode": "98A",
      "ProvinceId": null,
      "CountryCode": "AR"
  },
  {
      "CityCode": "83A",
      "ProvinceId": "ARB",
      "CountryCode": "AR"
  },
  {
      "CityCode": "AR_39",
      "ProvinceId": "ARA",
      "CountryCode": "AR"
  },
  {
      "CityCode": "03A",
      "ProvinceId": "ARB",
      "CountryCode": "AR"
  },
  {
      "CityCode": "04A",
      "ProvinceId": "ARR",
      "CountryCode": "AR"
  },
  {
      "CityCode": "05A",
      "ProvinceId": "ARX",
      "CountryCode": "AR"
  },
  {
      "CityCode": "06A",
      "ProvinceId": "ARX",
      "CountryCode": "AR"
  },
  {
      "CityCode": "AR_001",
      "ProvinceId": "ARX",
      "CountryCode": "AR"
  },
  {
      "CityCode": "AR_002",
      "ProvinceId": "ARX",
      "CountryCode": "AR"
  },
  {
      "CityCode": "AR_003",
      "ProvinceId": "ARX",
      "CountryCode": "AR"
  },
  {
      "CityCode": "AR_004",
      "ProvinceId": "ARX",
      "CountryCode": "AR"
  },
  {
      "CityCode": "AR_005",
      "ProvinceId": "ARX",
      "CountryCode": "AR"
  },
  {
      "CityCode": "AR_006",
      "ProvinceId": "ARX",
      "CountryCode": "AR"
  },
  {
      "CityCode": "AR_007",
      "ProvinceId": "ARX",
      "CountryCode": "AR"
  },
  {
      "CityCode": "AR_008",
      "ProvinceId": "ARX",
      "CountryCode": "AR"
  },
  {
      "CityCode": "AR_009",
      "ProvinceId": "ARX",
      "CountryCode": "AR"
  },
  {
      "CityCode": "AR_010",
      "ProvinceId": "ARX",
      "CountryCode": "AR"
  },
  {
      "CityCode": "AR_011",
      "ProvinceId": "ARX",
      "CountryCode": "AR"
  },
  {
      "CityCode": "AR_012",
      "ProvinceId": "ARX",
      "CountryCode": "AR"
  },
  {
      "CityCode": "AR_013",
      "ProvinceId": "ARX",
      "CountryCode": "AR"
  },
  {
      "CityCode": "AR_014",
      "ProvinceId": "ARX",
      "CountryCode": "AR"
  },
  {
      "CityCode": "AR_015",
      "ProvinceId": "ARX",
      "CountryCode": "AR"
  },
  {
      "CityCode": "AR_016",
      "ProvinceId": "ARX",
      "CountryCode": "AR"
  },
  {
      "CityCode": "AR_017",
      "ProvinceId": "ARX",
      "CountryCode": "AR"
  },
  {
      "CityCode": "AR_018",
      "ProvinceId": "ARX",
      "CountryCode": "AR"
  },
  {
      "CityCode": "AR_019",
      "ProvinceId": "ARX",
      "CountryCode": "AR"
  },
  {
      "CityCode": "AR_020",
      "ProvinceId": "ARX",
      "CountryCode": "AR"
  },
  {
      "CityCode": "AR_021",
      "ProvinceId": "ARX",
      "CountryCode": "AR"
  },
  {
      "CityCode": "AR_022",
      "ProvinceId": "ARX",
      "CountryCode": "AR"
  },
  {
      "CityCode": "AR_023",
      "ProvinceId": "ARX",
      "CountryCode": "AR"
  },
  {
      "CityCode": "AR_024",
      "ProvinceId": "ARX",
      "CountryCode": "AR"
  },
  {
      "CityCode": "AR_025",
      "ProvinceId": "ARX",
      "CountryCode": "AR"
  },
  {
      "CityCode": "AR_026",
      "ProvinceId": "ARX",
      "CountryCode": "AR"
  },
  {
      "CityCode": "AR_027",
      "ProvinceId": "ARX",
      "CountryCode": "AR"
  },
  {
      "CityCode": "AR_028",
      "ProvinceId": "ARX",
      "CountryCode": "AR"
  },
  {
      "CityCode": "AR_029",
      "ProvinceId": "ARX",
      "CountryCode": "AR"
  },
  {
      "CityCode": "AR_030",
      "ProvinceId": "ARX",
      "CountryCode": "AR"
  },
  {
      "CityCode": "AR_031",
      "ProvinceId": "ARX",
      "CountryCode": "AR"
  },
  {
      "CityCode": "AR_032",
      "ProvinceId": "ARX",
      "CountryCode": "AR"
  },
  {
      "CityCode": "AR_033",
      "ProvinceId": "ARX",
      "CountryCode": "AR"
  },
  {
      "CityCode": "AR_034",
      "ProvinceId": "ARX",
      "CountryCode": "AR"
  },
  {
      "CityCode": "AR_035",
      "ProvinceId": "ARX",
      "CountryCode": "AR"
  },
  {
      "CityCode": "AR_036",
      "ProvinceId": "ARX",
      "CountryCode": "AR"
  },
  {
      "CityCode": "VDR",
      "ProvinceId": "ARX",
      "CountryCode": "AR"
  },
  {
      "CityCode": "AR_037",
      "ProvinceId": "ARX",
      "CountryCode": "AR"
  },
  {
      "CityCode": "AR_038",
      "ProvinceId": "ARX",
      "CountryCode": "AR"
  },
  {
      "CityCode": "AR_039",
      "ProvinceId": "ARX",
      "CountryCode": "AR"
  },
  {
      "CityCode": "RAF",
      "ProvinceId": "ARS",
      "CountryCode": "AR"
  },
  {
      "CityCode": "AR_040",
      "ProvinceId": "ARS",
      "CountryCode": "AR"
  },
  {
      "CityCode": "NCJ",
      "ProvinceId": "ARS",
      "CountryCode": "AR"
  },
  {
      "CityCode": "AR_041",
      "ProvinceId": "ARF",
      "CountryCode": "AR"
  },
  {
      "CityCode": "29A",
      "ProvinceId": "ARS",
      "CountryCode": "AR"
  },
  {
      "CityCode": "27A",
      "ProvinceId": "ARR",
      "CountryCode": "AR"
  },
  {
      "CityCode": "28A",
      "ProvinceId": "ARN",
      "CountryCode": "AR"
  },
  {
      "CityCode": "99A",
      "ProvinceId": null,
      "CountryCode": "AR"
  },
  {
      "CityCode": "30A",
      "ProvinceId": "ARB",
      "CountryCode": "AR"
  },
  {
      "CityCode": "41A",
      "ProvinceId": "ARX",
      "CountryCode": "AR"
  },
  {
      "CityCode": "31A",
      "ProvinceId": "ARS",
      "CountryCode": "AR"
  },
  {
      "CityCode": "40A",
      "ProvinceId": "ARQ",
      "CountryCode": "AR"
  },
  {
      "CityCode": "45A",
      "ProvinceId": "ARB",
      "CountryCode": "AR"
  },
  {
      "CityCode": "44A",
      "ProvinceId": "ARX",
      "CountryCode": "AR"
  },
  {
      "CityCode": "LPG",
      "ProvinceId": "ARB",
      "CountryCode": "AR"
  },
  {
      "CityCode": "43A",
      "ProvinceId": "ARB",
      "CountryCode": "AR"
  },
  {
      "CityCode": "11A",
      "ProvinceId": "ARX",
      "CountryCode": "AR"
  },
  {
      "CityCode": "26A",
      "ProvinceId": "ARQ",
      "CountryCode": "AR"
  },
  {
      "CityCode": "25A",
      "ProvinceId": "ARB",
      "CountryCode": "AR"
  },
  {
      "CityCode": "24A",
      "ProvinceId": "ARE",
      "CountryCode": "AR"
  },
  {
      "CityCode": "10A",
      "ProvinceId": "ARX",
      "CountryCode": "AR"
  },
  {
      "CityCode": "07A",
      "ProvinceId": "ARX",
      "CountryCode": "AR"
  },
  {
      "CityCode": "08A",
      "ProvinceId": "ARX",
      "CountryCode": "AR"
  },
  {
      "CityCode": "09A",
      "ProvinceId": "ARB",
      "CountryCode": "AR"
  },
  {
      "CityCode": "BRC",
      "ProvinceId": "ARR",
      "CountryCode": "AR"
  },
  {
      "CityCode": "BHI",
      "ProvinceId": "ARB",
      "CountryCode": "AR"
  },
  {
      "CityCode": "72A",
      "ProvinceId": "ARS",
      "CountryCode": "AR"
  },
  {
      "CityCode": "81A",
      "ProvinceId": "ARX",
      "CountryCode": "AR"
  },
  {
      "CityCode": "53A",
      "ProvinceId": "ARB",
      "CountryCode": "AR"
  },
  {
      "CityCode": "54A",
      "ProvinceId": "ARX",
      "CountryCode": "AR"
  },
  {
      "CityCode": "55A",
      "ProvinceId": "ARB",
      "CountryCode": "AR"
  },
  {
      "CityCode": "56A",
      "ProvinceId": "ARQ",
      "CountryCode": "AR"
  },
  {
      "CityCode": "57A",
      "ProvinceId": "ARB",
      "CountryCode": "AR"
  },
  {
      "CityCode": "58A",
      "ProvinceId": "ARB",
      "CountryCode": "AR"
  },
  {
      "CityCode": "12A",
      "ProvinceId": "ARB",
      "CountryCode": "AR"
  },
  {
      "CityCode": "9A4",
      "ProvinceId": null,
      "CountryCode": "AR"
  },
  {
      "CityCode": "18A",
      "ProvinceId": "ARB",
      "CountryCode": "AR"
  },
  {
      "CityCode": "15A",
      "ProvinceId": "ARS",
      "CountryCode": "AR"
  },
  {
      "CityCode": "14A",
      "ProvinceId": "ARZ",
      "CountryCode": "AR"
  },
  {
      "CityCode": "21A",
      "ProvinceId": "ARQ",
      "CountryCode": "AR"
  },
  {
      "CityCode": "22A",
      "ProvinceId": "ARR",
      "CountryCode": "AR"
  },
  {
      "CityCode": "23A",
      "ProvinceId": "ARR",
      "CountryCode": "AR"
  },
  {
      "CityCode": "19A",
      "ProvinceId": "ARH",
      "CountryCode": "AR"
  },
  {
      "CityCode": "20A",
      "ProvinceId": "ARM",
      "CountryCode": "AR"
  },
  {
      "CityCode": "02A",
      "ProvinceId": "ARF",
      "CountryCode": "AR"
  },
  {
      "CityCode": "71A",
      "ProvinceId": "ARK",
      "CountryCode": "AR"
  },
  {
      "CityCode": "74A",
      "ProvinceId": "ARA",
      "CountryCode": "AR"
  },
  {
      "CityCode": "73A",
      "ProvinceId": "ARS",
      "CountryCode": "AR"
  },
  {
      "CityCode": "01A",
      "ProvinceId": "ARS",
      "CountryCode": "AR"
  },
  {
      "CityCode": "78A",
      "ProvinceId": "ARE",
      "CountryCode": "AR"
  },
  {
      "CityCode": "80A",
      "ProvinceId": "ARB",
      "CountryCode": "AR"
  },
  {
      "CityCode": "SM1",
      "ProvinceId": "ARM",
      "CountryCode": "AR"
  },
  {
      "CityCode": "97A",
      "ProvinceId": null,
      "CountryCode": "AR"
  },
  {
      "CityCode": "77A",
      "ProvinceId": "ARB",
      "CountryCode": "AR"
  },
  {
      "CityCode": "EQS",
      "ProvinceId": "ARU",
      "CountryCode": "AR"
  },
  {
      "CityCode": "38A",
      "ProvinceId": "ARX",
      "CountryCode": "AR"
  },
  {
      "CityCode": "37A",
      "ProvinceId": "ARB",
      "CountryCode": "AR"
  },
  {
      "CityCode": "36A",
      "ProvinceId": "ARM",
      "CountryCode": "AR"
  },
  {
      "CityCode": "35A",
      "ProvinceId": "ARH",
      "CountryCode": "AR"
  },
  {
      "CityCode": "GHU",
      "ProvinceId": null,
      "CountryCode": "AR"
  },
  {
      "CityCode": "39A",
      "ProvinceId": "ARH",
      "CountryCode": "AR"
  },
  {
      "CityCode": "33A",
      "ProvinceId": "ARS",
      "CountryCode": "AR"
  },
  {
      "CityCode": "34A",
      "ProvinceId": "ARM",
      "CountryCode": "AR"
  },
  {
      "CityCode": "32A",
      "ProvinceId": "ARR",
      "CountryCode": "AR"
  },
  {
      "CityCode": "CRD",
      "ProvinceId": "ARU",
      "CountryCode": "AR"
  },
  {
      "CityCode": "COR",
      "ProvinceId": "ARX",
      "CountryCode": "AR"
  },
  {
      "CityCode": "CPC",
      "ProvinceId": "ARQ",
      "CountryCode": "AR"
  },
  {
      "CityCode": "CNQ",
      "ProvinceId": "ARW",
      "CountryCode": "AR"
  },
  {
      "CityCode": "59A",
      "ProvinceId": "ARW",
      "CountryCode": "AR"
  },
  {
      "CityCode": "60A",
      "ProvinceId": "ARB",
      "CountryCode": "AR"
  },
  {
      "CityCode": "61A",
      "ProvinceId": "ARY",
      "CountryCode": "AR"
  },
  {
      "CityCode": "CAB",
      "ProvinceId": null,
      "CountryCode": "AR"
  },
  {
      "CityCode": "62A",
      "ProvinceId": "ARX",
      "CountryCode": "AR"
  },
  {
      "CityCode": "IRJ",
      "ProvinceId": "ARF",
      "CountryCode": "AR"
  },
  {
      "CityCode": "92A",
      "ProvinceId": "ART",
      "CountryCode": "AR"
  },
  {
      "CityCode": "93A",
      "ProvinceId": "ARB",
      "CountryCode": "AR"
  },
  {
      "CityCode": "88A",
      "ProvinceId": "ARB",
      "CountryCode": "AR"
  },
  {
      "CityCode": "89A",
      "ProvinceId": "ARS",
      "CountryCode": "AR"
  },
  {
      "CityCode": "90A",
      "ProvinceId": "ARX",
      "CountryCode": "AR"
  },
  {
      "CityCode": "91A",
      "ProvinceId": "ARX",
      "CountryCode": "AR"
  },
  {
      "CityCode": "FMA",
      "ProvinceId": "ARP",
      "CountryCode": "AR"
  },
  {
      "CityCode": "87A",
      "ProvinceId": "ARB",
      "CountryCode": "AR"
  },
  {
      "CityCode": "MDQ",
      "ProvinceId": "ARB",
      "CountryCode": "AR"
  },
  {
      "CityCode": "LGS",
      "ProvinceId": "ARM",
      "CountryCode": "AR"
  },
  {
      "CityCode": "SLA",
      "ProvinceId": "ARA",
      "CountryCode": "AR"
  },
  {
      "CityCode": "SDE",
      "ProvinceId": "ARG",
      "CountryCode": "AR"
  },
  {
      "CityCode": "REL",
      "ProvinceId": "ARU",
      "CountryCode": "AR"
  },
  {
      "CityCode": "RES",
      "ProvinceId": "ARH",
      "CountryCode": "AR"
  },
  {
      "CityCode": "ROS",
      "ProvinceId": "ARS",
      "CountryCode": "AR"
  },
  {
      "CityCode": "RSA",
      "ProvinceId": "ARL",
      "CountryCode": "AR"
  },
  {
      "CityCode": "TUC",
      "ProvinceId": "ART",
      "CountryCode": "AR"
  },
  {
      "CityCode": "PSS",
      "ProvinceId": "ARN",
      "CountryCode": "AR"
  },
  {
      "CityCode": "PMY",
      "ProvinceId": "ARU",
      "CountryCode": "AR"
  },
  {
      "CityCode": "VDM",
      "ProvinceId": "ARR",
      "CountryCode": "AR"
  },
  {
      "CityCode": "VLA",
      "ProvinceId": "ARQ",
      "CountryCode": "AR"
  },
  {
      "CityCode": "USH",
      "ProvinceId": "ARV",
      "CountryCode": "AR"
  },
  {
      "CityCode": "AUA",
      "ProvinceId": null,
      "CountryCode": "AW"
  },
  {
      "CityCode": "JTI",
      "ProvinceId": null,
      "CountryCode": "BR"
  },
  {
      "CityCode": "CO_9002",
      "ProvinceId": "CO32",
      "CountryCode": "CO"
  },
  {
      "CityCode": "ZYM",
      "ProvinceId": null,
      "CountryCode": "NL"
  },
  {
      "CityCode": "SFG",
      "ProvinceId": null,
      "CountryCode": "AN"
  },
  {
      "CityCode": "CZ4",
      "ProvinceId": "CO27",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0090",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0109",
      "ProvinceId": "CO04",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0110",
      "ProvinceId": "CO04",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0111",
      "ProvinceId": "CO04",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0112",
      "ProvinceId": "CO04",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0113",
      "ProvinceId": "CO04",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0114",
      "ProvinceId": "CO04",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0115",
      "ProvinceId": "CO04",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0116",
      "ProvinceId": "CO04",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0117",
      "ProvinceId": "CO04",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0118",
      "ProvinceId": "CO04",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0119",
      "ProvinceId": "CO04",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0120",
      "ProvinceId": "CO04",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0121",
      "ProvinceId": "CO04",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0122",
      "ProvinceId": "CO04",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0123",
      "ProvinceId": "CO04",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0124",
      "ProvinceId": "CO04",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0125",
      "ProvinceId": "CO04",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0126",
      "ProvinceId": "CO04",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0127",
      "ProvinceId": "CO04",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0128",
      "ProvinceId": "CO04",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0129",
      "ProvinceId": "CO04",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0130",
      "ProvinceId": "CO35",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0131",
      "ProvinceId": "CO35",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0132",
      "ProvinceId": "CO35",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0133",
      "ProvinceId": "CO35",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0134",
      "ProvinceId": "CO35",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0135",
      "ProvinceId": "CO35",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0136",
      "ProvinceId": "CO35",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0137",
      "ProvinceId": "CO35",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0138",
      "ProvinceId": "CO35",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0139",
      "ProvinceId": "CO35",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0140",
      "ProvinceId": "CO35",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0141",
      "ProvinceId": "CO35",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0142",
      "ProvinceId": "CO35",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0143",
      "ProvinceId": "CO35",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0145",
      "ProvinceId": "CO35",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0146",
      "ProvinceId": "CO35",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0147",
      "ProvinceId": "CO35",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0148",
      "ProvinceId": "CO35",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0149",
      "ProvinceId": "CO35",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0150",
      "ProvinceId": "CO35",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0151",
      "ProvinceId": "CO35",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0152",
      "ProvinceId": "CO35",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0153",
      "ProvinceId": "CO35",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0154",
      "ProvinceId": "CO35",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0155",
      "ProvinceId": "CO35",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0156",
      "ProvinceId": "CO35",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0157",
      "ProvinceId": "CO35",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0158",
      "ProvinceId": "CO35",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0159",
      "ProvinceId": "CO35",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0160",
      "ProvinceId": "CO35",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0162",
      "ProvinceId": "CO35",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0163",
      "ProvinceId": "CO35",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0164",
      "ProvinceId": "CO35",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0165",
      "ProvinceId": "CO35",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0166",
      "ProvinceId": "CO35",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0167",
      "ProvinceId": "CO35",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0168",
      "ProvinceId": "CO35",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0169",
      "ProvinceId": "CO35",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0170",
      "ProvinceId": "CO35",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0171",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0172",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0173",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0174",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0175",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0176",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0177",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0178",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0179",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0180",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0181",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0182",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0183",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0184",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0186",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0187",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0188",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0189",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0190",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0191",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0192",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0193",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0194",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0195",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0196",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0197",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0198",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0200",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0201",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0202",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0203",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0204",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0205",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0206",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0208",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0209",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0210",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0211",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0212",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0213",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0214",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0215",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0216",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0217",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0219",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0220",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0221",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0222",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0223",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0224",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0225",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0226",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0227",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0228",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0229",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0230",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0231",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0232",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0233",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0234",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0235",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0236",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0237",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0238",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0240",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0241",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0242",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0243",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0244",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0245",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0246",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0247",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0248",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0249",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0250",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0251",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0252",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0253",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0254",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0255",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0256",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0257",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0258",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0259",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0260",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0261",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0263",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0264",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0265",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0266",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0267",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0268",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0269",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0270",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0271",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0272",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0273",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0274",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0275",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0276",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0277",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0278",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0279",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0280",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0281",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0282",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0283",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0284",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0285",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0286",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0287",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0288",
      "ProvinceId": "CO37",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0289",
      "ProvinceId": "CO37",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0290",
      "ProvinceId": "CO37",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0291",
      "ProvinceId": "CO37",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0292",
      "ProvinceId": "CO37",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0293",
      "ProvinceId": "CO37",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0294",
      "ProvinceId": "CO37",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0295",
      "ProvinceId": "CO37",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0296",
      "ProvinceId": "CO37",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0297",
      "ProvinceId": "CO37",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0298",
      "ProvinceId": "CO37",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0299",
      "ProvinceId": "CO37",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0300",
      "ProvinceId": "CO37",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0301",
      "ProvinceId": "CO37",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0302",
      "ProvinceId": "CO37",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0303",
      "ProvinceId": "CO37",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0304",
      "ProvinceId": "CO37",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0305",
      "ProvinceId": "CO37",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0306",
      "ProvinceId": "CO37",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0307",
      "ProvinceId": "CO37",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0308",
      "ProvinceId": "CO37",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0309",
      "ProvinceId": "CO37",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0310",
      "ProvinceId": "CO37",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0311",
      "ProvinceId": "CO08",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0312",
      "ProvinceId": "CO08",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0313",
      "ProvinceId": "CO08",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0314",
      "ProvinceId": "CO08",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0315",
      "ProvinceId": "CO08",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0316",
      "ProvinceId": "CO08",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0317",
      "ProvinceId": "CO08",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0319",
      "ProvinceId": "CO08",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0321",
      "ProvinceId": "CO08",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0322",
      "ProvinceId": "CO08",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0323",
      "ProvinceId": "CO09",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0324",
      "ProvinceId": "CO09",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0325",
      "ProvinceId": "CO09",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0326",
      "ProvinceId": "CO09",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0327",
      "ProvinceId": "CO09",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0328",
      "ProvinceId": "CO09",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0329",
      "ProvinceId": "CO09",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0330",
      "ProvinceId": "CO09",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0331",
      "ProvinceId": "CO09",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0332",
      "ProvinceId": "CO09",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0334",
      "ProvinceId": "CO09",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0335",
      "ProvinceId": "CO09",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0336",
      "ProvinceId": "CO09",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0337",
      "ProvinceId": "CO09",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0339",
      "ProvinceId": "CO09",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0340",
      "ProvinceId": "CO09",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0341",
      "ProvinceId": "CO09",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0342",
      "ProvinceId": "CO09",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0343",
      "ProvinceId": "CO09",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0344",
      "ProvinceId": "CO09",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0345",
      "ProvinceId": "CO09",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0346",
      "ProvinceId": "CO09",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0347",
      "ProvinceId": "CO09",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0348",
      "ProvinceId": "CO09",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0349",
      "ProvinceId": "CO09",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0350",
      "ProvinceId": "CO09",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0352",
      "ProvinceId": "CO09",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0353",
      "ProvinceId": "CO09",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0354",
      "ProvinceId": "CO09",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0355",
      "ProvinceId": "CO09",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0357",
      "ProvinceId": "CO09",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0358",
      "ProvinceId": "CO09",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0359",
      "ProvinceId": "CO09",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0360",
      "ProvinceId": "CO10",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0362",
      "ProvinceId": "CO10",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0363",
      "ProvinceId": "CO10",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0364",
      "ProvinceId": "CO10",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0365",
      "ProvinceId": "CO10",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0366",
      "ProvinceId": "CO10",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0367",
      "ProvinceId": "CO10",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0368",
      "ProvinceId": "CO10",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0370",
      "ProvinceId": "CO10",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0371",
      "ProvinceId": "CO10",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0372",
      "ProvinceId": "CO10",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0373",
      "ProvinceId": "CO10",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0374",
      "ProvinceId": "CO10",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0375",
      "ProvinceId": "CO10",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0376",
      "ProvinceId": "CO10",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0377",
      "ProvinceId": "CO10",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0378",
      "ProvinceId": "CO10",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0379",
      "ProvinceId": "CO10",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0380",
      "ProvinceId": "CO10",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0381",
      "ProvinceId": "CO12",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0382",
      "ProvinceId": "CO12",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0383",
      "ProvinceId": "CO12",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0384",
      "ProvinceId": "CO12",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0385",
      "ProvinceId": "CO12",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0386",
      "ProvinceId": "CO12",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0387",
      "ProvinceId": "CO12",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0388",
      "ProvinceId": "CO12",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0389",
      "ProvinceId": "CO12",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0391",
      "ProvinceId": "CO12",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0392",
      "ProvinceId": "CO12",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0394",
      "ProvinceId": "CO12",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0396",
      "ProvinceId": "CO12",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0397",
      "ProvinceId": "CO12",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0398",
      "ProvinceId": "CO12",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0399",
      "ProvinceId": "CO12",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0400",
      "ProvinceId": "CO12",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0403",
      "ProvinceId": "CO12",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0404",
      "ProvinceId": "CO12",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0405",
      "ProvinceId": "CO12",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0406",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0407",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0408",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0409",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0410",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0411",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0412",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0413",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0414",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0415",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0416",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0417",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0418",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0419",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0420",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0421",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0422",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0425",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0426",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0427",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0428",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0429",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0430",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0431",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0432",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0433",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0434",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0435",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0437",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0438",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0439",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0440",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0442",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0443",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0444",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0445",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0446",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0447",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0448",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0449",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0450",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0451",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0452",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0453",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0454",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0455",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0456",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0457",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0458",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0459",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0461",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0462",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0464",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0465",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0466",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0467",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0468",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0470",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0472",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0473",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0474",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0475",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0477",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0478",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0479",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0480",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0481",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0482",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0483",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0484",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0485",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0486",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0487",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0488",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0489",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0490",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0491",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0492",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0493",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0494",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0495",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0496",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0497",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0498",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0499",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0500",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0501",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0502",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0503",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0504",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0505",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0506",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0507",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0508",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0509",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0510",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0512",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0513",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0514",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0515",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0517",
      "ProvinceId": "CO11",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0518",
      "ProvinceId": "CO11",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0519",
      "ProvinceId": "CO11",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0520",
      "ProvinceId": "CO11",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0521",
      "ProvinceId": "CO11",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0522",
      "ProvinceId": "CO11",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0523",
      "ProvinceId": "CO11",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0524",
      "ProvinceId": "CO11",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0526",
      "ProvinceId": "CO11",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0527",
      "ProvinceId": "CO11",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0528",
      "ProvinceId": "CO11",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0529",
      "ProvinceId": "CO11",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0530",
      "ProvinceId": "CO11",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0531",
      "ProvinceId": "CO11",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0532",
      "ProvinceId": "CO11",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0533",
      "ProvinceId": "CO11",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0535",
      "ProvinceId": "CO11",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0536",
      "ProvinceId": "CO11",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0537",
      "ProvinceId": "CO11",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0538",
      "ProvinceId": "CO11",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0539",
      "ProvinceId": "CO11",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0540",
      "ProvinceId": "CO11",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0542",
      "ProvinceId": "CO11",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0543",
      "ProvinceId": "CO16",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0544",
      "ProvinceId": "CO16",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0545",
      "ProvinceId": "CO16",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0546",
      "ProvinceId": "CO16",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0547",
      "ProvinceId": "CO16",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0548",
      "ProvinceId": "CO16",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0549",
      "ProvinceId": "CO16",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0550",
      "ProvinceId": "CO16",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0551",
      "ProvinceId": "CO16",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0552",
      "ProvinceId": "CO16",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0553",
      "ProvinceId": "CO16",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0554",
      "ProvinceId": "CO16",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0555",
      "ProvinceId": "CO16",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0556",
      "ProvinceId": "CO16",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0557",
      "ProvinceId": "CO16",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0558",
      "ProvinceId": "CO16",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0559",
      "ProvinceId": "CO16",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0560",
      "ProvinceId": "CO16",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0561",
      "ProvinceId": "CO16",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0562",
      "ProvinceId": "CO16",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0563",
      "ProvinceId": "CO16",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0565",
      "ProvinceId": "CO16",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0566",
      "ProvinceId": "CO16",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0568",
      "ProvinceId": "CO16",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0569",
      "ProvinceId": "CO16",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0570",
      "ProvinceId": "CO16",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0571",
      "ProvinceId": "CO16",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0572",
      "ProvinceId": "CO16",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0573",
      "ProvinceId": "CO16",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0574",
      "ProvinceId": "CO16",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0576",
      "ProvinceId": "CO17",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0577",
      "ProvinceId": "CO17",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0578",
      "ProvinceId": "CO17",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0579",
      "ProvinceId": "CO17",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0580",
      "ProvinceId": "CO17",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0581",
      "ProvinceId": "CO17",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0582",
      "ProvinceId": "CO17",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0583",
      "ProvinceId": "CO17",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0585",
      "ProvinceId": "CO17",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0587",
      "ProvinceId": "CO17",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0588",
      "ProvinceId": "CO17",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0589",
      "ProvinceId": "CO17",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0590",
      "ProvinceId": "CO38",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0591",
      "ProvinceId": "CO38",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0592",
      "ProvinceId": "CO38",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0593",
      "ProvinceId": "CO38",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0594",
      "ProvinceId": "CO38",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0595",
      "ProvinceId": "CO38",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0596",
      "ProvinceId": "CO38",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0598",
      "ProvinceId": "CO38",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0599",
      "ProvinceId": "CO38",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0601",
      "ProvinceId": "CO38",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0602",
      "ProvinceId": "CO38",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0603",
      "ProvinceId": "CO38",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0604",
      "ProvinceId": "CO38",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0605",
      "ProvinceId": "CO38",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0607",
      "ProvinceId": "CO38",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0608",
      "ProvinceId": "CO38",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0609",
      "ProvinceId": "CO38",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0610",
      "ProvinceId": "CO38",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0611",
      "ProvinceId": "CO38",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0612",
      "ProvinceId": "CO38",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0613",
      "ProvinceId": "CO38",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0614",
      "ProvinceId": "CO38",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0615",
      "ProvinceId": "CO38",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0616",
      "ProvinceId": "CO38",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0617",
      "ProvinceId": "CO19",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0619",
      "ProvinceId": "CO19",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0620",
      "ProvinceId": "CO19",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0621",
      "ProvinceId": "CO19",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0622",
      "ProvinceId": "CO19",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0623",
      "ProvinceId": "CO19",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0624",
      "ProvinceId": "CO19",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0625",
      "ProvinceId": "CO19",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0626",
      "ProvinceId": "CO19",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0627",
      "ProvinceId": "CO19",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0628",
      "ProvinceId": "CO19",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0630",
      "ProvinceId": "CO19",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0631",
      "ProvinceId": "CO19",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0633",
      "ProvinceId": "CO19",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0634",
      "ProvinceId": "CO19",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0635",
      "ProvinceId": "CO19",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0636",
      "ProvinceId": "CO19",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0637",
      "ProvinceId": "CO19",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0638",
      "ProvinceId": "CO19",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0639",
      "ProvinceId": "CO19",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0640",
      "ProvinceId": "CO19",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0641",
      "ProvinceId": "CO19",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0642",
      "ProvinceId": "CO20",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0643",
      "ProvinceId": "CO20",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0644",
      "ProvinceId": "CO20",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0645",
      "ProvinceId": "CO20",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0646",
      "ProvinceId": "CO20",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0647",
      "ProvinceId": "CO20",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0648",
      "ProvinceId": "CO20",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0649",
      "ProvinceId": "CO20",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0650",
      "ProvinceId": "CO20",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0651",
      "ProvinceId": "CO20",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0652",
      "ProvinceId": "CO20",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0653",
      "ProvinceId": "CO20",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0654",
      "ProvinceId": "CO20",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0656",
      "ProvinceId": "CO20",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0657",
      "ProvinceId": "CO20",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0658",
      "ProvinceId": "CO20",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0659",
      "ProvinceId": "CO20",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0660",
      "ProvinceId": "CO20",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0661",
      "ProvinceId": "CO20",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0662",
      "ProvinceId": "CO20",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0663",
      "ProvinceId": "CO20",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0664",
      "ProvinceId": "CO20",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0665",
      "ProvinceId": "CO20",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0666",
      "ProvinceId": "CO20",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0667",
      "ProvinceId": "CO20",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0668",
      "ProvinceId": "CO20",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0669",
      "ProvinceId": "CO20",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0670",
      "ProvinceId": "CO20",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0671",
      "ProvinceId": "CO20",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0672",
      "ProvinceId": "CO20",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0673",
      "ProvinceId": "CO20",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0674",
      "ProvinceId": "CO20",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0675",
      "ProvinceId": "CO20",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0676",
      "ProvinceId": "CO20",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0677",
      "ProvinceId": "CO20",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0678",
      "ProvinceId": "CO20",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0679",
      "ProvinceId": "CO20",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0680",
      "ProvinceId": "CO20",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0681",
      "ProvinceId": "CO20",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0682",
      "ProvinceId": "CO20",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0683",
      "ProvinceId": "CO20",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0684",
      "ProvinceId": "CO20",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0685",
      "ProvinceId": "CO20",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0686",
      "ProvinceId": "CO20",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0688",
      "ProvinceId": "CO20",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0689",
      "ProvinceId": "CO20",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0690",
      "ProvinceId": "CO20",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0691",
      "ProvinceId": "CO20",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0692",
      "ProvinceId": "CO20",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0693",
      "ProvinceId": "CO20",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0694",
      "ProvinceId": "CO20",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0695",
      "ProvinceId": "CO20",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0696",
      "ProvinceId": "CO20",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0697",
      "ProvinceId": "CO20",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0699",
      "ProvinceId": "CO20",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0700",
      "ProvinceId": "CO20",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0701",
      "ProvinceId": "CO21",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0702",
      "ProvinceId": "CO21",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0703",
      "ProvinceId": "CO21",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0704",
      "ProvinceId": "CO21",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0705",
      "ProvinceId": "CO21",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0706",
      "ProvinceId": "CO21",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0707",
      "ProvinceId": "CO21",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0708",
      "ProvinceId": "CO21",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0709",
      "ProvinceId": "CO21",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0710",
      "ProvinceId": "CO21",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0711",
      "ProvinceId": "CO21",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0712",
      "ProvinceId": "CO21",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0713",
      "ProvinceId": "CO21",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0714",
      "ProvinceId": "CO21",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0715",
      "ProvinceId": "CO21",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0716",
      "ProvinceId": "CO21",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0717",
      "ProvinceId": "CO21",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0718",
      "ProvinceId": "CO21",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0719",
      "ProvinceId": "CO21",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0720",
      "ProvinceId": "CO21",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0721",
      "ProvinceId": "CO21",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0722",
      "ProvinceId": "CO21",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0724",
      "ProvinceId": "CO21",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0725",
      "ProvinceId": "CO21",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0726",
      "ProvinceId": "CO21",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0727",
      "ProvinceId": "CO21",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0728",
      "ProvinceId": "CO21",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0729",
      "ProvinceId": "CO21",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0730",
      "ProvinceId": "CO21",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0731",
      "ProvinceId": "CO21",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0732",
      "ProvinceId": "CO21",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0734",
      "ProvinceId": "CO21",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0735",
      "ProvinceId": "CO21",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0736",
      "ProvinceId": "CO23",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0737",
      "ProvinceId": "CO23",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0738",
      "ProvinceId": "CO23",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0740",
      "ProvinceId": "CO23",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0741",
      "ProvinceId": "CO23",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0743",
      "ProvinceId": "CO23",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0746",
      "ProvinceId": "CO24",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0747",
      "ProvinceId": "CO24",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0748",
      "ProvinceId": "CO24",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0749",
      "ProvinceId": "CO24",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0750",
      "ProvinceId": "CO24",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0751",
      "ProvinceId": "CO24",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0752",
      "ProvinceId": "CO24",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0753",
      "ProvinceId": "CO24",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0754",
      "ProvinceId": "CO24",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0755",
      "ProvinceId": "CO24",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0757",
      "ProvinceId": "CO24",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0758",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0759",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0760",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0761",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0763",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0764",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0765",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0766",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0767",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0768",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0769",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0770",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0771",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0772",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0773",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0774",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0776",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0777",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0778",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0779",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0780",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0781",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0782",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0783",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0784",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0785",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0786",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0787",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0788",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0789",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0790",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0791",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0792",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0793",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0794",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0795",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0796",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0797",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0798",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0799",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0800",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0801",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0802",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0803",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0804",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0805",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0806",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0807",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0808",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0809",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0810",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0811",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0812",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0813",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0814",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0815",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0816",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0817",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0818",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0819",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0820",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0821",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0822",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0823",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0824",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0825",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0826",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0827",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0828",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0829",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0830",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0831",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0832",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0833",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0834",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0836",
      "ProvinceId": "CO27",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0837",
      "ProvinceId": "CO27",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0838",
      "ProvinceId": "CO27",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0839",
      "ProvinceId": "CO27",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0840",
      "ProvinceId": "CO27",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0841",
      "ProvinceId": "CO27",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0842",
      "ProvinceId": "CO27",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0843",
      "ProvinceId": "CO27",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0844",
      "ProvinceId": "CO27",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0845",
      "ProvinceId": "CO27",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0846",
      "ProvinceId": "CO27",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0847",
      "ProvinceId": "CO27",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0848",
      "ProvinceId": "CO27",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0849",
      "ProvinceId": "CO27",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0850",
      "ProvinceId": "CO27",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0851",
      "ProvinceId": "CO27",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0852",
      "ProvinceId": "CO27",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0854",
      "ProvinceId": "CO27",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0856",
      "ProvinceId": "CO27",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0857",
      "ProvinceId": "CO28",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0858",
      "ProvinceId": "CO28",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0859",
      "ProvinceId": "CO28",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0860",
      "ProvinceId": "CO28",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0861",
      "ProvinceId": "CO28",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0862",
      "ProvinceId": "CO28",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0863",
      "ProvinceId": "CO28",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0864",
      "ProvinceId": "CO28",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0865",
      "ProvinceId": "CO28",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0867",
      "ProvinceId": "CO28",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0868",
      "ProvinceId": "CO28",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0869",
      "ProvinceId": "CO28",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0870",
      "ProvinceId": "CO28",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0872",
      "ProvinceId": "CO28",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0873",
      "ProvinceId": "CO28",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0874",
      "ProvinceId": "CO28",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0875",
      "ProvinceId": "CO28",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0876",
      "ProvinceId": "CO28",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0877",
      "ProvinceId": "CO28",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0878",
      "ProvinceId": "CO28",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0879",
      "ProvinceId": "CO28",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0882",
      "ProvinceId": "CO28",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0883",
      "ProvinceId": "CO28",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0884",
      "ProvinceId": "CO28",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0885",
      "ProvinceId": "CO28",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0886",
      "ProvinceId": "CO28",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0888",
      "ProvinceId": "CO28",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0889",
      "ProvinceId": "CO28",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0890",
      "ProvinceId": "CO28",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0891",
      "ProvinceId": "CO28",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0892",
      "ProvinceId": "CO28",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0893",
      "ProvinceId": "CO28",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0894",
      "ProvinceId": "CO28",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0895",
      "ProvinceId": "CO28",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0896",
      "ProvinceId": "CO28",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0897",
      "ProvinceId": "CO28",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0898",
      "ProvinceId": "CO28",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0899",
      "ProvinceId": "CO29",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0900",
      "ProvinceId": "CO29",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0901",
      "ProvinceId": "CO29",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0902",
      "ProvinceId": "CO29",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0903",
      "ProvinceId": "CO29",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0905",
      "ProvinceId": "CO29",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0906",
      "ProvinceId": "CO29",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0907",
      "ProvinceId": "CO29",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0908",
      "ProvinceId": "CO29",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0909",
      "ProvinceId": "CO29",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0910",
      "ProvinceId": "CO29",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0911",
      "ProvinceId": "CO29",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0912",
      "ProvinceId": "CO29",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0913",
      "ProvinceId": "CO29",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0914",
      "ProvinceId": "CO29",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0915",
      "ProvinceId": "CO29",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0916",
      "ProvinceId": "CO29",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0917",
      "ProvinceId": "CO29",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0918",
      "ProvinceId": "CO29",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0919",
      "ProvinceId": "CO29",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0920",
      "ProvinceId": "CO29",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0921",
      "ProvinceId": "CO29",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0922",
      "ProvinceId": "CO29",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0923",
      "ProvinceId": "CO29",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0924",
      "ProvinceId": "CO29",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0925",
      "ProvinceId": "CO29",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0926",
      "ProvinceId": "CO29",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0927",
      "ProvinceId": "CO29",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0928",
      "ProvinceId": "CO29",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0930",
      "ProvinceId": "CO29",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0931",
      "ProvinceId": "CO29",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0932",
      "ProvinceId": "CO29",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0933",
      "ProvinceId": "CO29",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0934",
      "ProvinceId": "CO29",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0935",
      "ProvinceId": "CO29",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0938",
      "ProvinceId": "CO03",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0939",
      "ProvinceId": "CO03",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0941",
      "ProvinceId": "CO03",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0942",
      "ProvinceId": "CO32",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0943",
      "ProvinceId": "CO32",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0944",
      "ProvinceId": "CO32",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0945",
      "ProvinceId": "CO32",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0946",
      "ProvinceId": "CO32",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0951",
      "ProvinceId": "CO32",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0952",
      "ProvinceId": "CO32",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0953",
      "ProvinceId": "CO32",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0955",
      "ProvinceId": "CO32",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0957",
      "ProvinceId": "CO32",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0959",
      "ProvinceId": "CO22",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0960",
      "ProvinceId": "CO22",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0961",
      "ProvinceId": "CO22",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0963",
      "ProvinceId": "CO22",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0964",
      "ProvinceId": "CO22",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0965",
      "ProvinceId": "CO22",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0966",
      "ProvinceId": "CO22",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0971",
      "ProvinceId": "CO01",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0973",
      "ProvinceId": "CO01",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0975",
      "ProvinceId": "CO01",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0976",
      "ProvinceId": "CO01",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0977",
      "ProvinceId": "CO01",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0979",
      "ProvinceId": "CO15",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0980",
      "ProvinceId": "CO15",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0981",
      "ProvinceId": "CO15",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0982",
      "ProvinceId": "CO15",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0983",
      "ProvinceId": "CO15",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0984",
      "ProvinceId": "CO15",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0987",
      "ProvinceId": "CO14",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0988",
      "ProvinceId": "CO14",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0989",
      "ProvinceId": "CO14",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0992",
      "ProvinceId": "CO30",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0993",
      "ProvinceId": "CO30",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CO_0994",
      "ProvinceId": "CO30",
      "CountryCode": "CO"
  },
  {
      "CityCode": "ACM",
      "ProvinceId": "CO01",
      "CountryCode": "CO"
  },
  {
      "CityCode": "ADN",
      "ProvinceId": "CO04",
      "CountryCode": "CO"
  },
  {
      "CityCode": "API",
      "ProvinceId": "CO19",
      "CountryCode": "CO"
  },
  {
      "CityCode": "ARF",
      "ProvinceId": "CO01",
      "CountryCode": "CO"
  },
  {
      "CityCode": "ARQ",
      "ProvinceId": "CO03",
      "CountryCode": "CO"
  },
  {
      "CityCode": "AYC",
      "ProvinceId": "CO12",
      "CountryCode": "CO"
  },
  {
      "CityCode": "MFS",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "MHF",
      "ProvinceId": "CO15",
      "CountryCode": "CO"
  },
  {
      "CityCode": "MIX",
      "ProvinceId": "CO01",
      "CountryCode": "CO"
  },
  {
      "CityCode": "MMP",
      "ProvinceId": "CO35",
      "CountryCode": "CO"
  },
  {
      "CityCode": "MOY",
      "ProvinceId": "CO32",
      "CountryCode": "CO"
  },
  {
      "CityCode": "MQR",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "NAD",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "NAR",
      "ProvinceId": "CO19",
      "CountryCode": "CO"
  },
  {
      "CityCode": "NBB",
      "ProvinceId": "CO31",
      "CountryCode": "CO"
  },
  {
      "CityCode": "NUH",
      "ProvinceId": "CO32",
      "CountryCode": "CO"
  },
  {
      "CityCode": "ORC",
      "ProvinceId": "CO32",
      "CountryCode": "CO"
  },
  {
      "CityCode": "PBE",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "PLA",
      "ProvinceId": "CO28",
      "CountryCode": "CO"
  },
  {
      "CityCode": "PLC",
      "ProvinceId": "CO12",
      "CountryCode": "CO"
  },
  {
      "CityCode": "PLT",
      "ProvinceId": "CO38",
      "CountryCode": "CO"
  },
  {
      "CityCode": "PRE",
      "ProvinceId": "CO32",
      "CountryCode": "CO"
  },
  {
      "CityCode": "PYN",
      "ProvinceId": "CO20",
      "CountryCode": "CO"
  },
  {
      "CityCode": "PZA",
      "ProvinceId": "CO32",
      "CountryCode": "CO"
  },
  {
      "CityCode": "RON",
      "ProvinceId": "CO09",
      "CountryCode": "CO"
  },
  {
      "CityCode": "SCA",
      "ProvinceId": "CO35",
      "CountryCode": "CO"
  },
  {
      "CityCode": "SJG",
      "ProvinceId": "CO27",
      "CountryCode": "CO"
  },
  {
      "CityCode": "SJH",
      "ProvinceId": "CO17",
      "CountryCode": "CO"
  },
  {
      "CityCode": "SJR",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "SMC",
      "ProvinceId": "CO20",
      "CountryCode": "CO"
  },
  {
      "CityCode": "SQB",
      "ProvinceId": "CO29",
      "CountryCode": "CO"
  },
  {
      "CityCode": "SQE",
      "ProvinceId": "CO32",
      "CountryCode": "CO"
  },
  {
      "CityCode": "SRO",
      "ProvinceId": "CO08",
      "CountryCode": "CO"
  },
  {
      "CityCode": "SRS",
      "ProvinceId": "CO27",
      "CountryCode": "CO"
  },
  {
      "CityCode": "SSD",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "TAU",
      "ProvinceId": "CO32",
      "CountryCode": "CO"
  },
  {
      "CityCode": "TBD",
      "ProvinceId": "CO09",
      "CountryCode": "CO"
  },
  {
      "CityCode": "A11",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "AR9",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "AR8",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "AR7",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "AR2",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "A15",
      "ProvinceId": null,
      "CountryCode": "PE"
  },
  {
      "CityCode": "A16",
      "ProvinceId": null,
      "CountryCode": "PE"
  },
  {
      "CityCode": "A17",
      "ProvinceId": null,
      "CountryCode": "PE"
  },
  {
      "CityCode": "CO_0068",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "BU1",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "S25",
      "ProvinceId": null,
      "CountryCode": "EC"
  },
  {
      "CityCode": "BR_2630",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4273",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_23",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4848",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5510",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4852",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5143",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7373",
      "ProvinceId": "BR_RR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7401",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8873",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6812",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7313",
      "ProvinceId": "BR_RO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7408",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9795",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4856",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8886",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1810",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8335",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6845",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2683",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8340",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2384",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1",
      "ProvinceId": "BR_AC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_10",
      "ProvinceId": "BR_AC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9806",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1002",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1007",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1009",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_10090",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_10091",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_10092",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_10093",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_10094",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_10095",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_10096",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_10097",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_10098",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_10099",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4860",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_10100",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_10101",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_10102",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_10103",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1011",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1012",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1013",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1014",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_10144",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5788",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1016",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1019",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1021",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1024",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1027",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1029",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1030",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1031",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1033",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1034",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1035",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1036",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1037",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1040",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1041",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1044",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7134",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1046",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1047",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1049",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1051",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8772",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1056",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1059",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1064",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1065",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1066",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1071",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6851",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_108",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1080",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1081",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_31",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1085",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1087",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1088",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1089",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1090",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1091",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1094",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1095",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1098",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1099",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_11",
      "ProvinceId": "BR_AC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_110",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1100",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_11019",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5799",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_11020",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_11021",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1103",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1104",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1107",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1108",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_111",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1110",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1183",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1118",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1119",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8352",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1120",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1121",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1122",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1124",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1125",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1126",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4123",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1131",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_11323",
      "ProvinceId": "BR_AP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1134",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1137",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1138",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1149",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_115",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1154",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5805",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1161",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1168",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1169",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_117",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1173",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1176",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_118",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1180",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4871",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1185",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1187",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_11896",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_119",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1196",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_12",
      "ProvinceId": "BR_AC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_120",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1203",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1205",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1206",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1209",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_121",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1229",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_124",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_125",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1250",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1256",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_126",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1260",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1264",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1265",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1266",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1267",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_127",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1270",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7138",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1280",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1283",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8361",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1289",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_129",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1290",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1291",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1298",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_13",
      "ProvinceId": "BR_AC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1300",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1301",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1304",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_131",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1318",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8949",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1333",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1337",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1338",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1346",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1349",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_135",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1355",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_136",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1361",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1362",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1363",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1364",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1365",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1368",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1369",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_137",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1377",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1380",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1382",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1386",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_139",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1390",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1392",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5819",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_14",
      "ProvinceId": "BR_AC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1402",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1403",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1404",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7452",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2087",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1411",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1415",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1417",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1419",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_142",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1422",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1423",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1425",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1426",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_143",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1432",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1433",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1434",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1435",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_404",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_144",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1442",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1453",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_146",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1468",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1470",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1478",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1488",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1490",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1495",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1496",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_15",
      "ProvinceId": "BR_AC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_150",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1500",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1502",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_40",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1506",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_151",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1510",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1513",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1516",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1519",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_152",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1526",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1527",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5529",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_153",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1531",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1548",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_155",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1551",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1553",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1559",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1560",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_413",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1562",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1563",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1572",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1573",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1578",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_158",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1580",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1581",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8374",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_160",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1600",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1601",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1602",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1606",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1608",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1611",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_162",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1621",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1623",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1624",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1626",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_163",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1635",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1636",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1638",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1639",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_164",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1640",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1831",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1644",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1651",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1653",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1656",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_166",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1662",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1666",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1667",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_167",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1676",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_168",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2768",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1685",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_169",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1696",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_17",
      "ProvinceId": "BR_AC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_170",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1710",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1711",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5843",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1724",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1731",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1733",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1739",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1740",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1741",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1742",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_175",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1755",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1756",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_176",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1760",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1763",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1764",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1765",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1767",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1769",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1776",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1798",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_18",
      "ProvinceId": "BR_AC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1800",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1801",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1803",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1804",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1808",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_181",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1813",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_182",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1821",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1823",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1825",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1833",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1836",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5536",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_184",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1845",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1849",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_185",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1858",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_186",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1863",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1865",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1869",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1874",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1877",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8975",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1881",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1884",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1885",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1888",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1892",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1896",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_19",
      "ProvinceId": "BR_AC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1907",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_191",
      "ProvinceId": "BR_AM",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1910",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1915",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1916",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1918",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1923",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1927",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1928",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1929",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_193",
      "ProvinceId": "BR_AM",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1930",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1934",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1935",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1939",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_194",
      "ProvinceId": "BR_AM",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1941",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1942",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1946",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_195",
      "ProvinceId": "BR_AM",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1954",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1957",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_196",
      "ProvinceId": "BR_AM",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1962",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1964",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1966",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2408",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1978",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_198",
      "ProvinceId": "BR_AM",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1981",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1988",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1992",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1994",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2",
      "ProvinceId": "BR_AC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_20",
      "ProvinceId": "BR_AC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2003",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2006",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2017",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2019",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2024",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2031",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2035",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5179",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_204",
      "ProvinceId": "BR_AM",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2042",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2043",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6870",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2049",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_205",
      "ProvinceId": "BR_AM",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2050",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2051",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2052",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2053",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2054",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2055",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2056",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2057",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2059",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_206",
      "ProvinceId": "BR_AM",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2061",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2062",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2063",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2064",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2066",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2067",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_207",
      "ProvinceId": "BR_AM",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2072",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2073",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2074",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2075",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2076",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2077",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2078",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2079",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_208",
      "ProvinceId": "BR_AM",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2080",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2082",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2084",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2090",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2088",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2089",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_209",
      "ProvinceId": "BR_AM",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4882",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2091",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2092",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2093",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2094",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2097",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2098",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2099",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_21",
      "ProvinceId": "BR_AC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_210",
      "ProvinceId": "BR_AM",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2100",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2101",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5537",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2103",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2104",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2108",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_211",
      "ProvinceId": "BR_AM",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2110",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2111",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2112",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2113",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2116",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2117",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2122",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2123",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2126",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2127",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2130",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2131",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2132",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2135",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2137",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2138",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2139",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_214",
      "ProvinceId": "BR_AM",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2141",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2142",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2143",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2144",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2145",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2146",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2148",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2149",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_215",
      "ProvinceId": "BR_AM",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2150",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7144",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2154",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2155",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2157",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2158",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2159",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_216",
      "ProvinceId": "BR_AM",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7481",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2161",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2162",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2163",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2164",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2165",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8381",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2168",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_217",
      "ProvinceId": "BR_AM",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2171",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2172",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2173",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2175",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2176",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2177",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2178",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2179",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2180",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2181",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2182",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2183",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4576",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2185",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2186",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2187",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2188",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2189",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_219",
      "ProvinceId": "BR_AM",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2191",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2192",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2193",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2194",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2196",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2197",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9819",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2199",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_22",
      "ProvinceId": "BR_AC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_220",
      "ProvinceId": "BR_AM",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2200",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2201",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2202",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2203",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2205",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2207",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2208",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2210",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2212",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2214",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2786",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_222",
      "ProvinceId": "BR_AM",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2220",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2222",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2223",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2224",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2225",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2227",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2228",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2229",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_223",
      "ProvinceId": "BR_AM",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2232",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2233",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2235",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2236",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2237",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2238",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2239",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4883",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2241",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2242",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2243",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5862",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2245",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2247",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2248",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2249",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_225",
      "ProvinceId": "BR_AM",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2250",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2252",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2253",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2254",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2255",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8385",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2257",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2258",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2259",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2262",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2263",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2265",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2266",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2267",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2268",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2269",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_227",
      "ProvinceId": "BR_AM",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2270",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2271",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2272",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2273",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2276",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2277",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2278",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2789",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2280",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7376",
      "ProvinceId": "BR_RR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2284",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2285",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2286",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2287",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2288",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2289",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2290",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2292",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2293",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2295",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2300",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2302",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2303",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2304",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2306",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2307",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2308",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_231",
      "ProvinceId": "BR_AM",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2310",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2311",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2313",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2314",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2315",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2316",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2317",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2318",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2321",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2324",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2325",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2326",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2327",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2329",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2330",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2331",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2336",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2338",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2339",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_234",
      "ProvinceId": "BR_AM",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2340",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2341",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2343",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2345",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2346",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "B10",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2348",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4887",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8985",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2350",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2352",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2353",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2354",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2355",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2356",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2358",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5184",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2361",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2362",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2363",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2364",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2365",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2367",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2369",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_237",
      "ProvinceId": "BR_AM",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2370",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2371",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2372",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2373",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2374",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2375",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2376",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2377",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2378",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2379",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_238",
      "ProvinceId": "BR_AM",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2380",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2381",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2383",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7145",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2385",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2386",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2387",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2389",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_239",
      "ProvinceId": "BR_AM",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2390",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2391",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2393",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2394",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2396",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2398",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2401",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2402",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2403",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2404",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2405",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2406",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2419",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2409",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_241",
      "ProvinceId": "BR_AM",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2410",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2412",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2413",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2415",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2416",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2418",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_450",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_242",
      "ProvinceId": "BR_AM",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2420",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2421",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2422",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2423",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2424",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2425",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2426",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2428",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2429",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2430",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2812",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2432",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2433",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2434",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2435",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2436",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2437",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2439",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_244",
      "ProvinceId": "BR_AM",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7316",
      "ProvinceId": "BR_RO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2441",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2442",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2444",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2102",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2448",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2449",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_245",
      "ProvinceId": "BR_AM",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2450",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2452",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2453",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2454",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2455",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2456",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2457",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2459",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2460",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2461",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2462",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2463",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2464",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2465",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2466",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2467",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2468",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2469",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_247",
      "ProvinceId": "BR_AM",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2470",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2472",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2473",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2474",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2476",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2478",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2480",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2830",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2482",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2483",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2484",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2485",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2486",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2487",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2488",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2489",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2490",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2491",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2492",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2495",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2496",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2497",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2498",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2500",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2501",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2502",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2505",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2506",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2507",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2508",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2509",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_251",
      "ProvinceId": "BR_AM",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5192",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2511",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2512",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2513",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2514",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2515",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2516",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2517",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2518",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2519",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_252",
      "ProvinceId": "BR_AM",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2520",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2521",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2522",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2523",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2525",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2526",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2527",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2528",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2529",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_253",
      "ProvinceId": "BR_AM",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2530",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2531",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2532",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2533",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2534",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2535",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2537",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2538",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2539",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_254",
      "ProvinceId": "BR_AM",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2540",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2541",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2543",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2544",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7502",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9824",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2548",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2549",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2550",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2551",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1839",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2554",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2558",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2559",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_256",
      "ProvinceId": "BR_AM",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2560",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5888",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9009",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4899",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2564",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2565",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7506",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2567",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2569",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_257",
      "ProvinceId": "BR_AM",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2570",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2572",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2573",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2574",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2575",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2576",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2577",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2848",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2580",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_56",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2582",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2583",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2586",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2588",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2589",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_259",
      "ProvinceId": "BR_AM",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2590",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2591",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2592",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2594",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2595",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_57",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2597",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2598",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2599",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_26",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2600",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8400",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2602",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2603",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2604",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2605",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2606",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2607",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2608",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2609",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2610",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2611",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2612",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2613",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2614",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2616",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2617",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2618",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2619",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_262",
      "ProvinceId": "BR_AM",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2620",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2621",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2624",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2626",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2627",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2632",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2634",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2638",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2639",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_264",
      "ProvinceId": "BR_AM",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2640",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2641",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2642",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2643",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2649",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2652",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2654",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2655",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2656",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2657",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2658",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_266",
      "ProvinceId": "BR_AM",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2661",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2663",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2666",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2667",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2669",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_267",
      "ProvinceId": "BR_AM",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2673",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2675",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2676",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2679",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_268",
      "ProvinceId": "BR_AM",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2684",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2688",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_269",
      "ProvinceId": "BR_AM",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2691",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2693",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2694",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2698",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2699",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2700",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2701",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2702",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2706",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2707",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2708",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_271",
      "ProvinceId": "BR_AM",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2710",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2711",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2712",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2716",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2717",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2718",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2723",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2728",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2729",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_273",
      "ProvinceId": "BR_AM",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2730",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2731",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2734",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2735",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_274",
      "ProvinceId": "BR_AM",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2741",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2749",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_275",
      "ProvinceId": "BR_AM",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2751",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2753",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2755",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2757",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2759",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_276",
      "ProvinceId": "BR_AM",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2760",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2761",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2763",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2764",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2766",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9028",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2772",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2773",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2774",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2775",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2777",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2779",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2781",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2784",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2865",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2790",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2791",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2793",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2794",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2795",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2796",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2797",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2798",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2799",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_280",
      "ProvinceId": "BR_AP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2800",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2805",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2809",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_281",
      "ProvinceId": "BR_AP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2810",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2811",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_483",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2813",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2815",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2816",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2821",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2822",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2823",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4321",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2833",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2836",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2838",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2839",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2841",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2844",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2845",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2846",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2847",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_484",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2850",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2853",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2854",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2855",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2856",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2859",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2860",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2861",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2862",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2867",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_489",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2869",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_287",
      "ProvinceId": "BR_AP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2870",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2871",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2872",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2873",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2874",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2875",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2877",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2878",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2879",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2880",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2881",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2882",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2883",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2884",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2885",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2886",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2888",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2891",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2892",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2893",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2894",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2895",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2896",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2897",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2898",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2899",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2900",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2901",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2903",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2904",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2905",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2906",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2907",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2909",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2911",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2912",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2914",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2917",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2919",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2921",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2923",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2925",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2926",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2928",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2929",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2931",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2934",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2937",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2939",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_294",
      "ProvinceId": "BR_AP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2940",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2944",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2945",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2946",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2947",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2948",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2949",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2953",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2954",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2955",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_296",
      "ProvinceId": "BR_AP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2962",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2963",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2965",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2966",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2970",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2972",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2973",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2974",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2975",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2978",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2979",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2983",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2984",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2985",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2986",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2987",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2988",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2989",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2991",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2992",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2993",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2994",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2996",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2998",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2999",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3",
      "ProvinceId": "BR_AC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3006",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3008",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3010",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3011",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3012",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3013",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3014",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3015",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3017",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3020",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3022",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3023",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3024",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3025",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3026",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3027",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_303",
      "ProvinceId": "BR_AP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3030",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3033",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3034",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3039",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_304",
      "ProvinceId": "BR_AP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3040",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3041",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3042",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3043",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3046",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3048",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3049",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3050",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3052",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3053",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3054",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3057",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3058",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3059",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3061",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3062",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3063",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3065",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3066",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3068",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3071",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3073",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3075",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3077",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_308",
      "ProvinceId": "BR_AP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3081",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3082",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3085",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3086",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3088",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3089",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3090",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3093",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3095",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3097",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3098",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3099",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5918",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_310",
      "ProvinceId": "BR_AP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3101",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3105",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3106",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3110",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3111",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3112",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3113",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3117",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3119",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_312",
      "ProvinceId": "BR_AP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3125",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6883",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_313",
      "ProvinceId": "BR_AP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3130",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3131",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3132",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3133",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3134",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3135",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3137",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3138",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3139",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3143",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3144",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3145",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3146",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3148",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3153",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3155",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3158",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4596",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3161",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3162",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3165",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3168",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3172",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3174",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3177",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3178",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5920",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3180",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3181",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3182",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3184",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3187",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3190",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3191",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3192",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3194",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3195",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3196",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3200",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3201",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3202",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3203",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3204",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3205",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3206",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3208",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3209",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3210",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3211",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3212",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3213",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3214",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3216",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3217",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3218",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3219",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_322",
      "ProvinceId": "BR_AP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_64",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3222",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3224",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3225",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3226",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3227",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8781",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3230",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3232",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3233",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3235",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3238",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3239",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_324",
      "ProvinceId": "BR_AP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3242",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3244",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3247",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3249",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3250",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3251",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3253",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3254",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3256",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3257",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3258",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3259",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_326",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3261",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4143",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3265",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3266",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3267",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3269",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_327",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3271",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3273",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3276",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3278",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3282",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3283",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5558",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3285",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3288",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3289",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3290",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3291",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3292",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3293",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3295",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3296",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3297",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3298",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3299",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3300",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3301",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3302",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3303",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3304",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3305",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3306",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3307",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3308",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3309",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_331",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3311",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3312",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3317",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3319",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3322",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3324",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3325",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3328",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3329",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3330",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4909",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7152",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3333",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3335",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3340",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3341",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3342",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3343",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3344",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3346",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3347",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3348",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_335",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3351",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3354",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3355",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3358",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3362",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3363",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3366",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3370",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3371",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3372",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3373",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3374",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3375",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3378",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3380",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3381",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3382",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3383",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3385",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3386",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3387",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3388",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_339",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3390",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3392",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3393",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3394",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3395",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3396",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3397",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3398",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3399",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3400",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3401",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3402",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3403",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3404",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3407",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3409",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_341",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3416",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3417",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3418",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3419",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3421",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3425",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3429",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_343",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3430",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3432",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3436",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3437",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3438",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3439",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3440",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3441",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3443",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3445",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3446",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3449",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3450",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3452",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3454",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3458",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3461",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3462",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3463",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3464",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3465",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3467",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3468",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_347",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3470",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3473",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3476",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3477",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3478",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3482",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3483",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3484",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3485",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5943",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3489",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3491",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3492",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3494",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3497",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3499",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3500",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3501",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3502",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3503",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3504",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8412",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3506",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3508",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_351",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3511",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3516",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3519",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_352",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3520",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3521",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3523",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3524",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3528",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_353",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3530",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3533",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3536",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3537",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3542",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3543",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3544",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3545",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3548",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_355",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3551",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3552",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3553",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3555",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3556",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3558",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3559",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_356",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3560",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3562",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3563",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3565",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3568",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3569",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_357",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3570",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3571",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3573",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_358",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3581",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3582",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3583",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3585",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3586",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3588",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3590",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3594",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3596",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3597",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3599",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_36",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_360",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3600",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3602",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3604",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3608",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_361",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3611",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3612",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3613",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3614",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3615",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3618",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3619",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_362",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3620",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3623",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3625",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3627",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_363",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3630",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9056",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3633",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3634",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_364",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3641",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3644",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3647",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3648",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_365",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3652",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3653",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3655",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3656",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1287",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3658",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3659",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_366",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5222",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7569",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3662",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3663",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3667",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_367",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3670",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3673",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3677",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3678",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_368",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3681",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3682",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3683",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3684",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3685",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9832",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3688",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3689",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_369",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3691",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3694",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3695",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3697",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3698",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3699",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2440",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3700",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3702",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3703",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3704",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3705",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3706",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3708",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3709",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_371",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3710",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3713",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3715",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3717",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3718",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_372",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3722",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3723",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3725",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3727",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3729",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7599",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3732",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3733",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3734",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3737",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3738",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3739",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3743",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3744",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3746",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3748",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5983",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3751",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3752",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3753",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3754",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3756",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3757",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3758",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3761",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3762",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3764",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3766",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3771",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3772",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3774",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3776",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3781",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3782",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3783",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3784",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3785",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3787",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3789",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_379",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3793",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3794",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3798",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3799",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_380",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3800",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3803",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3807",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3808",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3812",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3813",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3816",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3818",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_382",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3823",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3824",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3825",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7607",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4920",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3828",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3829",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3831",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3833",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3836",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3838",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3840",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3841",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3843",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3844",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3845",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3847",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3849",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3850",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3851",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3856",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3860",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3861",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3862",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3863",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5231",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3865",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3866",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3869",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3870",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3874",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3875",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3878",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3883",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3885",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3886",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3895",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3897",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3903",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3904",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3906",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3907",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3909",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_391",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3911",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3914",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3921",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3923",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3924",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3926",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3927",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3933",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3934",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3935",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3938",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_394",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3943",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3948",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3949",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_395",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3951",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3952",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3953",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3954",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3955",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3957",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_396",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3962",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3964",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3965",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3967",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3968",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3970",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3973",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3976",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3977",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_398",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3980",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3981",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3982",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3983",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3987",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3992",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3994",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3996",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3997",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3999",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4",
      "ProvinceId": "BR_AC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_400",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4000",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4005",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4006",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4007",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6012",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4011",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4013",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4015",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4021",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4024",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4025",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7635",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4028",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4032",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4034",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4038",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4039",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2152",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2447",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4042",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4044",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4045",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4049",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4051",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4052",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4053",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4054",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4055",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4062",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4162",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4064",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4067",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4068",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4069",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_407",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4071",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4073",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4076",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4077",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4079",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6033",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4083",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4090",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4092",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4093",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4094",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4098",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4164",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4103",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4105",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4107",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4110",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4111",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4112",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4114",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4115",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4116",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4117",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9108",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4124",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4125",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4127",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4130",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8442",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4134",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4135",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4138",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_414",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5585",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4145",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4146",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4150",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4151",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4153",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4154",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4160",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4161",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9853",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2160",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4165",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4166",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4168",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4172",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4173",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4179",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4182",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4183",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4184",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4187",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4188",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9128",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_419",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4190",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4193",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4194",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4196",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4198",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_580",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9854",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4204",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4206",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4208",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_421",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4210",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4214",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4220",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4221",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4222",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4230",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4237",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4238",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5250",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_424",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4240",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4242",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4244",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4246",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4253",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4254",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4255",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4256",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4257",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4260",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4262",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4265",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_427",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4272",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8789",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_428",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4281",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4282",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4284",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4286",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4288",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4290",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4291",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4292",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4293",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4294",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4295",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4298",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4299",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_43",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_431",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4310",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4313",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4315",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4316",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4317",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4318",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_584",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4320",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9856",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4327",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4329",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_433",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4333",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4334",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4335",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4337",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4338",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_434",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4341",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4348",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4350",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4351",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4352",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4359",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4360",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4364",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5255",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4366",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4367",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4369",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4372",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4375",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4376",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4377",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4378",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4381",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4383",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4384",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4385",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4386",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4387",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4391",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4393",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4396",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4398",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4399",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_440",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4401",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4403",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4405",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4406",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4408",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_441",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4411",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4412",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4413",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4414",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4415",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6083",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4418",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4419",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_442",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4422",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4423",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4425",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4429",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_443",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4430",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2166",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4433",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4436",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4439",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4440",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4442",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4444",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4445",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4446",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4447",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4448",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_445",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4453",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4455",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4456",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4458",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3129",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4463",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4464",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4466",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4472",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4476",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4477",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4483",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4484",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4485",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4486",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4488",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4490",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4492",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4497",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4500",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4501",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4503",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4505",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4507",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_451",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4365",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4512",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4514",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_452",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4520",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6104",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4522",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4523",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4524",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4525",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4527",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4529",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4531",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4538",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4540",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_455",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4552",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4553",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4554",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4555",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4556",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4557",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4558",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4566",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4567",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_457",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4578",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4579",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_458",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4582",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4583",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4584",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4585",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4586",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4587",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_459",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4593",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4595",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4597",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4605",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4607",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4608",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_461",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4610",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4611",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4617",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4618",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4619",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_462",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4620",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4622",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4625",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4626",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4629",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4633",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4634",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4635",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4639",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4645",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4646",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4648",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4649",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4650",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4651",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4654",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4655",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4656",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4667",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4672",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4673",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4674",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4678",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4680",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4681",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4685",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4686",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4691",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4693",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_47",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_470",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4700",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4709",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4710",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4712",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4714",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4715",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4717",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4718",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4719",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4722",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4723",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4725",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4727",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6126",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4733",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4738",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4743",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4744",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4746",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4747",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4750",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9169",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4752",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3179",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4757",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4760",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4761",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4763",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4764",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4765",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4766",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4767",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4769",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4770",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4773",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4775",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4777",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4778",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4779",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_478",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4780",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4781",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4784",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4785",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4786",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4787",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4789",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_479",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4797",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4805",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8471",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4808",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4810",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4811",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4816",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4817",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4820",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4821",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4822",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4823",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4825",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4826",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4831",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4842",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4845",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4846",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1375",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4849",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4850",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4851",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2184",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4853",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4854",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4855",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_228",
      "ProvinceId": "BR_AM",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7761",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4858",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4859",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_486",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4861",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4862",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4863",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4865",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4866",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4867",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4868",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6157",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4872",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4873",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4876",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5600",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4878",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4879",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_488",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4880",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5283",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4885",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4886",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6165",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4888",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4889",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1397",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4890",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4891",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4892",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4894",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4896",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4897",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4898",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7776",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_490",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4900",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4901",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4902",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4903",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4908",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3221",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_491",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4911",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4913",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4914",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4916",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4917",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4919",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6167",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4922",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4923",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4925",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4926",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4927",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4928",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4929",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_493",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4930",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4932",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4933",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4934",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4935",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4936",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4937",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4938",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4939",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4941",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4942",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4946",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4947",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4949",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_495",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4951",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4952",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4953",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4954",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4955",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4956",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3228",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1405",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4960",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4961",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4962",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4963",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4965",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4966",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4967",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4968",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4969",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4970",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4971",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4973",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4974",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4976",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4977",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4978",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4979",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_498",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4981",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4982",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4983",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4984",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4985",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4986",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9864",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_499",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4990",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4991",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4992",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4993",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4995",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4996",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4997",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4998",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5",
      "ProvinceId": "BR_AC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_50",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1407",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5002",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5004",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5006",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7380",
      "ProvinceId": "BR_RR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5008",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_501",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5012",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5013",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5014",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5015",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6178",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8502",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4957",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5020",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5021",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5022",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5025",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5026",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8796",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5029",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5033",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5035",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5036",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5037",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5038",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5039",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5042",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5043",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2198",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7185",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5047",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5049",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_505",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5050",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5051",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5053",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5057",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5294",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6185",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_506",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_704",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8509",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3262",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5068",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_507",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5070",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5071",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5072",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9242",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_235",
      "ProvinceId": "BR_AM",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5075",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5076",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5077",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8510",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5081",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5082",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5083",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5084",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5086",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5087",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5089",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5090",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5091",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5092",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5093",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5094",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5095",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5096",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5097",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5099",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_51",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5100",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5101",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5103",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5104",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5105",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5106",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5107",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5108",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4959",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_511",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5110",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5111",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9247",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5113",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5114",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5116",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5117",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_734",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9264",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5122",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5123",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3284",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5125",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5127",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7804",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_513",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5132",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5133",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5134",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5135",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5136",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5137",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5138",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5140",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5141",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7188",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5146",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5147",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5148",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5150",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5152",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5153",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5154",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5158",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_516",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5165",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5167",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5168",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5169",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5173",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5174",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5177",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5178",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_236",
      "ProvinceId": "BR_AM",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5183",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6218",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5185",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5186",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5187",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_519",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5190",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8518",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5193",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5195",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5197",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5198",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5200",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5201",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5203",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5204",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_521",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5211",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5212",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5214",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5217",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5218",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5223",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5225",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_523",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1439",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5232",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5233",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5239",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5240",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5242",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5244",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5246",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5248",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_525",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4189",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5253",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5254",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8519",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5256",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5258",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_526",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5260",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5261",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5263",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5270",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5271",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5272",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_528",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5281",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5282",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9282",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5284",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5286",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_529",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5291",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5292",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2481",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5295",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5296",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5297",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_53",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_530",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5304",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5305",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5307",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5309",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5310",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5314",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5315",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7198",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5321",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5322",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5323",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5325",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_95",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5329",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_533",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5331",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5334",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5335",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5337",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_534",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5341",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5345",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5347",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5348",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_535",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5355",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_536",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5316",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5365",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5366",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5367",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5369",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5617",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5370",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5371",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5377",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2217",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_538",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5381",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5383",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6236",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5385",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5387",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_766",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_539",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5391",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5395",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3331",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5400",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5326",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5407",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5411",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5413",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5414",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5416",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5417",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5419",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5421",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5422",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5424",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5425",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_543",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5433",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5434",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5436",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3338",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5439",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_544",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5441",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5442",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5443",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5445",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6256",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_545",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5453",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5454",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5456",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5459",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_546",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5461",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5462",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5463",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5465",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5466",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_547",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5470",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5474",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5476",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5478",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5479",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_112",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_113",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5485",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5487",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_549",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5496",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5497",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5498",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5499",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5500",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5503",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5505",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5508",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5509",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_551",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8549",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5511",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5512",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5513",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5514",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5515",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5516",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5517",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5518",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5519",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_552",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5520",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5521",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5522",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5523",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5524",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5525",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5526",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5527",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5528",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4987",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5530",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5531",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5532",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5533",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5534",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5535",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8556",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3411",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5538",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5539",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_554",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5540",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5541",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5542",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5543",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5544",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5545",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5546",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5547",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5548",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5549",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5550",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5551",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5552",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5553",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5554",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5555",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5556",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5557",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6973",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5559",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_556",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5560",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5561",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5562",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5563",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5564",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5565",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5566",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5567",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5568",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5569",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5570",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5571",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5572",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5573",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5574",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5575",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5576",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5577",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5578",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5579",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5580",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5581",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5582",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5583",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5584",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1505",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5586",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5587",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5588",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_559",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5590",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5591",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5592",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5593",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5594",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5595",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5596",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5597",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5598",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5599",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_833",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2510",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5601",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5602",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5603",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5604",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5605",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5606",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5607",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5608",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5609",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_561",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5610",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5611",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5612",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5613",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5614",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5615",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5616",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6331",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5618",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5619",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5620",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5621",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5622",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5623",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5624",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5625",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5626",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5627",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5628",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5629",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5630",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5631",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5632",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5633",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5634",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5635",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5636",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5637",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5638",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5639",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5640",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5641",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5642",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5643",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5644",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5647",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5649",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_565",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5650",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5651",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5652",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5653",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5654",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5655",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5656",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5657",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5659",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5660",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5661",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5662",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5663",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5664",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5665",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5666",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5667",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5668",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5669",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_567",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5670",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5671",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5672",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5673",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5674",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5675",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5676",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5677",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5678",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5679",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_568",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5680",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5681",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4695",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5683",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5684",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5685",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5686",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5687",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5688",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5689",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5690",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5691",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5692",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5693",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5694",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5695",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5696",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5697",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5698",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5699",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7218",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5700",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8566",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5702",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5703",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5704",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5705",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5706",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5707",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5708",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5709",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_571",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5710",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5711",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5712",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5713",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5714",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5715",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5716",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5717",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5718",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5719",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_572",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5720",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5722",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5723",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5724",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5725",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9381",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5727",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5728",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5729",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5731",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5735",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5743",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5746",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5747",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1528",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5755",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5756",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_576",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5761",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5763",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5764",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5766",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5767",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5768",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_577",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5771",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5776",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_578",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5785",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2240",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5796",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5797",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5798",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1532",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5000",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2244",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5804",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4203",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5809",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_581",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5812",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_856",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5834",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5836",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6985",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5842",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9890",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5845",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5846",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5852",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5854",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5856",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_586",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_864",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5864",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5868",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_587",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5871",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5873",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_588",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5886",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9891",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5889",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5892",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5895",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5897",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5902",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5904",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5908",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5910",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5913",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5915",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5916",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2251",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6356",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5927",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5933",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5938",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5942",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6366",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5949",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_595",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5955",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5957",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5958",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_596",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5960",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5962",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_597",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_870",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_599",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5990",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5991",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5993",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5995",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5996",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5997",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5999",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_600",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6001",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6008",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6009",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6011",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4417",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6013",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6016",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_602",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6023",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6024",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6025",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6030",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6370",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6035",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6038",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6046",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6047",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6049",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_605",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6051",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6052",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6059",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_606",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6061",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6068",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6072",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6073",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6077",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6081",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6082",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1547",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6084",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6086",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_609",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6090",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6092",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6093",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_61",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5007",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6107",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6108",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6109",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6113",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9892",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6116",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6120",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6122",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6124",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5645",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6130",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6133",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_614",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6145",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6147",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6148",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6150",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6152",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6155",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7914",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6161",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6163",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6164",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3487",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7344",
      "ProvinceId": "BR_RO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6172",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6175",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6176",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2256",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_618",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6180",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6181",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6183",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6184",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8580",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6189",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6190",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6192",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6194",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6196",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6198",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6199",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6201",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6205",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6211",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6213",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6216",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6217",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8581",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6221",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6222",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6226",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6228",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_623",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6230",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6234",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6235",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_879",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6238",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_624",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_625",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6254",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9420",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6257",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_626",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6261",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6263",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6264",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6266",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6267",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_627",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6272",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6273",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6274",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6279",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6281",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6283",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6284",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6286",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6287",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6288",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6289",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_629",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6297",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6299",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_630",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6301",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6303",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6304",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6306",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6309",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6310",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6314",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6316",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6319",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6320",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6324",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6325",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6326",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6330",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4521",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6334",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6335",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6338",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6339",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_634",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6342",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6349",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_635",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6352",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6354",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5648",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_636",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6361",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6364",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6365",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5362",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6367",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6368",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_637",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6371",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6373",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6374",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6375",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6380",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6390",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6392",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6393",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6396",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_640",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_132",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3505",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6410",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6414",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6416",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6419",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6426",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6430",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6432",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6433",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6438",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6439",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_644",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6440",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6443",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6446",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6448",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_645",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7225",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6458",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6460",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6462",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6465",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_647",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8585",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6472",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6473",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6476",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6477",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6484",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6489",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6490",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6491",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9437",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6496",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6498",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_65",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6500",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1561",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6502",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6504",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6506",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6507",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6509",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_651",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6510",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6511",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6512",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6513",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6514",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6517",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6518",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6519",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6523",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6524",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6527",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6528",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_653",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6530",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6531",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6532",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8820",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6554",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6556",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6558",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6559",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6560",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6562",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6565",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6566",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6569",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6570",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6572",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6575",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_133",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9441",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6579",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6580",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6587",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6589",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6590",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6597",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6601",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6604",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6605",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6608",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6609",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6610",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6616",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_662",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6632",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6639",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6640",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6642",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6646",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6647",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6648",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6651",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6652",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_667",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6670",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6674",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6679",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_668",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6687",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6688",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6689",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_669",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_67",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6702",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6402",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6708",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8591",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6711",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6718",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_672",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6722",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6727",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6728",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_673",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6734",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6737",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_674",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6742",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6744",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6406",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9445",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6753",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6758",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_676",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6760",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8595",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6762",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6763",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_677",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6772",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6774",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_678",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6786",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6787",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6788",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9449",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6793",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6798",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6799",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_68",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6806",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6807",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6809",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_681",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_682",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6827",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7004",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6835",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6838",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7229",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6847",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6848",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6849",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5016",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6863",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6865",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7231",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6871",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6879",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_688",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4731",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6885",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6886",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6887",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6889",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_689",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6893",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6896",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_69",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_690",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6900",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_691",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6911",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6914",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_692",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6927",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6932",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6947",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6949",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6957",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6963",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6964",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6971",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6972",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9904",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6974",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6975",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_698",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6988",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6999",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7",
      "ProvinceId": "BR_AC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_70",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_700",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7000",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7007",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1594",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7015",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7017",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_702",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7020",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_703",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7030",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7032",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5019",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4432",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7057",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7062",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7065",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7066",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7067",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7073",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7076",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_708",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7080",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7235",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7088",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_709",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7091",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7095",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7099",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_71",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7104",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5388",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7112",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_712",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7124",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7125",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7126",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7127",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7128",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7129",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_713",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7130",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7131",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7132",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7133",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8606",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7135",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7136",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7012",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7139",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7141",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7142",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7143",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_145",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7146",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7147",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7148",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5027",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_715",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7150",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7151",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5028",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7153",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7154",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7155",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7156",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7157",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7158",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_716",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7160",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7161",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7162",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7163",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7164",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7165",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7166",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7168",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7169",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7171",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7172",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7173",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7176",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7177",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7178",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7179",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_718",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7180",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7182",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7184",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7239",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7186",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7187",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8609",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7189",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7190",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7191",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7192",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7193",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7194",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7195",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7196",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7197",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9487",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7199",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7200",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7201",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7202",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7203",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7205",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7206",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7207",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7208",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7209",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_721",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7211",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7212",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7213",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7215",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7216",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7217",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6454",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7219",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7223",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7224",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8825",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7226",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7227",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7228",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_147",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_723",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7230",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2281",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7232",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7233",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7234",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6463",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7236",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7237",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7238",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9503",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7240",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7241",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7242",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7243",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7244",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7245",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7246",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6466",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7985",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7249",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_725",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7250",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_934",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9504",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7258",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7259",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7260",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7262",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7263",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7265",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7266",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7269",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_727",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7272",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7273",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7274",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7276",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7278",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_728",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7281",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7282",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7283",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7285",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7286",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7287",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7289",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_729",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7290",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7292",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7293",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7295",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7296",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7297",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7299",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_73",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_730",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7302",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7303",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7304",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7306",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3657",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5041",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7309",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7311",
      "ProvinceId": "BR_RO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7312",
      "ProvinceId": "BR_RO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3660",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7314",
      "ProvinceId": "BR_RO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7315",
      "ProvinceId": "BR_RO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9530",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7317",
      "ProvinceId": "BR_RO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7318",
      "ProvinceId": "BR_RO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7321",
      "ProvinceId": "BR_RO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7322",
      "ProvinceId": "BR_RO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7323",
      "ProvinceId": "BR_RO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7324",
      "ProvinceId": "BR_RO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7325",
      "ProvinceId": "BR_RO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7326",
      "ProvinceId": "BR_RO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7327",
      "ProvinceId": "BR_RO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7328",
      "ProvinceId": "BR_RO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7329",
      "ProvinceId": "BR_RO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_733",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7330",
      "ProvinceId": "BR_RO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7331",
      "ProvinceId": "BR_RO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7332",
      "ProvinceId": "BR_RO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7334",
      "ProvinceId": "BR_RO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7335",
      "ProvinceId": "BR_RO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7337",
      "ProvinceId": "BR_RO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7339",
      "ProvinceId": "BR_RO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6494",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7340",
      "ProvinceId": "BR_RO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7341",
      "ProvinceId": "BR_RO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7342",
      "ProvinceId": "BR_RO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7343",
      "ProvinceId": "BR_RO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8627",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7346",
      "ProvinceId": "BR_RO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7347",
      "ProvinceId": "BR_RO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7348",
      "ProvinceId": "BR_RO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_735",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7350",
      "ProvinceId": "BR_RO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7351",
      "ProvinceId": "BR_RO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2545",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7354",
      "ProvinceId": "BR_RO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7356",
      "ProvinceId": "BR_RO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7359",
      "ProvinceId": "BR_RO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_736",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7360",
      "ProvinceId": "BR_RO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7361",
      "ProvinceId": "BR_RO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7362",
      "ProvinceId": "BR_RO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7363",
      "ProvinceId": "BR_RO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7365",
      "ProvinceId": "BR_RO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7366",
      "ProvinceId": "BR_RO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7367",
      "ProvinceId": "BR_RO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7368",
      "ProvinceId": "BR_RO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7369",
      "ProvinceId": "BR_RO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_949",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7374",
      "ProvinceId": "BR_RR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2546",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7377",
      "ProvinceId": "BR_RR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7378",
      "ProvinceId": "BR_RR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7379",
      "ProvinceId": "BR_RR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3661",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7381",
      "ProvinceId": "BR_RR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7382",
      "ProvinceId": "BR_RR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7383",
      "ProvinceId": "BR_RR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7384",
      "ProvinceId": "BR_RR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7385",
      "ProvinceId": "BR_RR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7386",
      "ProvinceId": "BR_RR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7387",
      "ProvinceId": "BR_RR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7388",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7390",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7392",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7393",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7395",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7397",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7399",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_74",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_740",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7400",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1971",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7404",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9923",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7409",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7410",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7411",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7412",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7414",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7415",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7416",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7417",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_742",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7421",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7422",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7423",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7425",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7426",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7427",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_743",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7431",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7434",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7435",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7439",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7441",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7443",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7444",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7445",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7446",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7448",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7449",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2547",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7450",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7451",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7353",
      "ProvinceId": "BR_RO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7458",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7465",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7472",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7473",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7474",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7475",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7476",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4751",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7482",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7483",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7486",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7490",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7492",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7494",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7495",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7497",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7499",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_75",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_750",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7500",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7501",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5399",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7503",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7505",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7507",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7508",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7509",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_751",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7512",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7513",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7516",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7520",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7525",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7526",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7528",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7529",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_753",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7531",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7534",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7536",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7542",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7543",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7544",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7547",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7548",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7552",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7554",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7555",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7556",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7558",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_756",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7561",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7563",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7572",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7576",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7580",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7581",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7582",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7583",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7585",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7586",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7587",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_759",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7591",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7592",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7593",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7595",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5044",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_760",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_954",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7609",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7611",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7612",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7613",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7616",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7617",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7619",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7624",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7625",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7628",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7629",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7630",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7632",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7633",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5045",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7642",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7646",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7647",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7648",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7651",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7652",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7653",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7654",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7656",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7657",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7658",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5402",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7661",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7663",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7664",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7665",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7667",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7669",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_767",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7670",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7671",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7672",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7674",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7676",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7678",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7679",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_768",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7681",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7682",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7687",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7694",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7696",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_77",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_770",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7700",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7702",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7703",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7705",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7712",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7713",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7716",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7717",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7722",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7724",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7725",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7728",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7729",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7735",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7736",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7737",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7738",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7739",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7740",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7742",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7745",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7747",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7749",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7752",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7753",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7755",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7756",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7757",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7760",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1643",
      "ProvinceId": "BR_CE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7762",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7764",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7765",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7766",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7767",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7773",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7774",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7775",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4754",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7777",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7778",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_778",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7780",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7782",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7784",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7786",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_779",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7792",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7794",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7795",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7796",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_78",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7800",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7801",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7802",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7803",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2553",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7805",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7807",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7809",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_781",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7810",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7815",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7818",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7819",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_782",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7820",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7821",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7822",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5048",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7827",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7833",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7835",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7836",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7838",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_784",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7841",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7842",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7844",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7847",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7848",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7849",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_785",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7851",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7853",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7854",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7857",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7858",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7860",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7862",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7863",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7866",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7868",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7869",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_787",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7873",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7876",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7878",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7880",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7881",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7883",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7886",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7887",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7889",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7890",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7891",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7892",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7893",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7895",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7896",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7899",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_79",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7900",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7901",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7902",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7903",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7904",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7905",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7906",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7908",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7909",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_791",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7911",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7912",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7913",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3686",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7916",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7917",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7920",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7922",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7925",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_793",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7932",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7933",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7935",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7936",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7938",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7939",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7940",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7941",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7942",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7943",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7944",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7952",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7956",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7958",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7959",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7962",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7964",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7966",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7967",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_797",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7972",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7973",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7976",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7977",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_798",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7982",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7983",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9927",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7988",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_799",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7991",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7992",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7993",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7996",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7997",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7998",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7999",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8",
      "ProvinceId": "BR_AC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_800",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8000",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8005",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8006",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_801",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8010",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8012",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8013",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8015",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8016",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_802",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8020",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8023",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8025",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8026",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_803",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_804",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8040",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8043",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8047",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8048",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8049",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_805",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8050",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8051",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8053",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8054",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8055",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8057",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8058",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_806",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8060",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8064",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8065",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8067",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8071",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8073",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8075",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8088",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8094",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8096",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_81",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_810",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8100",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8102",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8104",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8108",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8109",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_811",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8112",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8113",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8114",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8115",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8116",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8120",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8122",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8124",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7247",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_967",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8127",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8131",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8132",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8133",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8137",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_814",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8140",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8141",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8142",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8143",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8144",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8145",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8148",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_815",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8151",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8153",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7248",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8156",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8158",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8159",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8161",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8163",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8164",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8165",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8167",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_817",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8171",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8172",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8174",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8176",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8177",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8178",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8179",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_818",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8180",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8181",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8832",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8184",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8187",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8188",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8191",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8192",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8193",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8195",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8196",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8199",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8200",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8202",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8206",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8209",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8210",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8217",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8224",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8226",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8227",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8228",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_823",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8230",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8232",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8233",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8235",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8238",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8239",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8246",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8248",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8250",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8251",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8252",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8253",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8254",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8255",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8257",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4239",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8260",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8262",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8264",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8265",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8267",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8269",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8272",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8274",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8276",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8277",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8280",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8283",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8284",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8286",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8287",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6543",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_829",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8290",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8292",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8293",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8294",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8295",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8296",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8299",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8300",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8302",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8303",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8307",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8309",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_831",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8310",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8312",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8317",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8318",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8319",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_832",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8320",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8321",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8322",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8323",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8326",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8327",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8328",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7252",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8331",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8333",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_982",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8336",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8337",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8338",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_834",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5056",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8341",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8342",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8343",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8344",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8345",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8347",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8348",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8349",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8350",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5415",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8355",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8356",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8358",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8360",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8663",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8367",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8373",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9586",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8375",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8376",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8378",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3731",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8382",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8383",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_990",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8386",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8387",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8388",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8389",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_839",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8394",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8395",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8396",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_84",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_840",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5058",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8401",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8402",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8405",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8407",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8408",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8409",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8410",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8667",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8414",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8416",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8417",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8418",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8421",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8424",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8425",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8426",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8427",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8428",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8429",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8431",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8432",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8433",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8436",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8437",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8438",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8439",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5059",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8443",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8444",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8447",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8451",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8453",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8454",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8458",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8459",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_846",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8462",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8466",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8469",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_847",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5420",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8472",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8473",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8475",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8478",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8479",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8480",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8482",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8483",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8484",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8485",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8487",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8492",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8493",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8495",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8496",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8497",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8498",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_85",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8500",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7254",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8503",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8504",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8506",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5423",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5682",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_851",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2561",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8514",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8515",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8516",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8517",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5061",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6577",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_852",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8522",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8523",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8524",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8529",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_853",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8530",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8531",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8533",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8534",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8535",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8537",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8539",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_854",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8540",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8542",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8544",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8545",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8546",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8669",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_855",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8552",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8557",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8558",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8561",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8562",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8563",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8565",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8568",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_857",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8570",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8574",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8576",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8579",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_858",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2309",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8582",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8583",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8584",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9608",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8587",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8588",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_859",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8590",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6581",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8592",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8594",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9610",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8596",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8598",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_86",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8600",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8601",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8604",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_861",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8611",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8616",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8618",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8619",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8620",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8621",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8623",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8624",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8628",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8631",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8632",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8634",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8636",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8646",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8648",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8649",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_865",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8652",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8653",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8655",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8657",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8658",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8659",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_866",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8660",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8662",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8664",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8666",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2566",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5066",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8675",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8676",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8838",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8678",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8680",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4470",
      "ProvinceId": "BR_MT",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8685",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8686",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5427",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8689",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_869",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8677",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_998",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8695",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8696",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8698",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8699",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_87",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1000",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8701",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8702",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8705",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8706",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_316",
      "ProvinceId": "BR_AP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8708",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8709",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_871",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8711",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8717",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8718",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8719",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8721",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8723",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8724",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8726",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8727",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1004",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_873",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8732",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8733",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8734",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8736",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8737",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8738",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8739",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8740",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8741",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8743",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2568",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8746",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8747",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8749",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_875",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8750",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8751",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8681",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8755",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8756",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_876",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8761",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8762",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8764",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8765",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8766",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8768",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8769",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_877",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8771",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8776",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8777",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8778",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8779",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9625",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8782",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8783",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8784",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8785",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8786",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8787",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8788",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2571",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8790",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8791",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8792",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8793",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8794",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8795",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5074",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8797",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8798",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8799",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_88",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_880",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8800",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8801",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8802",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8805",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8806",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8807",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8808",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8810",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8811",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8813",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8814",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8815",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8816",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8817",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8818",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8819",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8822",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8824",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8826",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8827",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8828",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8829",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8830",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8831",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1010",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8833",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8834",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8835",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8837",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2320",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8839",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8840",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8841",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8691",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8842",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8846",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8847",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8848",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8849",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_885",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8850",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8851",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8852",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8853",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8854",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8857",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8858",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_886",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8860",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8862",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8865",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8870",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8871",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8872",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3826",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8875",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8876",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8877",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8878",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8879",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8884",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8885",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5078",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8888",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8891",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8892",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8893",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8894",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8843",
      "ProvinceId": "BR_SE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8897",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_89",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8901",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8906",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8908",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8909",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_891",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8910",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8911",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8913",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8916",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8917",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8918",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8919",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8920",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8923",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8924",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8925",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_893",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8930",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8931",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8932",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8937",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8940",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8941",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8942",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8945",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8947",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8948",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9644",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8950",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8951",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8955",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8957",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8958",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8965",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8966",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8968",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8969",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8970",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8972",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8125",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8976",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8979",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_898",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8981",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8983",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8984",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1015",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8986",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_899",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8995",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8996",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8997",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9",
      "ProvinceId": "BR_AC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_90",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9000",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9001",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9002",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9003",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9008",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8126",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_901",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9011",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9013",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9014",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9015",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9016",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9017",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9018",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9023",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9026",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9029",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_903",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9030",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9031",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9033",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9034",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9036",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9037",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9038",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9039",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_904",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9044",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9049",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9050",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9051",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9052",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9053",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7268",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9057",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9058",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9059",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9061",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9062",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9065",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9067",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9068",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9070",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9071",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9072",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9073",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9075",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9078",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9079",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_908",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9080",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9082",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9083",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9084",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9086",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9088",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9090",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9093",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9094",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9095",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9097",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9098",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9099",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_910",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9100",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9102",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9103",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9104",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9105",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9107",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5438",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_911",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9110",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9111",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9112",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9113",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9114",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9115",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9118",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9124",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9125",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9126",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9127",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6633",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9129",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_913",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9131",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9135",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9137",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9138",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9139",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9140",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9142",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9143",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2578",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9145",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9148",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9149",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9150",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9152",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9153",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9154",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9155",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9156",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9160",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9161",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8694",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9164",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9165",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9167",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9168",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2581",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_917",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9171",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9172",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9175",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9176",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9178",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9179",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3864",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9184",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9185",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9186",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9187",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_919",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9190",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9191",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9192",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9193",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9195",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9196",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9197",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_92",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9202",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9204",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9206",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9208",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9209",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_921",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9210",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9211",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9213",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_3882",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9217",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9218",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_922",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9220",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9221",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9222",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9223",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9224",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9225",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9226",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9227",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9229",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9230",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9231",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9233",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9235",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9236",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9238",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_924",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9240",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5701",
      "ProvinceId": "BR_PI",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9243",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9245",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9246",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8155",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9248",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9249",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9250",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9252",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9253",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9255",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9256",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9257",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9258",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_926",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9262",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8707",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9268",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9271",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9274",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9276",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9277",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7277",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9286",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9287",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9288",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9291",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9293",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9294",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9298",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9299",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_930",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9301",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9309",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_931",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9310",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9313",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9314",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9315",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9316",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9318",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9322",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9323",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9324",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9325",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9326",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9327",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9328",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_933",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9330",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9331",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9332",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9333",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9335",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9337",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9669",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9340",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9342",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9343",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9344",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9347",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9349",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9353",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9356",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9357",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9358",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9359",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9360",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9361",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9362",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9364",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9365",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9367",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9368",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_937",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9372",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9373",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9377",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9378",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9379",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9382",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9384",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9386",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9388",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_939",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9390",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9392",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9393",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9394",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9395",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9397",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9398",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9399",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_94",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9403",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9406",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9407",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9408",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9409",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9410",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9411",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9412",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9414",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9418",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_942",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2333",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9421",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9423",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9424",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9428",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9429",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9430",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9431",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9677",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9433",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6704",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9438",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9439",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7279",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9442",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9443",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9446",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9448",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9452",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9454",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9455",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9456",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9457",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9458",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_946",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9462",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9463",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9465",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9466",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9468",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9469",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9471",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9472",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9473",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9474",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9476",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9478",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9479",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9481",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9484",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9486",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2596",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5448",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9490",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9491",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9492",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9494",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9495",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9497",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9499",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4807",
      "ProvinceId": "BR_PA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_950",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9502",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7084",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9507",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9508",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9509",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_951",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9511",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9512",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9513",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9514",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9515",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9516",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9517",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9519",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9521",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9522",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9524",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9526",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8182",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9528",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9529",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1045",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9535",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9537",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9538",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9539",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7288",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9540",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9541",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9543",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9544",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9546",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9547",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9548",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_955",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9550",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9552",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9553",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9554",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9555",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9556",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9557",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9558",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9559",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9563",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9564",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9565",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9567",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9568",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9569",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_957",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9570",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9573",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9574",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9575",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9577",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_958",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9580",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9581",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9582",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9583",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9584",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9585",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9588",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9590",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9591",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9592",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9593",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9595",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9596",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9597",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9598",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9599",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_96",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_960",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9601",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9602",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9604",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9606",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9607",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2601",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7291",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9612",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9614",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9615",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9616",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9618",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9619",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_962",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9621",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9624",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1055",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9626",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9628",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9629",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_963",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9630",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9634",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9635",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9639",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_964",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8213",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5112",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9647",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9648",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9649",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9652",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9654",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9655",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9657",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9658",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9661",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9663",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9665",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9667",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8214",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9670",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9706",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9674",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7294",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8728",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9680",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9681",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9682",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9683",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9685",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6746",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9687",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9688",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_969",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9690",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9698",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_970",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9702",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9703",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9705",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8223",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9708",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9709",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_971",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9710",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9712",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9714",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9715",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1068",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9718",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9719",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9720",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9721",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9722",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9723",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9724",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9725",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9728",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5120",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4008",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9735",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9736",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9738",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9739",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_974",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9740",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9741",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9743",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9746",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_975",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9750",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9752",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6747",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9755",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9757",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9758",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9759",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9761",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9762",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9763",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9767",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9769",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4009",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9772",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9773",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9775",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9717",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_978",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9784",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9785",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9786",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9788",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9790",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9791",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9792",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9793",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9794",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5121",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9797",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9798",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9799",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_98",
      "ProvinceId": "BR_AL",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_980",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9802",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9803",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9804",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8231",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9807",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9808",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9809",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_981",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9810",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9811",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9812",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9813",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9814",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9816",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9817",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9818",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1079",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9729",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9821",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9822",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9823",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1082",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9825",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9827",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9828",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9829",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9831",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5475",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9833",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9834",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9837",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9838",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9839",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9840",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9842",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9844",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9846",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9847",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9848",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9849",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_985",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9850",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9851",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6761",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9732",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9855",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9857",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9858",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9859",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9860",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9861",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9862",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9865",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9866",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9867",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9868",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9869",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9870",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9872",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9873",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9875",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9876",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9877",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9878",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9879",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9880",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9881",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9883",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9884",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9886",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9887",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9888",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2349",
      "ProvinceId": "BR_GO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5482",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9893",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9894",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9895",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9897",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9898",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5124",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9900",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9901",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9902",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9903",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5483",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9906",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9908",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_991",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9910",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9912",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9913",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9914",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9915",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9916",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9919",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9921",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9922",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8258",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9925",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9926",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4041",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9928",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9929",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_993",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9930",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9931",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9932",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9933",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9934",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9935",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9936",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9937",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9938",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9939",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9753",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9940",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9941",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9942",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9943",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9944",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9945",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9946",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9947",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9949",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6790",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9950",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9954",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9955",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9956",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9958",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_996",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9960",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9961",
      "ProvinceId": "BR_TO",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_997",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8745",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_999",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7110",
      "ProvinceId": "BR_RJ",
      "CountryCode": "BR"
  },
  {
      "CityCode": "B02",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8752",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9771",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4063",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8753",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_5128",
      "ProvinceId": "BR_PB",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7305",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_1113",
      "ProvinceId": "BR_BA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_7307",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_8289",
      "ProvinceId": "BR_RS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_9777",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2038",
      "ProvinceId": "BR_ES",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_2615",
      "ProvinceId": "BR_MA",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4099",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_6834",
      "ProvinceId": "BR_PR",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_10145",
      "ProvinceId": "BR_SP",
      "CountryCode": "BR"
  },
  {
      "CityCode": "M05",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "AYG",
      "ProvinceId": "CO16",
      "CountryCode": "CO"
  },
  {
      "CityCode": "AYI",
      "ProvinceId": "CO20",
      "CountryCode": "CO"
  },
  {
      "CityCode": "AZT",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "BAC",
      "ProvinceId": "CO19",
      "CountryCode": "CO"
  },
  {
      "CityCode": "BHF",
      "ProvinceId": "CO11",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CCO",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CIM",
      "ProvinceId": "CO26",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CJD",
      "ProvinceId": "CO19",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CPL",
      "ProvinceId": "CO28",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CQT",
      "ProvinceId": "CO19",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CSR",
      "ProvinceId": "CO31",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CUI",
      "ProvinceId": "CO20",
      "CountryCode": "CO"
  },
  {
      "CityCode": "CUO",
      "ProvinceId": "CO30",
      "CountryCode": "CO"
  },
  {
      "CityCode": "DZI",
      "ProvinceId": "CO10",
      "CountryCode": "CO"
  },
  {
      "CityCode": "ECO",
      "ProvinceId": "CO01",
      "CountryCode": "CO"
  },
  {
      "CityCode": "ECR",
      "ProvinceId": "CO20",
      "CountryCode": "CO"
  },
  {
      "CityCode": "ELB",
      "ProvinceId": "CO38",
      "CountryCode": "CO"
  },
  {
      "CityCode": "ELJ",
      "ProvinceId": "CO19",
      "CountryCode": "CO"
  },
  {
      "CityCode": "EUO",
      "ProvinceId": "CO33",
      "CountryCode": "CO"
  },
  {
      "CityCode": "FDA",
      "ProvinceId": "CO38",
      "CountryCode": "CO"
  },
  {
      "CityCode": "GCA",
      "ProvinceId": "CO36",
      "CountryCode": "CO"
  },
  {
      "CityCode": "GGL",
      "ProvinceId": "CO11",
      "CountryCode": "CO"
  },
  {
      "CityCode": "GMC",
      "ProvinceId": "CO31",
      "CountryCode": "CO"
  },
  {
      "CityCode": "GRA",
      "ProvinceId": "CO10",
      "CountryCode": "CO"
  },
  {
      "CityCode": "HRR",
      "ProvinceId": "CO28",
      "CountryCode": "CO"
  },
  {
      "CityCode": "HTZ",
      "ProvinceId": "CO32",
      "CountryCode": "CO"
  },
  {
      "CityCode": "ISD",
      "ProvinceId": "CO20",
      "CountryCode": "CO"
  },
  {
      "CityCode": "IVO",
      "ProvinceId": "CO38",
      "CountryCode": "CO"
  },
  {
      "CityCode": "LAT",
      "ProvinceId": "CO19",
      "CountryCode": "CO"
  },
  {
      "CityCode": "LGT",
      "ProvinceId": "CO35",
      "CountryCode": "CO"
  },
  {
      "CityCode": "LGZ",
      "ProvinceId": "CO22",
      "CountryCode": "CO"
  },
  {
      "CityCode": "LMX",
      "ProvinceId": "CO09",
      "CountryCode": "CO"
  },
  {
      "CityCode": "LPD",
      "ProvinceId": "CO01",
      "CountryCode": "CO"
  },
  {
      "CityCode": "LPE",
      "ProvinceId": "CO31",
      "CountryCode": "CO"
  },
  {
      "CityCode": "MFB",
      "ProvinceId": "CO01",
      "CountryCode": "CO"
  },
  {
      "CityCode": "BR_10163",
      "ProvinceId": "BR_MG",
      "CountryCode": "BR"
  },
  {
      "CityCode": "M08",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "ELF",
      "ProvinceId": null,
      "CountryCode": "GR"
  },
  {
      "CityCode": "GPL",
      "ProvinceId": null,
      "CountryCode": "JM"
  },
  {
      "CityCode": "PAC",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "A14",
      "ProvinceId": null,
      "CountryCode": "PE"
  },
  {
      "CityCode": "PUX",
      "ProvinceId": null,
      "CountryCode": "CL"
  },
  {
      "CityCode": "A04",
      "ProvinceId": "BR_SC",
      "CountryCode": "BR"
  },
  {
      "CityCode": "BR_4132",
      "ProvinceId": "BR_MS",
      "CountryCode": "BR"
  },
  {
      "CityCode": "TCD",
      "ProvinceId": "CO37",
      "CountryCode": "CO"
  },
  {
      "CityCode": "TDA",
      "ProvinceId": "CO32",
      "CountryCode": "CO"
  },
  {
      "CityCode": "TIB",
      "ProvinceId": "CO21",
      "CountryCode": "CO"
  },
  {
      "CityCode": "TTM",
      "ProvinceId": "CO32",
      "CountryCode": "CO"
  },
  {
      "CityCode": "ULS",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "UNC",
      "ProvinceId": "CO11",
      "CountryCode": "CO"
  },
  {
      "CityCode": "URI",
      "ProvinceId": "CO19",
      "CountryCode": "CO"
  },
  {
      "CityCode": "URR",
      "ProvinceId": "CO02",
      "CountryCode": "CO"
  },
  {
      "CityCode": "VAB",
      "ProvinceId": "CO30",
      "CountryCode": "CO"
  },
  {
      "CityCode": "WWN",
      "ProvinceId": "CO35",
      "CountryCode": "CO"
  },
  {
      "CityCode": "TUY",
      "ProvinceId": null,
      "CountryCode": "MX"
  },
  {
      "CityCode": "PO1",
      "ProvinceId": "BR_PE",
      "CountryCode": "BR"
  },
  {
      "CityCode": "POT",
      "ProvinceId": null,
      "CountryCode": "JM"
  },
  {
      "CityCode": "PP1",
      "ProvinceId": "BR_RN",
      "CountryCode": "BR"
  },
  {
      "CityCode": "RD1",
      "ProvinceId": null,
      "CountryCode": "DO"
  },
  {
      "CityCode": "ISR",
      "ProvinceId": null,
      "CountryCode": "CO"
  },
  {
      "CityCode": "BUE001",
      "ProvinceId": "BUE01",
      "CountryCode": "AR"
  },
  {
      "CityCode": "CZU",
      "ProvinceId": null,
      "CountryCode": "CO"
  }
];
